const getMap = () =>
  window.dotsMapConfig.map || [
    {
      id: "afghanistan",
      dots: [
        {
          id: "3",
          x: 0.6610171197945679,
          y: 0.4576315202142314,
        },
        {
          id: "1",
          x: 0.6694941051296439,
          y: 0.4406819962736919,
        },
        {
          id: "6",
          x: 0.6610171197945679,
          y: 0.42372811521605125,
        },
        {
          id: "4",
          x: 0.6525445338690236,
          y: 0.4406819962736919,
        },
        {
          id: "2",
          x: 0.6610171197945679,
          y: 0.4406819962736919,
        },
        {
          id: "0",
          x: 0.6694941051296439,
          y: 0.42372811521605125,
        },
        {
          id: "5",
          x: 0.6525445338690236,
          y: 0.4576315202142314,
        },
      ],
      region: "middle_east",
    },
    {
      id: "albania",
      dots: [
        {
          id: "0",
          x: 0.5339011730179475,
          y: 0.4067785066712962,
        },
      ],
      region: "europe",
    },
    {
      id: "algeria",
      dots: [
        {
          id: "8",
          x: 0.491524114517307,
          y: 0.5254297851848204,
        },
        {
          id: "1",
          x: 0.5000021151007363,
          y: 0.4915284529899215,
        },
        {
          id: "17",
          x: 0.47457458555870136,
          y: 0.5084715047079709,
        },
        {
          id: "19",
          x: 0.4661030994855398,
          y: 0.4915284529899215,
        },
        {
          id: "5",
          x: 0.491524114517307,
          y: 0.4745745719322808,
        },
        {
          id: "11",
          x: 0.4830526284441455,
          y: 0.4745745719322808,
        },
        {
          id: "10",
          x: 0.4830526284441455,
          y: 0.4576315202142314,
        },
        {
          id: "4",
          x: 0.491524114517307,
          y: 0.4576315202142314,
        },
        {
          id: "16",
          x: 0.47457458555870136,
          y: 0.4915284529899215,
        },
        {
          id: "2",
          x: 0.5000021151007363,
          y: 0.5084715047079709,
        },
        {
          id: "15",
          x: 0.47457458555870136,
          y: 0.4745745719322808,
        },
        {
          id: "9",
          x: 0.4830526284441455,
          y: 0.4406819962736919,
        },
        {
          id: "18",
          x: 0.4661030994855398,
          y: 0.4745745719322808,
        },
        {
          id: "20",
          x: 0.45762505660009567,
          y: 0.4745745719322808,
        },
        {
          id: "0",
          x: 0.5000021151007363,
          y: 0.4745745719322808,
        },
        {
          id: "7",
          x: 0.491524114517307,
          y: 0.5084715047079709,
        },
        {
          id: "3",
          x: 0.491524114517307,
          y: 0.4406819962736919,
        },
        {
          id: "12",
          x: 0.4830526284441455,
          y: 0.4915284529899215,
        },
        {
          id: "14",
          x: 0.4830526284441455,
          y: 0.5254297851848204,
          color: "#A566FF",
        },
        {
          id: "6",
          x: 0.491524114517307,
          y: 0.4915284529899215,
        },
        {
          id: "13",
          x: 0.4830526284441455,
          y: 0.5084715047079709,
        },
      ],
      region: "africa",
    },
    {
      id: "angola",
      dots: [
        {
          id: "14",
          x: 0.5084747433282955,
          y: 0.7457674626062059,
        },
        {
          id: "8",
          x: 0.5254253298372692,
          y: 0.7457674626062059,
        },
        {
          id: "7",
          x: 0.5254253298372692,
          y: 0.7288136238506728,
        },
        {
          id: "10",
          x: 0.5169516440593419,
          y: 0.7118684147251269,
        },
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.7118684147251269,
        },
        {
          id: "11",
          x: 0.5169516440593419,
          y: 0.7288136238506728,
        },
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.6949144913653784,
        },
        {
          id: "4",
          x: 0.5339011730179475,
          y: 0.7457674626062059,
        },
        {
          id: "13",
          x: 0.5084747433282955,
          y: 0.7288136238506728,
        },
        {
          id: "3",
          x: 0.5339011730179475,
          y: 0.7288136238506728,
        },
        {
          id: "2",
          x: 0.5339011730179475,
          y: 0.7118684147251269,
        },
        {
          id: "5",
          x: 0.5254253298372692,
          y: 0.6949144913653784,
        },
        {
          id: "6",
          x: 0.5254253298372692,
          y: 0.7118684147251269,
        },
        {
          id: "9",
          x: 0.5169516440593419,
          y: 0.6949144913653784,
          color: "#DB4437",
        },
        {
          id: "12",
          x: 0.5169516440593419,
          y: 0.7457674626062059,
        },
      ],
      region: "africa",
    },
    {
      id: "argentina",
      dots: [
        {
          id: "26",
          x: 0.27966166510205615,
          y: 0.9152543261942604,
        },
        {
          id: "15",
          x: 0.2881364507323663,
          y: 0.847460545247096,
        },
        {
          id: "20",
          x: 0.2881364507323663,
          y: 1,
        },
        {
          id: "16",
          x: 0.2881364507323663,
          y: 0.8644099845834199,
        },
        {
          id: "35",
          x: 0.27118687947174597,
          y: 0.9661094971446923,
          radius: 2.3260323675286783,
        },
        {
          id: "6",
          x: 0.296611151758647,
          y: 0.8305110213065564,
        },
        {
          id: "8",
          x: 0.296611151758647,
          y: 0.8644099845834199,
        },
        {
          id: "27",
          x: 0.27966166510205615,
          y: 0.9322082495540088,
        },
        {
          id: "18",
          x: 0.2881364507323663,
          y: 0.8983113167783189,
        },
        {
          id: "22",
          x: 0.27966166510205615,
          y: 0.847460545247096,
        },
        {
          id: "2",
          x: 0.30508483753657434,
          y: 0.8644099845834199,
        },
        {
          id: "9",
          x: 0.296611151758647,
          y: 0.8813573934185704,
        },
        {
          id: "34",
          x: 0.27118687947174597,
          y: 0.9491556583891595,
        },
        {
          id: "12",
          x: 0.2881364507323663,
          y: 0.7966118042170462,
        },
        {
          id: "1",
          x: 0.30508483753657434,
          y: 0.8305110213065564,
        },
        {
          id: "24",
          x: 0.27966166510205615,
          y: 0.8813573934185704,
        },
        {
          id: "5",
          x: 0.296611151758647,
          y: 0.8135592130521969,
        },
        {
          id: "4",
          x: 0.296611151758647,
          y: 0.7966118042170462,
        },
        {
          id: "28",
          x: 0.27966166510205615,
          y: 0.9491556583891595,
          radius: 2.475027821058367,
        },
        {
          id: "11",
          x: 0.2881364507323663,
          y: 0.7796665950915004,
        },
        {
          id: "13",
          x: 0.2881364507323663,
          y: 0.8135592130521969,
        },
        {
          id: "10",
          x: 0.296611151758647,
          y: 0.8983113167783189,
        },
        {
          id: "23",
          x: 0.27966166510205615,
          y: 0.8644099845834199,
        },
        {
          id: "33",
          x: 0.27118687947174597,
          y: 0.9322082495540088,
          radius: 2.8748838013728535,
        },
        {
          id: "7",
          x: 0.296611151758647,
          y: 0.847460545247096,
        },
        {
          id: "14",
          x: 0.2881364507323663,
          y: 0.8305110213065564,
        },
        {
          id: "29",
          x: 0.27966166510205615,
          y: 0.9830547062702384,
          color: "#2EB67D",
        },
        {
          id: "3",
          x: 0.30508483753657434,
          y: 0.8813573934185704,
          color: "#F4B400",
        },
        {
          id: "0",
          x: 0.30508483753657434,
          y: 0.8135592130521969,
        },
        {
          id: "21",
          x: 0.27966166510205615,
          y: 0.8305110213065564,
        },
        {
          id: "25",
          x: 0.27966166510205615,
          y: 0.8983113167783189,
        },
        {
          id: "17",
          x: 0.2881364507323663,
          y: 0.8813573934185704,
        },
        {
          id: "36",
          x: 0.27118687947174597,
          y: 0.9830547062702384,
        },
        {
          id: "32",
          x: 0.27118687947174597,
          y: 0.9152543261942604,
        },
        {
          id: "31",
          x: 0.27118687947174597,
          y: 0.8983113167783189,
        },
        {
          id: "19",
          x: 0.2881364507323663,
          y: 0.9152543261942604,
        },
        {
          id: "30",
          x: 0.27966166510205615,
          y: 1,
        },
      ],
      region: "south_america",
    },
    {
      id: "armenia",
      dots: [
        {
          id: "0",
          x: 0.6016949740468679,
          y: 0.4067785066712962,
        },
      ],
      region: "middle_east",
    },
    {
      id: "aruba",
      dots: [
        {
          id: "0",
          x: 0.27118687947174597,
          y: 0.5762740844935532,
        },
      ],
      region: "south_america",
    },
    {
      id: "australia",
      region: "australia",
      dots: [
        {
          id: "72",
          x: 0.830508094575122,
          y: 0.8305110213065564,
        },
        {
          id: "43",
          x: 0.8559344819627593,
          y: 0.7288136238506728,
        },
        {
          id: "31",
          x: 0.8728839686193501,
          y: 0.7966118042170462,
        },
        {
          id: "6",
          x: 0.8983061258055149,
          y: 0.8305110213065564,
        },
        {
          id: "14",
          x: 0.8898334552759412,
          y: 0.847460545247096,
        },
        {
          id: "15",
          x: 0.8898334552759412,
          y: 0.8644099845834199,
        },
        {
          id: "62",
          x: 0.8389838954537855,
          y: 0.7796665950915004,
        },
        {
          id: "85",
          x: 0.8135585233145016,
          y: 0.8305110213065564,
          color: "#DB4437",
        },
        {
          id: "87",
          x: 0.8050848375365743,
          y: 0.7796665950915004,
        },
        {
          id: "45",
          x: 0.8559344819627593,
          y: 0.7627126717317518,
        },
        {
          id: "22",
          x: 0.881356639148924,
          y: 0.7966118042170462,
        },
        {
          id: "51",
          x: 0.8474575812317129,
          y: 0.7118684147251269,
        },
        {
          id: "49",
          x: 0.8559344819627593,
          y: 0.8305110213065564,
        },
        {
          id: "74",
          x: 0.8220344087971947,
          y: 0.7627126717317518,
        },
        {
          id: "0",
          x: 0.9067787117310594,
          y: 0.7966118042170462,
          radius: 2.3336987389562234,
        },
        {
          id: "13",
          x: 0.8898334552759412,
          y: 0.8305110213065564,
        },
        {
          id: "91",
          x: 0.8050848375365743,
          y: 0.847460545247096,
          radius: 2.7405178260622503,
        },
        {
          id: "1",
          x: 0.9067787117310594,
          y: 0.8135592130521969,
        },
        {
          id: "88",
          x: 0.8050848375365743,
          y: 0.7966118042170462,
        },
        {
          id: "57",
          x: 0.8474575812317129,
          y: 0.8135592130521969,
        },
        {
          id: "19",
          x: 0.881356639148924,
          y: 0.7457674626062059,
        },
        {
          id: "52",
          x: 0.8474575812317129,
          y: 0.7288136238506728,
        },
        {
          id: "7",
          x: 0.8983061258055149,
          y: 0.8644099845834199,
        },
        {
          id: "90",
          x: 0.8050848375365743,
          y: 0.8305110213065564,
        },
        {
          id: "79",
          x: 0.8220344087971947,
          y: 0.847460545247096,
        },
        {
          id: "76",
          x: 0.8220344087971947,
          y: 0.7966118042170462,
        },
        {
          id: "11",
          x: 0.8898334552759412,
          y: 0.7966118042170462,
        },
        {
          id: "56",
          x: 0.8474575812317129,
          y: 0.7966118042170462,
        },
        {
          id: "18",
          x: 0.881356639148924,
          y: 0.7288136238506728,
        },
        {
          id: "5",
          x: 0.8983061258055149,
          y: 0.8135592130521969,
        },
        {
          id: "93",
          x: 0.7966122516110299,
          y: 0.7966118042170462,
        },
        {
          id: "40",
          x: 0.8644071524923332,
          y: 0.8135592130521969,
        },
        {
          id: "71",
          x: 0.830508094575122,
          y: 0.8135592130521969,
        },
        {
          id: "17",
          x: 0.8898334552759412,
          y: 0.8983113167783189,
          radius: 2.89956957795594,
        },
        {
          id: "24",
          x: 0.881356639148924,
          y: 0.8305110213065564,
        },
        {
          id: "10",
          x: 0.8898334552759412,
          y: 0.7796665950915004,
        },
        {
          id: "2",
          x: 0.9067787117310594,
          y: 0.8305110213065564,
        },
        {
          id: "65",
          x: 0.8389838954537855,
          y: 0.8305110213065564,
        },
        {
          id: "28",
          x: 0.8728839686193501,
          y: 0.7457674626062059,
        },
        {
          id: "27",
          x: 0.881356639148924,
          y: 0.8813573934185704,
        },
        {
          id: "59",
          x: 0.8389838954537855,
          y: 0.7288136238506728,
        },
        {
          id: "42",
          x: 0.8644071524923332,
          y: 0.847460545247096,
        },
        {
          id: "38",
          x: 0.8644071524923332,
          y: 0.7796665950915004,
        },
        {
          id: "86",
          x: 0.8135585233145016,
          y: 0.847460545247096,
        },
        {
          id: "41",
          x: 0.8644071524923332,
          y: 0.8305110213065564,
        },
        {
          id: "36",
          x: 0.8644071524923332,
          y: 0.7457674626062059,
        },
        {
          id: "25",
          x: 0.881356639148924,
          y: 0.847460545247096,
        },
        {
          id: "68",
          x: 0.830508094575122,
          y: 0.7627126717317518,
        },
        {
          id: "55",
          x: 0.8474575812317129,
          y: 0.7796665950915004,
        },
        {
          id: "73",
          x: 0.8220344087971947,
          y: 0.7457674626062059,
        },
        {
          id: "92",
          x: 0.7966122516110299,
          y: 0.7796665950915004,
          color: "#A566FF",
        },
        {
          id: "50",
          x: 0.8559344819627593,
          y: 0.847460545247096,
        },
        {
          id: "82",
          x: 0.8135585233145016,
          y: 0.7796665950915004,
        },
        {
          id: "20",
          x: 0.881356639148924,
          y: 0.7627126717317518,
        },
        {
          id: "75",
          x: 0.8220344087971947,
          y: 0.7796665950915004,
        },
        {
          id: "80",
          x: 0.8135585233145016,
          y: 0.7457674626062059,
        },
        {
          id: "9",
          x: 0.8898334552759412,
          y: 0.7622712915391893,
        },
        {
          id: "46",
          x: 0.8559344819627593,
          y: 0.7796665950915004,
        },
        {
          id: "89",
          x: 0.8050848375365743,
          y: 0.8135592130521969,
        },
        {
          id: "32",
          x: 0.8728839686193501,
          y: 0.8135592130521969,
        },
        {
          id: "4",
          x: 0.8983061258055149,
          y: 0.7966118042170462,
        },
        {
          id: "44",
          x: 0.8559344819627593,
          y: 0.7457674626062059,
        },
        {
          id: "30",
          x: 0.8728839686193501,
          y: 0.7796665950915004,
        },
        {
          id: "34",
          x: 0.8728839686193501,
          y: 0.847460545247096,
        },
        {
          id: "16",
          x: 0.8898334552759412,
          y: 0.8813573934185704,
        },
        {
          id: "70",
          x: 0.830508094575122,
          y: 0.7966118042170462,
        },
        {
          id: "12",
          x: 0.8898334552759412,
          y: 0.8135592130521969,
        },
        {
          id: "33",
          x: 0.8728839686193501,
          y: 0.8305110213065564,
        },
        {
          id: "26",
          x: 0.881356639148924,
          y: 0.8644099845834199,
        },
        {
          id: "37",
          x: 0.8644071524923332,
          y: 0.7627126717317518,
        },
        {
          id: "53",
          x: 0.8474575812317129,
          y: 0.7457674626062059,
        },
        {
          id: "63",
          x: 0.8389838954537855,
          y: 0.7966118042170462,
        },
        {
          id: "83",
          x: 0.8135585233145016,
          y: 0.7966118042170462,
        },
        {
          id: "64",
          x: 0.8389838954537855,
          y: 0.8135592130521969,
        },
        {
          id: "60",
          x: 0.8389838954537855,
          y: 0.7457674626062059,
        },
        {
          id: "21",
          x: 0.881356639148924,
          y: 0.7796665950915004,
        },
        {
          id: "29",
          x: 0.8728839686193501,
          y: 0.7627126717317518,
        },
        {
          id: "23",
          x: 0.881356639148924,
          y: 0.8135592130521969,
          radius: 2.779469897942854,
        },
        {
          id: "77",
          x: 0.8220344087971947,
          y: 0.8135592130521969,
        },
        {
          id: "58",
          x: 0.8474575812317129,
          y: 0.8305110213065564,
        },
        {
          id: "48",
          x: 0.8559344819627593,
          y: 0.8135592130521969,
        },
        {
          id: "3",
          x: 0.8983061258055149,
          y: 0.7796665950915004,
        },
        {
          id: "78",
          x: 0.8220344087971947,
          y: 0.8305110213065564,
        },
        {
          id: "67",
          x: 0.830508094575122,
          y: 0.7457674626062059,
        },
        {
          id: "81",
          x: 0.8135585233145016,
          y: 0.7627126717317518,
        },
        {
          id: "47",
          x: 0.8559344819627593,
          y: 0.7966118042170462,
        },
        {
          id: "8",
          x: 0.8898334552759412,
          y: 0.7457674626062059,
        },
        {
          id: "66",
          x: 0.830508094575122,
          y: 0.7288136238506728,
        },
        {
          id: "61",
          x: 0.8389838954537855,
          y: 0.7627126717317518,
        },
        {
          id: "84",
          x: 0.8135585233145016,
          y: 0.8135592130521969,
        },
        {
          id: "39",
          x: 0.8644071524923332,
          y: 0.7966118042170462,
        },
        {
          id: "69",
          x: 0.830508094575122,
          y: 0.7796665950915004,
        },
        {
          id: "35",
          x: 0.8728839686193501,
          y: 0.8644099845834199,
        },
        {
          id: "54",
          x: 0.8474575812317129,
          y: 0.7627126717317518,
        },
        {
          id: "94",
          x: 0.7966122516110299,
          y: 0.8135592130521969,
          radius: 2.4096286567457117,
        },
      ],
    },
    {
      id: "austria",
      dots: [
        {
          id: "1",
          x: 0.5084747433282955,
          y: 0.35592980794335444,
        },
        {
          id: "0",
          x: 0.5169516440593419,
          y: 0.35592980794335444,
        },
      ],
      region: "europe",
    },
    {
      id: "azerbaijan",
      dots: [
        {
          id: "0",
          x: 0.610171790173885,
          y: 0.4067785066712962,
        },
      ],
      region: "middle_east",
    },
    {
      id: "bahrain",
      dots: [
        {
          id: "0",
          x: 0.610171790173885,
          y: 0.4915284529899215,
        },
      ],
      region: "middle_east",
    },
    {
      id: "bangladesh",
      dots: [
        {
          id: "0",
          x: 0.7372878215545348,
          y: 0.5254297851848204,
        },
        {
          id: "1",
          x: 0.7288152356289904,
          y: 0.5084715047079709,
        },
        {
          id: "2",
          x: 0.7288152356289904,
          y: 0.5254297851848204,
        },
      ],
      region: "asia",
    },
    {
      id: "barbados",
      dots: [
        {
          id: "0",
          x: 0.296611151758647,
          y: 0.5762740844935532,
          color: "#2EB67D",
        },
      ],
      region: "south_america",
    },
    {
      id: "belarus",
      dots: [
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.32203291746977214,
        },
        {
          id: "1",
          x: 0.5593233302041123,
          y: 0.30508550863462164,
        },
        {
          id: "2",
          x: 0.5508506596745385,
          y: 0.30508550863462164,
        },
        {
          id: "3",
          x: 0.5508506596745385,
          y: 0.32203291746977214,
        },
      ],
      region: "europe",
    },
    {
      id: "belgium",
      dots: [
        {
          id: "0",
          x: 0.4830526284441455,
          y: 0.3389845988178084,
        },
      ],
      region: "europe",
    },
    {
      id: "belize",
      dots: [
        {
          id: "0",
          x: 0.2203404923006949,
          y: 0.5423706371932654,
        },
      ],
    },
    {
      id: "benin",
      dots: [
        {
          id: "1",
          x: 0.4830526284441455,
          y: 0.6101688175596388,
        },
        {
          id: "0",
          x: 0.4830526284441455,
          y: 0.5932258081436972,
        },
      ],
      region: "africa",
    },
    {
      id: "bhutan",
      dots: [
        {
          id: "0",
          x: 0.7288152356289904,
          y: 0.4915284529899215,
        },
      ],
      region: "asia",
    },
    {
      id: "bolivia",
      dots: [
        {
          id: "4",
          x: 0.2881364507323663,
          y: 0.7288136238506728,
          color: "#F4B400",
        },
        {
          id: "2",
          x: 0.296611151758647,
          y: 0.7457674626062059,
        },
        {
          id: "6",
          x: 0.2881364507323663,
          y: 0.7627126717317518,
        },
        {
          id: "1",
          x: 0.296611151758647,
          y: 0.7288136238506728,
        },
        {
          id: "0",
          x: 0.30508483753657434,
          y: 0.7457674626062059,
        },
        {
          id: "7",
          x: 0.27966166510205615,
          y: 0.7118684147251269,
        },
        {
          id: "5",
          x: 0.2881364507323663,
          y: 0.7457674626062059,
        },
        {
          id: "9",
          x: 0.27966166510205615,
          y: 0.7457674626062059,
        },
        {
          id: "8",
          x: 0.27966166510205615,
          y: 0.7288136238506728,
        },
        {
          id: "3",
          x: 0.296611151758647,
          y: 0.7627126717317518,
        },
      ],
      region: "south_america",
    },
    {
      id: "bosnia",
      dots: [
        {
          id: "0",
          x: 0.5254253298372692,
          y: 0.38983109783614567,
        },
      ],
      region: "europe",
    },
    {
      id: "botswana",
      dots: [
        {
          id: "4",
          x: 0.5339011730179475,
          y: 0.7627126717317518,
        },
        {
          id: "5",
          x: 0.5339011730179475,
          y: 0.7796665950915004,
        },
        {
          id: "6",
          x: 0.5339011730179475,
          y: 0.7966118042170462,
        },
        {
          id: "3",
          x: 0.5423748587958749,
          y: 0.7966118042170462,
        },
        {
          id: "2",
          x: 0.5423748587958749,
          y: 0.7796665950915004,
        },
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.7627126717317518,
        },
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.7796665950915004,
        },
      ],
      region: "africa",
    },
    {
      id: "brazil",
      dots: [
        {
          id: "87",
          x: 0.27966166510205615,
          y: 0.6949144913653784,
        },
        {
          id: "48",
          x: 0.32203432419316524,
          y: 0.7118684147251269,
        },
        {
          id: "50",
          x: 0.32203432419316524,
          y: 0.7457674626062059,
        },
        {
          id: "81",
          x: 0.2881364507323663,
          y: 0.6779692822398323,
        },
        {
          id: "71",
          x: 0.30508483753657434,
          y: 0.7118684147251269,
        },
        {
          id: "85",
          x: 0.27966166510205615,
          y: 0.661013243774695,
        },
        {
          id: "78",
          x: 0.296611151758647,
          y: 0.7118684147251269,
        },
        {
          id: "56",
          x: 0.32203432419316524,
          y: 0.847460545247096,
        },
        {
          id: "75",
          x: 0.296611151758647,
          y: 0.661013243774695,
        },
        {
          id: "66",
          x: 0.3135607230192674,
          y: 0.8305110213065564,
        },
        {
          id: "1",
          x: 0.3728818535186139,
          y: 0.6949144913653784,
        },
        {
          id: "22",
          x: 0.33898389545378554,
          y: 0.661013243774695,
        },
        {
          id: "64",
          x: 0.3135607230192674,
          y: 0.7627126717317518,
        },
        {
          id: "10",
          x: 0.355932366862023,
          y: 0.7288136238506728,
        },
        {
          id: "28",
          x: 0.33898389545378554,
          y: 0.7627126717317518,
        },
        {
          id: "38",
          x: 0.33050910982347537,
          y: 0.7457674626062059,
          radius: 2.9089879131858485,
        },
        {
          id: "29",
          x: 0.33898389545378554,
          y: 0.7796665950915004,
        },
        {
          id: "17",
          x: 0.34745758123171283,
          y: 0.7118684147251269,
        },
        {
          id: "3",
          x: 0.36440711019031846,
          y: 0.6949144913653784,
        },
        {
          id: "39",
          x: 0.33050910982347537,
          y: 0.7627126717317518,
        },
        {
          id: "25",
          x: 0.33898389545378554,
          y: 0.7118684147251269,
        },
        {
          id: "9",
          x: 0.355932366862023,
          y: 0.7118684147251269,
        },
        {
          id: "80",
          x: 0.2881364507323663,
          y: 0.661013243774695,
        },
        {
          id: "14",
          x: 0.34745758123171283,
          y: 0.661013243774695,
        },
        {
          id: "58",
          x: 0.3135607230192674,
          y: 0.661013243774695,
        },
        {
          id: "26",
          x: 0.33898389545378554,
          y: 0.7288136238506728,
        },
        {
          id: "5",
          x: 0.36440711019031846,
          y: 0.7288136238506728,
        },
        {
          id: "44",
          x: 0.32203432419316524,
          y: 0.6440722648599267,
        },
        {
          id: "74",
          x: 0.296611151758647,
          y: 0.6440722648599267,
        },
        {
          id: "0",
          x: 0.3728818535186139,
          y: 0.6779692822398323,
          radius: 2.5733558611356093,
        },
        {
          id: "27",
          x: 0.33898389545378554,
          y: 0.7457674626062059,
        },
        {
          id: "13",
          x: 0.355932366862023,
          y: 0.7796665950915004,
          radius: 2.6872058495604447,
        },
        {
          id: "20",
          x: 0.34745758123171283,
          y: 0.7627126717317518,
        },
        {
          id: "53",
          x: 0.32203432419316524,
          y: 0.7966118042170462,
        },
        {
          id: "82",
          x: 0.2881364507323663,
          y: 0.6949144913653784,
        },
        {
          id: "84",
          x: 0.27966166510205615,
          y: 0.6440722648599267,
        },
        {
          id: "61",
          x: 0.3135607230192674,
          y: 0.7118684147251269,
        },
        {
          id: "68",
          x: 0.30508483753657434,
          y: 0.661013243774695,
        },
        {
          id: "31",
          x: 0.33050910982347537,
          y: 0.6271270557343807,
        },
        {
          id: "54",
          x: 0.32203432419316524,
          y: 0.8135592130521969,
        },
        {
          id: "43",
          x: 0.33050910982347537,
          y: 0.8305110213065564,
        },
        {
          id: "49",
          x: 0.32203432419316524,
          y: 0.7288136238506728,
        },
        {
          id: "40",
          x: 0.33050910982347537,
          y: 0.7796665950915004,
        },
        {
          id: "15",
          x: 0.34745758123171283,
          y: 0.6779692822398323,
        },
        {
          id: "76",
          x: 0.296611151758647,
          y: 0.6779692822398323,
        },
        {
          id: "70",
          x: 0.30508483753657434,
          y: 0.6949144913653784,
        },
        {
          id: "21",
          x: 0.34745758123171283,
          y: 0.7796665950915004,
        },
        {
          id: "57",
          x: 0.3135607230192674,
          y: 0.6440722648599267,
        },
        {
          id: "7",
          x: 0.355932366862023,
          y: 0.6779692822398323,
        },
        {
          id: "69",
          x: 0.30508483753657434,
          y: 0.6779692822398323,
        },
        {
          id: "33",
          x: 0.33050910982347537,
          y: 0.661013243774695,
        },
        {
          id: "89",
          x: 0.27118687947174597,
          y: 0.6949144913653784,
        },
        {
          id: "23",
          x: 0.33898389545378554,
          y: 0.6779692822398323,
        },
        {
          id: "51",
          x: 0.32203432419316524,
          y: 0.7627126717317518,
        },
        {
          id: "62",
          x: 0.3135607230192674,
          y: 0.7288136238506728,
        },
        {
          id: "6",
          x: 0.36440711019031846,
          y: 0.7457674626062059,
          radius: 2.785609767047808,
        },
        {
          id: "65",
          x: 0.3135607230192674,
          y: 0.7796665950915004,
        },
        {
          id: "41",
          x: 0.33050910982347537,
          y: 0.7966118042170462,
        },
        {
          id: "8",
          x: 0.355932366862023,
          y: 0.6949144913653784,
          radius: 2.0237334516892487,
        },
        {
          id: "83",
          x: 0.2881364507323663,
          y: 0.7118684147251269,
        },
        {
          id: "67",
          x: 0.30508483753657434,
          y: 0.6440722648599267,
        },
        {
          id: "72",
          x: 0.30508483753657434,
          y: 0.7288136238506728,
        },
        {
          id: "32",
          x: 0.33050910982347537,
          y: 0.6440722648599267,
        },
        {
          id: "37",
          x: 0.33050910982347537,
          y: 0.7288136238506728,
        },
        {
          id: "77",
          x: 0.296611151758647,
          y: 0.6949144913653784,
        },
        {
          id: "16",
          x: 0.34745758123171283,
          y: 0.6949144913653784,
        },
        {
          id: "4",
          x: 0.36440711019031846,
          y: 0.7118684147251269,
        },
        {
          id: "60",
          x: 0.3135607230192674,
          y: 0.6949144913653784,
        },
        {
          id: "88",
          x: 0.27118687947174597,
          y: 0.6779692822398323,
        },
        {
          id: "30",
          x: 0.33898389545378554,
          y: 0.7966118042170462,
        },
        {
          id: "79",
          x: 0.2881364507323663,
          y: 0.6440722648599267,
        },
        {
          id: "47",
          x: 0.32203432419316524,
          y: 0.6949144913653784,
        },
        {
          id: "2",
          x: 0.36440711019031846,
          y: 0.6779692822398323,
        },
        {
          id: "42",
          x: 0.33050910982347537,
          y: 0.8135592130521969,
          color: "#DB4437",
        },
        {
          id: "12",
          x: 0.355932366862023,
          y: 0.7627126717317518,
        },
        {
          id: "46",
          x: 0.32203432419316524,
          y: 0.6779692822398323,
        },
        {
          id: "86",
          x: 0.27966166510205615,
          y: 0.6779692822398323,
        },
        {
          id: "19",
          x: 0.34745758123171283,
          y: 0.7457674626062059,
        },
        {
          id: "45",
          x: 0.32203432419316524,
          y: 0.661013243774695,
        },
        {
          id: "11",
          x: 0.355932366862023,
          y: 0.7457674626062059,
        },
        {
          id: "36",
          x: 0.33050910982347537,
          y: 0.7118684147251269,
        },
        {
          id: "63",
          x: 0.3135607230192674,
          y: 0.7457674626062059,
        },
        {
          id: "35",
          x: 0.33050910982347537,
          y: 0.6949144913653784,
        },
        {
          id: "59",
          x: 0.3135607230192674,
          y: 0.6779692822398323,
        },
        {
          id: "18",
          x: 0.34745758123171283,
          y: 0.7288136238506728,
        },
        {
          id: "52",
          x: 0.32203432419316524,
          y: 0.7796665950915004,
        },
        {
          id: "24",
          x: 0.33898389545378554,
          y: 0.6949144913653784,
        },
        {
          id: "34",
          x: 0.33050910982347537,
          y: 0.6779692822398323,
        },
        {
          id: "55",
          x: 0.32203432419316524,
          y: 0.8305110213065564,
          color: "#2EB67D",
        },
        {
          id: "73",
          x: 0.296611151758647,
          y: 0.6271270557343807,
        },
      ],
      region: "south_america",
    },
    {
      id: "brunei",
      dots: [
        {
          id: "0",
          x: 0.7966122516110299,
          y: 0.6271270557343807,
        },
      ],
      region: "asia",
    },
    {
      id: "bulgaria",
      dots: [
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.38983109783614567,
        },
      ],
      region: "europe",
    },
    {
      id: "burkina_faso",
      dots: [
        {
          id: "1",
          x: 0.4661030994855398,
          y: 0.5762740844935532,
        },
        {
          id: "0",
          x: 0.47457458555870136,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "burma",
      dots: [
        {
          id: "5",
          x: 0.7457648068896107,
          y: 0.5423706371932654,
        },
        {
          id: "4",
          x: 0.7457648068896107,
          y: 0.5254297851848204,
        },
        {
          id: "3",
          x: 0.7457648068896107,
          y: 0.5084715047079709,
        },
        {
          id: "2",
          x: 0.7542373082111256,
          y: 0.5254297851848204,
        },
        {
          id: "1",
          x: 0.7542373082111256,
          y: 0.5084715047079709,
        },
        {
          id: "0",
          x: 0.7542373082111256,
          y: 0.4915284529899215,
        },
      ],
      region: "asia",
    },
    {
      id: "burundi",
      dots: [
        {
          id: "0",
          x: 0.5593233302041123,
          y: 0.6779692822398323,
        },
      ],
      region: "africa",
    },
    {
      id: "cambodia",
      dots: [
        {
          id: "1",
          x: 0.7627142935462016,
          y: 0.5762740844935532,
        },
        {
          id: "0",
          x: 0.7711868794717459,
          y: 0.5762740844935532,
        },
      ],
      region: "asia",
    },
    {
      id: "cameroon",
      dots: [
        {
          id: "0",
          x: 0.5169516440593419,
          y: 0.5762740844935532,
        },
        {
          id: "2",
          x: 0.5169516440593419,
          y: 0.6271270557343807,
        },
        {
          id: "3",
          x: 0.5084747433282955,
          y: 0.6101688175596388,
        },
        {
          id: "5",
          x: 0.5000021151007363,
          y: 0.6271270557343807,
        },
        {
          id: "4",
          x: 0.5084747433282955,
          y: 0.6271270557343807,
        },
        {
          id: "1",
          x: 0.5169516440593419,
          y: 0.5932258081436972,
        },
      ],
      region: "africa",
    },
    {
      id: "canada",
      dots: [
        {
          id: "281",
          x: 0.23728892140691765,
          y: 0.30508550863462164,
        },
        {
          id: "244",
          x: 0.10169603159723609,
          y: 0.20338599607334912,
        },
        {
          id: "210",
          x: 0.13559508951444732,
          y: 0.2711863761493271,
        },
        {
          id: "219",
          x: 0.12711924633376898,
          y: 0.22033556231599638,
        },
        {
          id: "230",
          x: 0.11864448185446617,
          y: 0.2372851074075898,
        },
        {
          id: "189",
          x: 0.14406875414136724,
          y: 0.0847456315036318,
        },
        {
          id: "233",
          x: 0.11864448185446617,
          y: 0.28813378498447767,
        },
        {
          id: "214",
          x: 0.12711924633376898,
          y: 0.13559213052196908,
        },
        {
          id: "206",
          x: 0.13559508951444732,
          y: 0.20338599607334912,
        },
        {
          id: "227",
          x: 0.11864448185446617,
          y: 0.1864364509817558,
        },
        {
          id: "254",
          x: 0.09322128826894065,
          y: 0.25423465249918314,
        },
        {
          id: "205",
          x: 0.13559508951444732,
          y: 0.1864364509817558,
        },
        {
          id: "184",
          x: 0.1525445761710382,
          y: 0.22033556231599638,
        },
        {
          id: "222",
          x: 0.12711924633376898,
          y: 0.2711863761493271,
        },
        {
          id: "198",
          x: 0.14406875414136724,
          y: 0.25423465249918314,
        },
        {
          id: "256",
          x: 0.08474652378963783,
          y: 0.1864364509817558,
        },
        {
          id: "250",
          x: 0.09322128826894065,
          y: 0.1864364509817558,
        },
        {
          id: "258",
          x: 0.08474652378963783,
          y: 0.22033556231599638,
        },
        {
          id: "283",
          x: 0.22881523562899034,
          y: 0.30508550863462164,
        },
        {
          id: "262",
          x: 0.07627393786409344,
          y: 0.1864364509817558,
        },
        {
          id: "277",
          x: 0.2627121361434505,
          y: 0.30508550863462164,
        },
        {
          id: "279",
          x: 0.2542373928151551,
          y: 0.30508550863462164,
        },
        {
          id: "263",
          x: 0.07627393786409344,
          y: 0.20338599607334912,
          color: "#A566FF",
        },
        {
          id: "272",
          x: 0.2881364507323663,
          y: 0.32203291746977214,
        },
        {
          id: "274",
          x: 0.27966166510205615,
          y: 0.32203291746977214,
        },
        {
          id: "232",
          x: 0.11864448185446617,
          y: 0.2711863761493271,
        },
        {
          id: "201",
          x: 0.13559508951444732,
          y: 0.0847456315036318,
        },
        {
          id: "259",
          x: 0.08474652378963783,
          y: 0.2372851074075898,
        },
        {
          id: "290",
          x: 0.2033909633420893,
          y: 0.32203291746977214,
        },
        {
          id: "260",
          x: 0.08474652378963783,
          y: 0.25423465249918314,
        },
        {
          id: "289",
          x: 0.2033909633420893,
          y: 0.30508550863462164,
        },
        {
          id: "300",
          x: 0.1610182619489655,
          y: 0.32203291746977214,
        },
        {
          id: "238",
          x: 0.1101707960765389,
          y: 0.2372851074075898,
        },
        {
          id: "243",
          x: 0.10169603159723609,
          y: 0.1864364509817558,
        },
        {
          id: "221",
          x: 0.12711924633376898,
          y: 0.25423465249918314,
        },
        {
          id: "286",
          x: 0.2203404923006949,
          y: 0.32203291746977214,
        },
        {
          id: "298",
          x: 0.16949194772689277,
          y: 0.32203291746977214,
        },
        {
          id: "265",
          x: 0.07627393786409344,
          y: 0.2372851074075898,
        },
        {
          id: "268",
          x: 0.30508483753657434,
          y: 0.32203291746977214,
          color: "#A566FF",
        },
        {
          id: "172",
          x: 0.1610182619489655,
          y: 0.20338599607334912,
        },
        {
          id: "195",
          x: 0.14406875414136724,
          y: 0.20338599607334912,
        },
        {
          id: "115",
          x: 0.2033909633420893,
          y: 0.2372851074075898,
        },
        {
          id: "212",
          x: 0.12711924633376898,
          y: 0.10169299803667456,
        },
        {
          id: "19",
          x: 0.27118687947174597,
          y: 0.016947377108569712,
        },
        {
          id: "56",
          x: 0.24576476458759597,
          y: 0.11864256427932182,
          color: "#DB4437",
        },
        {
          id: "293",
          x: 0.1864414766854984,
          y: 0.30508550863462164,
        },
        {
          id: "0",
          x: 0.296611151758647,
          y: 0.016947377108569712,
        },
        {
          id: "292",
          x: 0.19491622001379386,
          y: 0.32203291746977214,
        },
        {
          id: "288",
          x: 0.2118657489723995,
          y: 0.32203291746977214,
        },
        {
          id: "245",
          x: 0.10169603159723609,
          y: 0.22033556231599638,
          radius: 2.357906510482046,
        },
        {
          id: "192",
          x: 0.14406875414136724,
          y: 0.15254167561356247,
        },
        {
          id: "174",
          x: 0.1610182619489655,
          y: 0.2372851074075898,
        },
        {
          id: "282",
          x: 0.23728892140691765,
          y: 0.32203291746977214,
        },
        {
          id: "12",
          x: 0.27966166510205615,
          y: 0.1694912418562097,
        },
        {
          id: "17",
          x: 0.27966166510205615,
          y: 0.2711863761493271,
        },
        {
          id: "278",
          x: 0.2627121361434505,
          y: 0.32203291746977214,
        },
        {
          id: "266",
          x: 0.3135607230192674,
          y: 0.32203291746977214,
        },
        {
          id: "99",
          x: 0.2118657489723995,
          y: 0.13559213052196908,
        },
        {
          id: "255",
          x: 0.09322128826894065,
          y: 0.2711863761493271,
        },
        {
          id: "29",
          x: 0.27118687947174597,
          y: 0.28813378498447767,
        },
        {
          id: "211",
          x: 0.13559508951444732,
          y: 0.28813378498447767,
        },
        {
          id: "264",
          x: 0.07627393786409344,
          y: 0.22033556231599638,
        },
        {
          id: "16",
          x: 0.27966166510205615,
          y: 0.2372851074075898,
        },
        {
          id: "129",
          x: 0.19491622001379386,
          y: 0.2711863761493271,
        },
        {
          id: "21",
          x: 0.27118687947174597,
          y: 0.05084649901833728,
        },
        {
          id: "133",
          x: 0.1864414766854984,
          y: 0.10169299803667456,
        },
        {
          id: "285",
          x: 0.2203404923006949,
          y: 0.30508550863462164,
        },
        {
          id: "177",
          x: 0.1610182619489655,
          y: 0.28813378498447767,
        },
        {
          id: "95",
          x: 0.2118657489723995,
          y: 0.03389693277569003,
          color: "#2EB67D",
        },
        {
          id: "321",
          x: 0.27118687947174597,
          y: 0.3389845988178084,
        },
        {
          id: "128",
          x: 0.19491622001379386,
          y: 0.25423465249918314,
        },
        {
          id: "1",
          x: 0.296611151758647,
          y: 0.20338599607334912,
        },
        {
          id: "139",
          x: 0.1864414766854984,
          y: 0.2372851074075898,
        },
        {
          id: "121",
          x: 0.19491622001379386,
          y: 0.13559213052196908,
        },
        {
          id: "146",
          x: 0.1779667122061956,
          y: 0.13559213052196908,
        },
        {
          id: "287",
          x: 0.2118657489723995,
          y: 0.30508550863462164,
        },
        {
          id: "168",
          x: 0.1610182619489655,
          y: 0.0847456315036318,
        },
        {
          id: "37",
          x: 0.2627121361434505,
          y: 0.25423465249918314,
        },
        {
          id: "234",
          x: 0.1101707960765389,
          y: 0.1694912418562097,
        },
        {
          id: "39",
          x: 0.2627121361434505,
          y: 0.28813378498447767,
        },
        {
          id: "220",
          x: 0.12711924633376898,
          y: 0.2372851074075898,
        },
        {
          id: "147",
          x: 0.1779667122061956,
          y: 0.15254167561356247,
        },
        {
          id: "134",
          x: 0.1864414766854984,
          y: 0.13559213052196908,
        },
        {
          id: "165",
          x: 0.16949194772689277,
          y: 0.2711863761493271,
        },
        {
          id: "224",
          x: 0.11864448185446617,
          y: 0.13559213052196908,
          color: "#A566FF",
        },
        {
          id: "261",
          x: 0.07627393786409344,
          y: 0.1694912418562097,
        },
        {
          id: "2",
          x: 0.296611151758647,
          y: 0.28813378498447767,
        },
        {
          id: "296",
          x: 0.1779667122061956,
          y: 0.32203291746977214,
        },
        {
          id: "225",
          x: 0.11864448185446617,
          y: 0.15254167561356247,
        },
        {
          id: "322",
          x: 0.27118687947174597,
          y: 0.35592980794335444,
        },
        {
          id: "269",
          x: 0.296611151758647,
          y: 0.30508550863462164,
          color: "#F4B400",
        },
        {
          id: "301",
          x: 0.1525445761710382,
          y: 0.30508550863462164,
        },
        {
          id: "173",
          x: 0.1610182619489655,
          y: 0.22033556231599638,
        },
        {
          id: "213",
          x: 0.12711924633376898,
          y: 0.11864256427932182,
        },
        {
          id: "297",
          x: 0.16949194772689277,
          y: 0.30508550863462164,
        },
        {
          id: "145",
          x: 0.1779667122061956,
          y: 0.10169299803667456,
        },
        {
          id: "124",
          x: 0.19491622001379386,
          y: 0.1864364509817558,
        },
        {
          id: "65",
          x: 0.23728892140691765,
          y: 0.11864256427932182,
        },
        {
          id: "276",
          x: 0.27118687947174597,
          y: 0.32203291746977214,
        },
        {
          id: "119",
          x: 0.19491622001379386,
          y: 0.06779388670243394,
        },
        {
          id: "46",
          x: 0.2542373928151551,
          y: 0.1864364509817558,
        },
        {
          id: "153",
          x: 0.1779667122061956,
          y: 0.25423465249918314,
        },
        {
          id: "62",
          x: 0.23728892140691765,
          y: 0.05084649901833728,
        },
        {
          id: "323",
          x: 0.2627121361434505,
          y: 0.3389845988178084,
        },
        {
          id: "150",
          x: 0.1779667122061956,
          y: 0.20338599607334912,
        },
        {
          id: "200",
          x: 0.14406875414136724,
          y: 0.28813378498447767,
        },
        {
          id: "31",
          x: 0.2627121361434505,
          y: 0.03389693277569003,
        },
        {
          id: "329",
          x: 0.24576476458759597,
          y: 0.35592980794335444,
        },
        {
          id: "89",
          x: 0.2203404923006949,
          y: 0.13559213052196908,
        },
        {
          id: "302",
          x: 0.1525445761710382,
          y: 0.32203291746977214,
        },
        {
          id: "240",
          x: 0.1101707960765389,
          y: 0.2711863761493271,
        },
        {
          id: "68",
          x: 0.23728892140691765,
          y: 0.1694912418562097,
        },
        {
          id: "10",
          x: 0.27966166510205615,
          y: 0.016947377108569712,
        },
        {
          id: "42",
          x: 0.2542373928151551,
          y: 0.05084649901833728,
        },
        {
          id: "242",
          x: 0.10169603159723609,
          y: 0.1694912418562097,
        },
        {
          id: "280",
          x: 0.2542373928151551,
          y: 0.32203291746977214,
        },
        {
          id: "24",
          x: 0.27118687947174597,
          y: 0.1864364509817558,
        },
        {
          id: "218",
          x: 0.12711924633376898,
          y: 0.20338599607334912,
        },
        {
          id: "311",
          x: 0.1101707960765389,
          y: 0.30508550863462164,
        },
        {
          id: "226",
          x: 0.11864448185446617,
          y: 0.1694912418562097,
          radius: 2.5331281836128765,
        },
        {
          id: "32",
          x: 0.2627121361434505,
          y: 0.05084649901833728,
        },
        {
          id: "82",
          x: 0.22881523562899034,
          y: 0.20338599607334912,
        },
        {
          id: "102",
          x: 0.2118657489723995,
          y: 0.20338599607334912,
        },
        {
          id: "180",
          x: 0.1525445761710382,
          y: 0.11864256427932182,
        },
        {
          id: "77",
          x: 0.22881523562899034,
          y: 0.11864256427932182,
        },
        {
          id: "125",
          x: 0.19491622001379386,
          y: 0.20338599607334912,
        },
        {
          id: "15",
          x: 0.27966166510205615,
          y: 0.22033556231599638,
        },
        {
          id: "148",
          x: 0.1779667122061956,
          y: 0.1694912418562097,
        },
        {
          id: "130",
          x: 0.19491622001379386,
          y: 0.28813378498447767,
        },
        {
          id: "199",
          x: 0.14406875414136724,
          y: 0.2711863761493271,
        },
        {
          id: "328",
          x: 0.24576476458759597,
          y: 0.3389845988178084,
        },
        {
          id: "72",
          x: 0.23728892140691765,
          y: 0.2372851074075898,
        },
        {
          id: "30",
          x: 0.2627121361434505,
          y: 0.016947377108569712,
        },
        {
          id: "84",
          x: 0.2203404923006949,
          y: 0.03389693277569003,
        },
        {
          id: "122",
          x: 0.19491622001379386,
          y: 0.15254167561356247,
        },
        {
          id: "45",
          x: 0.2542373928151551,
          y: 0.1694912418562097,
        },
        {
          id: "13",
          x: 0.27966166510205615,
          y: 0.1864364509817558,
        },
        {
          id: "275",
          x: 0.27118687947174597,
          y: 0.30508550863462164,
        },
        {
          id: "271",
          x: 0.2881364507323663,
          y: 0.30508550863462164,
        },
        {
          id: "23",
          x: 0.27118687947174597,
          y: 0.1694912418562097,
        },
        {
          id: "131",
          x: 0.1864414766854984,
          y: 0.05084649901833728,
        },
        {
          id: "215",
          x: 0.12711924633376898,
          y: 0.15254167561356247,
        },
        {
          id: "284",
          x: 0.22881523562899034,
          y: 0.32203291746977214,
        },
        {
          id: "7",
          x: 0.2881364507323663,
          y: 0.2372851074075898,
        },
        {
          id: "137",
          x: 0.1864414766854984,
          y: 0.20338599607334912,
        },
        {
          id: "55",
          x: 0.24576476458759597,
          y: 0.0847456315036318,
        },
        {
          id: "9",
          x: 0.2881364507323663,
          y: 0.28813378498447767,
        },
        {
          id: "237",
          x: 0.1101707960765389,
          y: 0.22033556231599638,
        },
        {
          id: "3",
          x: 0.2881364507323663,
          y: 0.016947377108569712,
        },
        {
          id: "319",
          x: 0.2881364507323663,
          y: 0.37287941648810946,
        },
        {
          id: "294",
          x: 0.1864414766854984,
          y: 0.32203291746977214,
        },
        {
          id: "236",
          x: 0.1101707960765389,
          y: 0.20338599607334912,
          color: "#F4B400",
        },
        {
          id: "120",
          x: 0.19491622001379386,
          y: 0.10169299803667456,
        },
        {
          id: "22",
          x: 0.27118687947174597,
          y: 0.15254167561356247,
        },
        {
          id: "305",
          x: 0.13559508951444732,
          y: 0.30508550863462164,
          color: "#2EB67D",
        },
        {
          id: "101",
          x: 0.2118657489723995,
          y: 0.1864364509817558,
        },
        {
          id: "235",
          x: 0.1101707960765389,
          y: 0.1864364509817558,
        },
        {
          id: "11",
          x: 0.27966166510205615,
          y: 0.03389693277569003,
        },
        {
          id: "216",
          x: 0.12711924633376898,
          y: 0.1694912418562097,
        },
        {
          id: "169",
          x: 0.1610182619489655,
          y: 0.10169299803667456,
        },
        {
          id: "223",
          x: 0.12711924633376898,
          y: 0.28813378498447767,
        },
        {
          id: "217",
          x: 0.12711924633376898,
          y: 0.1864364509817558,
        },
        {
          id: "161",
          x: 0.16949194772689277,
          y: 0.20338599607334912,
        },
        {
          id: "61",
          x: 0.23728892140691765,
          y: 0.03389693277569003,
          color: "#2EB67D",
        },
        {
          id: "112",
          x: 0.2033909633420893,
          y: 0.1864364509817558,
        },
        {
          id: "249",
          x: 0.10169603159723609,
          y: 0.28813378498447767,
        },
        {
          id: "239",
          x: 0.1101707960765389,
          y: 0.25423465249918314,
        },
        {
          id: "316",
          x: 0.30508483753657434,
          y: 0.35592980794335444,
          radius: 2.0536473637965127,
        },
        {
          id: "247",
          x: 0.10169603159723609,
          y: 0.25423465249918314,
        },
        {
          id: "75",
          x: 0.22881523562899034,
          y: 0.06779388670243394,
        },
        {
          id: "25",
          x: 0.27118687947174597,
          y: 0.20338599607334912,
        },
        {
          id: "143",
          x: 0.1779667122061956,
          y: 0.06779388670243394,
        },
        {
          id: "330",
          x: 0.24576476458759597,
          y: 0.37287941648810946,
          color: "#2EB67D",
        },
        {
          id: "41",
          x: 0.2542373928151551,
          y: 0.03389693277569003,
        },
        {
          id: "93",
          x: 0.2203404923006949,
          y: 0.22033556231599638,
        },
        {
          id: "104",
          x: 0.2118657489723995,
          y: 0.2372851074075898,
        },
        {
          id: "163",
          x: 0.16949194772689277,
          y: 0.2372851074075898,
        },
        {
          id: "73",
          x: 0.22881523562899034,
          y: 0.03389693277569003,
        },
        {
          id: "158",
          x: 0.16949194772689277,
          y: 0.15254167561356247,
        },
        {
          id: "157",
          x: 0.16949194772689277,
          y: 0.13559213052196908,
        },
        {
          id: "20",
          x: 0.27118687947174597,
          y: 0.03389693277569003,
          color: "#F4B400",
        },
        {
          id: "303",
          x: 0.14406875414136724,
          y: 0.30508550863462164,
        },
        {
          id: "228",
          x: 0.11864448185446617,
          y: 0.20338599607334912,
        },
        {
          id: "267",
          x: 0.30508483753657434,
          y: 0.30508550863462164,
        },
        {
          id: "105",
          x: 0.2118657489723995,
          y: 0.2711863761493271,
        },
        {
          id: "28",
          x: 0.27118687947174597,
          y: 0.2711863761493271,
        },
        {
          id: "26",
          x: 0.27118687947174597,
          y: 0.22033556231599638,
        },
        {
          id: "295",
          x: 0.1779667122061956,
          y: 0.30508550863462164,
        },
        {
          id: "142",
          x: 0.1864414766854984,
          y: 0.28813378498447767,
        },
        {
          id: "48",
          x: 0.2542373928151551,
          y: 0.2372851074075898,
        },
        {
          id: "156",
          x: 0.16949194772689277,
          y: 0.10169299803667456,
        },
        {
          id: "140",
          x: 0.1864414766854984,
          y: 0.25423465249918314,
        },
        {
          id: "325",
          x: 0.2542373928151551,
          y: 0.3389845988178084,
        },
        {
          id: "241",
          x: 0.1101707960765389,
          y: 0.28813378498447767,
        },
        {
          id: "114",
          x: 0.2033909633420893,
          y: 0.22033556231599638,
        },
        {
          id: "270",
          x: 0.296611151758647,
          y: 0.32203291746977214,
        },
        {
          id: "6",
          x: 0.2881364507323663,
          y: 0.22033556231599638,
          color: "#DB4437",
        },
        {
          id: "197",
          x: 0.14406875414136724,
          y: 0.2372851074075898,
        },
        {
          id: "135",
          x: 0.1864414766854984,
          y: 0.1694912418562097,
        },
        {
          id: "334",
          x: 0.2203404923006949,
          y: 0.3389845988178084,
        },
        {
          id: "33",
          x: 0.2627121361434505,
          y: 0.15254167561356247,
        },
        {
          id: "252",
          x: 0.09322128826894065,
          y: 0.22033556231599638,
        },
        {
          id: "179",
          x: 0.1525445761710382,
          y: 0.10169299803667456,
        },
        {
          id: "231",
          x: 0.11864448185446617,
          y: 0.25423465249918314,
        },
        {
          id: "118",
          x: 0.2033909633420893,
          y: 0.28813378498447767,
        },
        {
          id: "257",
          x: 0.08474652378963783,
          y: 0.20338599607334912,
        },
        {
          id: "67",
          x: 0.23728892140691765,
          y: 0.15254167561356247,
        },
        {
          id: "160",
          x: 0.16949194772689277,
          y: 0.1864364509817558,
        },
        {
          id: "187",
          x: 0.1525445761710382,
          y: 0.2711863761493271,
        },
        {
          id: "186",
          x: 0.1525445761710382,
          y: 0.25423465249918314,
        },
        {
          id: "175",
          x: 0.1610182619489655,
          y: 0.25423465249918314,
        },
        {
          id: "291",
          x: 0.19491622001379386,
          y: 0.30508550863462164,
        },
        {
          id: "117",
          x: 0.2033909633420893,
          y: 0.2711863761493271,
        },
        {
          id: "106",
          x: 0.2118657489723995,
          y: 0.28813378498447767,
        },
        {
          id: "90",
          x: 0.2203404923006949,
          y: 0.15254167561356247,
        },
        {
          id: "312",
          x: 0.1101707960765389,
          y: 0.32203291746977214,
        },
        {
          id: "310",
          x: 0.11864448185446617,
          y: 0.32203291746977214,
        },
        {
          id: "273",
          x: 0.27966166510205615,
          y: 0.30508550863462164,
        },
        {
          id: "336",
          x: 0.1101707960765389,
          y: 0.3389845988178084,
          radius: 2.247514520157986,
        },
        {
          id: "313",
          x: 0.32203432419316524,
          y: 0.35592980794335444,
        },
        {
          id: "27",
          x: 0.27118687947174597,
          y: 0.25423465249918314,
        },
        {
          id: "38",
          x: 0.2627121361434505,
          y: 0.2711863761493271,
        },
        {
          id: "74",
          x: 0.22881523562899034,
          y: 0.05084649901833728,
        },
        {
          id: "152",
          x: 0.1779667122061956,
          y: 0.2372851074075898,
        },
        {
          id: "335",
          x: 0.11864448185446617,
          y: 0.3389845988178084,
        },
        {
          id: "253",
          x: 0.09322128826894065,
          y: 0.2372851074075898,
        },
        {
          id: "138",
          x: 0.1864414766854984,
          y: 0.22033556231599638,
        },
        {
          id: "66",
          x: 0.23728892140691765,
          y: 0.13559213052196908,
        },
        {
          id: "317",
          x: 0.296611151758647,
          y: 0.37287941648810946,
        },
        {
          id: "49",
          x: 0.2542373928151551,
          y: 0.25423465249918314,
          radius: 2.7224752503747007,
        },
        {
          id: "141",
          x: 0.1864414766854984,
          y: 0.2711863761493271,
        },
        {
          id: "136",
          x: 0.1864414766854984,
          y: 0.1864364509817558,
        },
        {
          id: "18",
          x: 0.27966166510205615,
          y: 0.28813378498447767,
        },
        {
          id: "185",
          x: 0.1525445761710382,
          y: 0.2372851074075898,
        },
        {
          id: "8",
          x: 0.2881364507323663,
          y: 0.2711863761493271,
        },
        {
          id: "246",
          x: 0.10169603159723609,
          y: 0.2372851074075898,
        },
        {
          id: "34",
          x: 0.2627121361434505,
          y: 0.1694912418562097,
        },
        {
          id: "229",
          x: 0.11864448185446617,
          y: 0.22033556231599638,
        },
        {
          id: "251",
          x: 0.09322128826894065,
          y: 0.20338599607334912,
        },
        {
          id: "159",
          x: 0.16949194772689277,
          y: 0.1694912418562097,
        },
        {
          id: "5",
          x: 0.2881364507323663,
          y: 0.20338599607334912,
          radius: 2.9783806893550246,
          color: "#F4B400",
        },
        {
          id: "248",
          x: 0.10169603159723609,
          y: 0.2711863761493271,
        },
        {
          id: "91",
          x: 0.2203404923006949,
          y: 0.1864364509817558,
        },
        {
          id: "14",
          x: 0.27966166510205615,
          y: 0.20338599607334912,
          radius: 2.9246586877547767,
        },
        {
          id: "35",
          x: 0.2627121361434505,
          y: 0.22033556231599638,
        },
        {
          id: "162",
          x: 0.16949194772689277,
          y: 0.22033556231599638,
        },
        {
          id: "36",
          x: 0.2627121361434505,
          y: 0.2372851074075898,
        },
        {
          id: "164",
          x: 0.16949194772689277,
          y: 0.25423465249918314,
        },
        {
          id: "98",
          x: 0.2118657489723995,
          y: 0.10169299803667456,
          color: "#2EB67D",
        },
        {
          id: "43",
          x: 0.2542373928151551,
          y: 0.06779388670243394,
        },
        {
          id: "64",
          x: 0.23728892140691765,
          y: 0.0847456315036318,
        },
        {
          id: "83",
          x: 0.22881523562899034,
          y: 0.22033556231599638,
        },
        {
          id: "149",
          x: 0.1779667122061956,
          y: 0.1864364509817558,
        },
        {
          id: "71",
          x: 0.23728892140691765,
          y: 0.22033556231599638,
        },
        {
          id: "170",
          x: 0.1610182619489655,
          y: 0.15254167561356247,
        },
        {
          id: "40",
          x: 0.2542373928151551,
          y: 0.016947387684096656,
        },
        {
          id: "167",
          x: 0.1610182619489655,
          y: 0.06779388670243394,
          radius: 2.0684082823764602,
        },
        {
          id: "151",
          x: 0.1779667122061956,
          y: 0.22033556231599638,
        },
        {
          id: "78",
          x: 0.22881523562899034,
          y: 0.13559213052196908,
          radius: 2.9659051928601965,
        },
        {
          id: "144",
          x: 0.1779667122061956,
          y: 0.0847456315036318,
        },
        {
          id: "166",
          x: 0.16949194772689277,
          y: 0.28813378498447767,
        },
        {
          id: "4",
          x: 0.2881364507323663,
          y: 0.1864364509817558,
          color: "#A566FF",
        },
        {
          id: "171",
          x: 0.1610182619489655,
          y: 0.1694912418562097,
        },
        {
          id: "80",
          x: 0.22881523562899034,
          y: 0.1694912418562097,
        },
        {
          id: "54",
          x: 0.24576476458759597,
          y: 0.06779388670243394,
        },
        {
          id: "126",
          x: 0.19491622001379386,
          y: 0.22033556231599638,
        },
        {
          id: "96",
          x: 0.2118657489723995,
          y: 0.05084649901833728,
        },
        {
          id: "107",
          x: 0.2033909633420893,
          y: 0.05084649901833728,
        },
        {
          id: "109",
          x: 0.2033909633420893,
          y: 0.13559213052196908,
        },
        {
          id: "70",
          x: 0.23728892140691765,
          y: 0.20338599607334912,
        },
        {
          id: "57",
          x: 0.24576476458759597,
          y: 0.13559213052196908,
        },
        {
          id: "155",
          x: 0.1779667122061956,
          y: 0.28813378498447767,
        },
        {
          id: "113",
          x: 0.2033909633420893,
          y: 0.20338599607334912,
        },
        {
          id: "79",
          x: 0.22881523562899034,
          y: 0.15254167561356247,
        },
        {
          id: "188",
          x: 0.1525445761710382,
          y: 0.28813378498447767,
        },
        {
          id: "194",
          x: 0.14406875414136724,
          y: 0.1864364509817558,
        },
        {
          id: "85",
          x: 0.2203404923006949,
          y: 0.05084649901833728,
        },
        {
          id: "94",
          x: 0.2203404923006949,
          y: 0.28813378498447767,
        },
        {
          id: "309",
          x: 0.11864448185446617,
          y: 0.30508550863462164,
        },
        {
          id: "53",
          x: 0.24576476458759597,
          y: 0.05084649901833728,
        },
        {
          id: "190",
          x: 0.14406875414136724,
          y: 0.10169299803667456,
        },
        {
          id: "51",
          x: 0.24576476458759597,
          y: 0.016947377108569712,
        },
        {
          id: "132",
          x: 0.1864414766854984,
          y: 0.06779388670243394,
          radius: 2.5085039212125784,
          color: "#2EB67D",
        },
        {
          id: "207",
          x: 0.13559508951444732,
          y: 0.22033556231599638,
        },
        {
          id: "208",
          x: 0.13559508951444732,
          y: 0.2372851074075898,
        },
        {
          id: "88",
          x: 0.2203404923006949,
          y: 0.11864256427932182,
        },
        {
          id: "87",
          x: 0.2203404923006949,
          y: 0.10169299803667456,
          radius: 2.596357497299122,
        },
        {
          id: "182",
          x: 0.1525445761710382,
          y: 0.1694912418562097,
        },
        {
          id: "154",
          x: 0.1779667122061956,
          y: 0.2711863761493271,
        },
        {
          id: "196",
          x: 0.14406875414136724,
          y: 0.22033556231599638,
        },
        {
          id: "178",
          x: 0.1525445761710382,
          y: 0.0847456315036318,
        },
        {
          id: "86",
          x: 0.2203404923006949,
          y: 0.06779388670243394,
        },
        {
          id: "103",
          x: 0.2118657489723995,
          y: 0.22033556231599638,
        },
        {
          id: "76",
          x: 0.22881523562899034,
          y: 0.0847456315036318,
        },
        {
          id: "307",
          x: 0.12711924633376898,
          y: 0.30508550863462164,
        },
        {
          id: "315",
          x: 0.3135607230192674,
          y: 0.35592980794335444,
        },
        {
          id: "191",
          x: 0.14406875414136724,
          y: 0.13559213052196908,
        },
        {
          id: "202",
          x: 0.13559508951444732,
          y: 0.10169299803667456,
          color: "#A566FF",
        },
        {
          id: "63",
          x: 0.23728892140691765,
          y: 0.06779388670243394,
        },
        {
          id: "203",
          x: 0.13559508951444732,
          y: 0.13559213052196908,
        },
        {
          id: "69",
          x: 0.23728892140691765,
          y: 0.1864364509817558,
        },
        {
          id: "47",
          x: 0.2542373928151551,
          y: 0.22033556231599638,
        },
        {
          id: "314",
          x: 0.3135607230192674,
          y: 0.3389845988178084,
          radius: 2.9935559317319447,
        },
        {
          id: "318",
          x: 0.2881364507323663,
          y: 0.35592980794335444,
        },
        {
          id: "304",
          x: 0.14406875414136724,
          y: 0.32203291746977214,
        },
        {
          id: "332",
          x: 0.23728892140691765,
          y: 0.35592980794335444,
        },
        {
          id: "181",
          x: 0.1525445761710382,
          y: 0.15254167561356247,
        },
        {
          id: "183",
          x: 0.1525445761710382,
          y: 0.20338599607334912,
        },
        {
          id: "324",
          x: 0.2627121361434505,
          y: 0.35592980794335444,
        },
        {
          id: "176",
          x: 0.1610182619489655,
          y: 0.2711863761493271,
        },
        {
          id: "44",
          x: 0.2542373928151551,
          y: 0.15254167561356247,
        },
        {
          id: "111",
          x: 0.2033909633420893,
          y: 0.1694912418562097,
        },
        {
          id: "59",
          x: 0.24576476458759597,
          y: 0.1694912418562097,
        },
        {
          id: "327",
          x: 0.2542373928151551,
          y: 0.37287941648810946,
        },
        {
          id: "123",
          x: 0.19491622001379386,
          y: 0.1694912418562097,
        },
        {
          id: "100",
          x: 0.2118657489723995,
          y: 0.1694912418562097,
        },
        {
          id: "193",
          x: 0.14406875414136724,
          y: 0.1694912418562097,
          radius: 2.390670887197082,
        },
        {
          id: "60",
          x: 0.23728892140691765,
          y: 0.016947377108569712,
          color: "#DB4437",
        },
        {
          id: "110",
          x: 0.2033909633420893,
          y: 0.15254167561356247,
          radius: 2.5561068126592623,
        },
        {
          id: "81",
          x: 0.22881523562899034,
          y: 0.1864364509817558,
        },
        {
          id: "116",
          x: 0.2033909633420893,
          y: 0.25423465249918314,
        },
        {
          id: "299",
          x: 0.1610182619489655,
          y: 0.30508550863462164,
        },
        {
          id: "306",
          x: 0.13559508951444732,
          y: 0.32203291746977214,
        },
        {
          id: "58",
          x: 0.24576476458759597,
          y: 0.15254167561356247,
        },
        {
          id: "52",
          x: 0.24576476458759597,
          y: 0.03389693277569003,
        },
        {
          id: "320",
          x: 0.27966166510205615,
          y: 0.3389845988178084,
        },
        {
          id: "92",
          x: 0.2203404923006949,
          y: 0.20338599607334912,
        },
        {
          id: "50",
          x: 0.2542373928151551,
          y: 0.2711863761493271,
          radius: 2.3864259479351717,
        },
        {
          id: "97",
          x: 0.2118657489723995,
          y: 0.06779388670243394,
        },
        {
          id: "308",
          x: 0.12711924633376898,
          y: 0.32203291746977214,
        },
        {
          id: "333",
          x: 0.22881523562899034,
          y: 0.3389845988178084,
        },
        {
          id: "108",
          x: 0.2033909633420893,
          y: 0.0847456315036318,
        },
        {
          id: "326",
          x: 0.2542373928151551,
          y: 0.35592980794335444,
        },
        {
          id: "204",
          x: 0.13559508951444732,
          y: 0.15254167561356247,
        },
        {
          id: "209",
          x: 0.13559508951444732,
          y: 0.25423465249918314,
        },
        {
          id: "127",
          x: 0.19491622001379386,
          y: 0.2372851074075898,
        },
        {
          id: "331",
          x: 0.23728892140691765,
          y: 0.3389845988178084,
        },
      ],
      region: "north_america",
    },
    {
      id: "cape_verde",
      dots: [
        {
          id: "0",
          x: 0.41525459721375235,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "central_african_republic",
      dots: [
        {
          id: "5",
          x: 0.5254253298372692,
          y: 0.6101688175596388,
          radius: 2.7249862552173503,
        },
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.6101688175596388,
        },
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.5932258081436972,
        },
        {
          id: "4",
          x: 0.5339011730179475,
          y: 0.6101688175596388,
        },
        {
          id: "3",
          x: 0.5339011730179475,
          y: 0.5932258081436972,
        },
        {
          id: "2",
          x: 0.5423748587958749,
          y: 0.6101688175596388,
        },
        {
          id: "6",
          x: 0.5169516440593419,
          y: 0.6101688175596388,
        },
      ],
      region: "africa",
    },
    {
      id: "chad",
      dots: [
        {
          id: "9",
          x: 0.5254253298372692,
          y: 0.5932258081436972,
        },
        {
          id: "3",
          x: 0.5339011730179475,
          y: 0.5593288753680071,
        },
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.5254297851848204,
        },
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.5423706371932654,
        },
        {
          id: "2",
          x: 0.5339011730179475,
          y: 0.5423706371932654,
        },
        {
          id: "6",
          x: 0.5254253298372692,
          y: 0.5423706371932654,
        },
        {
          id: "5",
          x: 0.5254253298372692,
          y: 0.5254297851848204,
        },
        {
          id: "7",
          x: 0.5254253298372692,
          y: 0.5593288753680071,
        },
        {
          id: "10",
          x: 0.5169516440593419,
          y: 0.5593288753680071,
        },
        {
          id: "4",
          x: 0.5339011730179475,
          y: 0.5762740844935532,
        },
        {
          id: "8",
          x: 0.5254253298372692,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "chile",
      dots: [
        {
          id: "6",
          x: 0.27118687947174597,
          y: 0.847460545247096,
        },
        {
          id: "14",
          x: 0.2627121361434505,
          y: 0.9661094971446923,
        },
        {
          id: "7",
          x: 0.27118687947174597,
          y: 0.8644099845834199,
        },
        {
          id: "0",
          x: 0.27966166510205615,
          y: 0.7627126717317518,
        },
        {
          id: "13",
          x: 0.2627121361434505,
          y: 0.9491556583891595,
        },
        {
          id: "12",
          x: 0.2627121361434505,
          y: 0.9322082495540088,
        },
        {
          id: "1",
          x: 0.27966166510205615,
          y: 0.7796665950915004,
        },
        {
          id: "2",
          x: 0.27966166510205615,
          y: 0.7966118042170462,
        },
        {
          id: "4",
          x: 0.27118687947174597,
          y: 0.8135592130521969,
        },
        {
          id: "9",
          x: 0.27118687947174597,
          y: 1,
          color: "#A566FF",
        },
        {
          id: "8",
          x: 0.27118687947174597,
          y: 0.8813573934185704,
        },
        {
          id: "15",
          x: 0.2627121361434505,
          y: 0.9830547062702384,
        },
        {
          id: "11",
          x: 0.2627121361434505,
          y: 0.9152543261942604,
        },
        {
          id: "3",
          x: 0.27966166510205615,
          y: 0.8135592130521969,
        },
        {
          id: "10",
          x: 0.2627121361434505,
          y: 0.8983113167783189,
        },
        {
          id: "5",
          x: 0.27118687947174597,
          y: 0.8305110213065564,
        },
      ],
      region: "south_america",
    },
    {
      id: "china",
      dots: [
        {
          id: "126",
          x: 0.7033920631944722,
          y: 0.37287941648810946,
        },
        {
          id: "70",
          x: 0.7711868794717459,
          y: 0.42372811521605125,
        },
        {
          id: "88",
          x: 0.7542373082111256,
          y: 0.4576315202142314,
        },
        {
          id: "71",
          x: 0.7711868794717459,
          y: 0.4406819962736919,
        },
        {
          id: "82",
          x: 0.7627142935462016,
          y: 0.4915284529899215,
        },
        {
          id: "101",
          x: 0.7372878215545348,
          y: 0.4576315202142314,
        },
        {
          id: "81",
          x: 0.7627142935462016,
          y: 0.4745745719322808,
        },
        {
          id: "86",
          x: 0.7542373082111256,
          y: 0.42372811521605125,
        },
        {
          id: "97",
          x: 0.7372878215545348,
          y: 0.38983109783614567,
          radius: 2.7277654278674284,
        },
        {
          id: "96",
          x: 0.7372878215545348,
          y: 0.37287941648810946,
        },
        {
          id: "132",
          x: 0.6949151624634257,
          y: 0.4067785066712962,
        },
        {
          id: "99",
          x: 0.7372878215545348,
          y: 0.42372811521605125,
        },
        {
          id: "75",
          x: 0.7711868794717459,
          y: 0.5084715047079709,
        },
        {
          id: "106",
          x: 0.7288152356289904,
          y: 0.4067785066712962,
        },
        {
          id: "35",
          x: 0.8050848375365743,
          y: 0.42372811521605125,
        },
        {
          id: "44",
          x: 0.7966122516110299,
          y: 0.42372811521605125,
        },
        {
          id: "74",
          x: 0.7711868794717459,
          y: 0.4915284529899215,
        },
        {
          id: "38",
          x: 0.8050848375365743,
          y: 0.4745745719322808,
        },
        {
          id: "91",
          x: 0.7457648068896107,
          y: 0.4067785066712962,
        },
        {
          id: "20",
          x: 0.8220344087971947,
          y: 0.38983109783614567,
        },
        {
          id: "36",
          x: 0.8050848375365743,
          y: 0.4406819962736919,
        },
        {
          id: "13",
          x: 0.8389838954537855,
          y: 0.35592980794335444,
        },
        {
          id: "65",
          x: 0.7796638648068219,
          y: 0.4915284529899215,
        },
        {
          id: "66",
          x: 0.7796638648068219,
          y: 0.5084715047079709,
        },
        {
          id: "67",
          x: 0.7796638648068219,
          y: 0.5254297851848204,
        },
        {
          id: "29",
          x: 0.8135585233145016,
          y: 0.4745745719322808,
        },
        {
          id: "56",
          x: 0.7881353508799834,
          y: 0.4915284529899215,
        },
        {
          id: "37",
          x: 0.8050848375365743,
          y: 0.4576315202142314,
        },
        {
          id: "23",
          x: 0.8135585233145016,
          y: 0.37287941648810946,
        },
        {
          id: "111",
          x: 0.720341549851063,
          y: 0.35592980794335444,
        },
        {
          id: "134",
          x: 0.6864424919338519,
          y: 0.4067785066712962,
        },
        {
          id: "49",
          x: 0.7966122516110299,
          y: 0.5084715047079709,
        },
        {
          id: "84",
          x: 0.7542373082111256,
          y: 0.38983109783614567,
        },
        {
          id: "21",
          x: 0.8220344087971947,
          y: 0.4067785066712962,
        },
        {
          id: "54",
          x: 0.7881353508799834,
          y: 0.4576315202142314,
        },
        {
          id: "28",
          x: 0.8135585233145016,
          y: 0.4576315202142314,
        },
        {
          id: "7",
          x: 0.8135585233145016,
          y: 0.30508550863462164,
        },
        {
          id: "9",
          x: 0.8135585233145016,
          y: 0.3389845988178084,
        },
        {
          id: "117",
          x: 0.720341549851063,
          y: 0.4576315202142314,
        },
        {
          id: "45",
          x: 0.7966122516110299,
          y: 0.4406819962736919,
        },
        {
          id: "4",
          x: 0.8220344087971947,
          y: 0.30508550863462164,
          radius: 2.7292386502522445,
        },
        {
          id: "57",
          x: 0.7881353508799834,
          y: 0.5084715047079709,
        },
        {
          id: "92",
          x: 0.7457648068896107,
          y: 0.42372811521605125,
        },
        {
          id: "105",
          x: 0.7288152356289904,
          y: 0.38983109783614567,
        },
        {
          id: "50",
          x: 0.7881353508799834,
          y: 0.38983109783614567,
        },
        {
          id: "39",
          x: 0.8050848375365743,
          y: 0.4915284529899215,
        },
        {
          id: "53",
          x: 0.7881353508799834,
          y: 0.4406819962736919,
        },
        {
          id: "108",
          x: 0.7288152356289904,
          y: 0.4406819962736919,
        },
        {
          id: "89",
          x: 0.7542373082111256,
          y: 0.4745745719322808,
        },
        {
          id: "40",
          x: 0.8050848375365743,
          y: 0.5084715047079709,
        },
        {
          id: "85",
          x: 0.7542373082111256,
          y: 0.4067785066712962,
        },
        {
          id: "107",
          x: 0.7288152356289904,
          y: 0.42372811521605125,
        },
        {
          id: "15",
          x: 0.830508094575122,
          y: 0.35592980794335444,
        },
        {
          id: "58",
          x: 0.7881353508799834,
          y: 0.5254297851848204,
        },
        {
          id: "133",
          x: 0.6949151624634257,
          y: 0.42372811521605125,
        },
        {
          id: "33",
          x: 0.8050848375365743,
          y: 0.38983109783614567,
        },
        {
          id: "46",
          x: 0.7966122516110299,
          y: 0.4576315202142314,
        },
        {
          id: "79",
          x: 0.7627142935462016,
          y: 0.4406819962736919,
        },
        {
          id: "6",
          x: 0.8220344087971947,
          y: 0.3389845988178084,
        },
        {
          id: "118",
          x: 0.720341549851063,
          y: 0.4745745719322808,
        },
        {
          id: "98",
          x: 0.7372878215545348,
          y: 0.4067785066712962,
          color: "#F4B400",
        },
        {
          id: "123",
          x: 0.7118646491200166,
          y: 0.42372811521605125,
        },
        {
          id: "94",
          x: 0.7457648068896107,
          y: 0.4576315202142314,
        },
        {
          id: "63",
          x: 0.7796638648068219,
          y: 0.4576315202142314,
        },
        {
          id: "103",
          x: 0.7288152356289904,
          y: 0.35592980794335444,
        },
        {
          id: "24",
          x: 0.8135585233145016,
          y: 0.38983109783614567,
        },
        {
          id: "2",
          x: 0.830508094575122,
          y: 0.32203291746977214,
        },
        {
          id: "55",
          x: 0.7881353508799834,
          y: 0.4745745719322808,
        },
        {
          id: "122",
          x: 0.7118646491200166,
          y: 0.4067785066712962,
        },
        {
          id: "115",
          x: 0.720341549851063,
          y: 0.42372811521605125,
        },
        {
          id: "102",
          x: 0.7372878215545348,
          y: 0.4745745719322808,
        },
        {
          id: "110",
          x: 0.7288152356289904,
          y: 0.4745745719322808,
        },
        {
          id: "109",
          x: 0.7288152356289904,
          y: 0.4576315202142314,
        },
        {
          id: "104",
          x: 0.7288152356289904,
          y: 0.37287941648810946,
          radius: 2.653121459878576,
        },
        {
          id: "68",
          x: 0.7711868794717459,
          y: 0.38983109783614567,
        },
        {
          id: "60",
          x: 0.7796638648068219,
          y: 0.4067785066712962,
        },
        {
          id: "112",
          x: 0.720341549851063,
          y: 0.37287941648810946,
        },
        {
          id: "43",
          x: 0.7966122516110299,
          y: 0.4067785066712962,
        },
        {
          id: "90",
          x: 0.7457648068896107,
          y: 0.38983109783614567,
        },
        {
          id: "48",
          x: 0.7966122516110299,
          y: 0.4915284529899215,
        },
        {
          id: "80",
          x: 0.7627142935462016,
          y: 0.4576315202142314,
        },
        {
          id: "22",
          x: 0.8135585233145016,
          y: 0.35592980794335444,
        },
        {
          id: "113",
          x: 0.720341549851063,
          y: 0.38983109783614567,
        },
        {
          id: "64",
          x: 0.7796638648068219,
          y: 0.4745745719322808,
        },
        {
          id: "129",
          x: 0.7033920631944722,
          y: 0.42372811521605125,
        },
        {
          id: "62",
          x: 0.7796638648068219,
          y: 0.4406819962736919,
        },
        {
          id: "114",
          x: 0.720341549851063,
          y: 0.4067785066712962,
        },
        {
          id: "42",
          x: 0.7966122516110299,
          y: 0.38983109783614567,
        },
        {
          id: "27",
          x: 0.8135585233145016,
          y: 0.4406819962736919,
        },
        {
          id: "130",
          x: 0.7033920631944722,
          y: 0.4406819962736919,
        },
        {
          id: "72",
          x: 0.7711868794717459,
          y: 0.4576315202142314,
        },
        {
          id: "135",
          x: 0.6864424919338519,
          y: 0.42372811521605125,
          color: "#F4B400",
        },
        {
          id: "59",
          x: 0.7796638648068219,
          y: 0.38983109783614567,
        },
        {
          id: "5",
          x: 0.8220344087971947,
          y: 0.32203291746977214,
        },
        {
          id: "127",
          x: 0.7033920631944722,
          y: 0.38983109783614567,
        },
        {
          id: "77",
          x: 0.7627142935462016,
          y: 0.4067785066712962,
        },
        {
          id: "41",
          x: 0.7966122516110299,
          y: 0.37287941648810946,
        },
        {
          id: "69",
          x: 0.7711868794717459,
          y: 0.4067785066712962,
        },
        {
          id: "31",
          x: 0.8050848375365743,
          y: 0.35592980794335444,
        },
        {
          id: "17",
          x: 0.830508094575122,
          y: 0.38983109783614567,
        },
        {
          id: "116",
          x: 0.720341549851063,
          y: 0.4406819962736919,
        },
        {
          id: "100",
          x: 0.7372878215545348,
          y: 0.4406819962736919,
        },
        {
          id: "47",
          x: 0.7966122516110299,
          y: 0.4745745719322808,
        },
        {
          id: "131",
          x: 0.7033920631944722,
          y: 0.4576315202142314,
        },
        {
          id: "136",
          x: 0.7118646491200166,
          y: 0.4745745719322808,
        },
        {
          id: "12",
          x: 0.8474575812317129,
          y: 0.35592980794335444,
        },
        {
          id: "95",
          x: 0.7457648068896107,
          y: 0.4745745719322808,
        },
        {
          id: "10",
          x: 0.8050848375365743,
          y: 0.3389845988178084,
        },
        {
          id: "8",
          x: 0.8135585233145016,
          y: 0.32203291746977214,
        },
        {
          id: "78",
          x: 0.7627142935462016,
          y: 0.42372811521605125,
        },
        {
          id: "52",
          x: 0.7881353508799834,
          y: 0.42372811521605125,
        },
        {
          id: "51",
          x: 0.7881353508799834,
          y: 0.4067785066712962,
          radius: 2.4035509266959774,
        },
        {
          id: "73",
          x: 0.7711868794717459,
          y: 0.4745745719322808,
        },
        {
          id: "61",
          x: 0.7796638648068219,
          y: 0.42372811521605125,
        },
        {
          id: "34",
          x: 0.8050848375365743,
          y: 0.4067785066712962,
        },
        {
          id: "87",
          x: 0.7542373082111256,
          y: 0.4406819962736919,
        },
        {
          id: "76",
          x: 0.7627142935462016,
          y: 0.38983109783614567,
        },
        {
          id: "120",
          x: 0.7118646491200166,
          y: 0.37287941648810946,
        },
        {
          id: "14",
          x: 0.8389838954537855,
          y: 0.37287941648810946,
        },
        {
          id: "3",
          x: 0.830508094575122,
          y: 0.3389845988178084,
        },
        {
          id: "83",
          x: 0.7627142935462016,
          y: 0.5084715047079709,
        },
        {
          id: "16",
          x: 0.830508094575122,
          y: 0.37287941648810946,
        },
        {
          id: "1",
          x: 0.8389838954537855,
          y: 0.3389845988178084,
        },
        {
          id: "119",
          x: 0.7118646491200166,
          y: 0.35592980794335444,
        },
        {
          id: "30",
          x: 0.8135585233145016,
          y: 0.4915284529899215,
        },
        {
          id: "121",
          x: 0.7118646491200166,
          y: 0.38983109783614567,
        },
        {
          id: "25",
          x: 0.8135585233145016,
          y: 0.4067785066712962,
        },
        {
          id: "18",
          x: 0.8220344087971947,
          y: 0.35592980794335444,
        },
        {
          id: "11",
          x: 0.720341549851063,
          y: 0.3389845988178084,
        },
        {
          id: "128",
          x: 0.7033920631944722,
          y: 0.4067785066712962,
        },
        {
          id: "26",
          x: 0.8135585233145016,
          y: 0.42372811521605125,
        },
        {
          id: "124",
          x: 0.7118646491200166,
          y: 0.4406819962736919,
        },
        {
          id: "125",
          x: 0.7118646491200166,
          y: 0.4576315202142314,
        },
        {
          id: "0",
          x: 0.8474575812317129,
          y: 0.3389845988178084,
        },
        {
          id: "32",
          x: 0.8050848375365743,
          y: 0.37287941648810946,
        },
        {
          id: "19",
          x: 0.8220344087971947,
          y: 0.37287941648810946,
        },
        {
          id: "93",
          x: 0.7457648068896107,
          y: 0.4406819962736919,
        },
      ],
      region: "asia",
    },
    {
      id: "colombia",
      dots: [
        {
          id: "2",
          x: 0.27118687947174597,
          y: 0.6271270557343807,
        },
        {
          id: "1",
          x: 0.27118687947174597,
          y: 0.6101688175596388,
          color: "#F4B400",
        },
        {
          id: "9",
          x: 0.2542373928151551,
          y: 0.6271270557343807,
        },
        {
          id: "5",
          x: 0.2627121361434505,
          y: 0.6101688175596388,
        },
        {
          id: "6",
          x: 0.2627121361434505,
          y: 0.6271270557343807,
        },
        {
          id: "10",
          x: 0.2542373928151551,
          y: 0.6440722648599267,
        },
        {
          id: "4",
          x: 0.2627121361434505,
          y: 0.5932258081436972,
        },
        {
          id: "7",
          x: 0.2627121361434505,
          y: 0.6440722648599267,
        },
        {
          id: "0",
          x: 0.27966166510205615,
          y: 0.6271270557343807,
        },
        {
          id: "3",
          x: 0.27118687947174597,
          y: 0.6440722648599267,
        },
        {
          id: "8",
          x: 0.2542373928151551,
          y: 0.6101688175596388,
        },
      ],
      region: "south_america",
    },
    {
      id: "comoros",
      dots: [
        {
          id: "0",
          x: 0.5932191731682043,
          y: 0.7288136238506728,
        },
      ],
      region: "africa",
    },
    {
      id: "congo",
      dots: [
        {
          id: "3",
          x: 0.5084747433282955,
          y: 0.6779692822398323,
        },
        {
          id: "2",
          x: 0.5169516440593419,
          y: 0.661013243774695,
          radius: 2.6654844470274606,
          color: "#2EB67D",
        },
        {
          id: "1",
          x: 0.5254253298372692,
          y: 0.6440722648599267,
        },
        {
          id: "0",
          x: 0.5254253298372692,
          y: 0.6271270557343807,
        },
      ],
      region: "africa",
    },
    {
      id: "costa_rica",
      dots: [
        {
          id: "0",
          x: 0.23728892140691765,
          y: 0.5932258081436972,
          color: "#DB4437",
        },
        {
          id: "1",
          x: 0.22881523562899034,
          y: 0.5932258081436972,
          color: "#2EB67D",
        },
      ],
      region: "south_america",
    },
    {
      id: "ivory_coast",
      dots: [
        {
          id: "2",
          x: 0.45762505660009567,
          y: 0.6271270557343807,
        },
        {
          id: "3",
          x: 0.44915251297656605,
          y: 0.6101688175596388,
        },
        {
          id: "1",
          x: 0.45762505660009567,
          y: 0.6101688175596388,
        },
        {
          id: "0",
          x: 0.45762505660009567,
          y: 0.5932258081436972,
        },
      ],
    },
    {
      id: "croatia",
      dots: [
        {
          id: "0",
          x: 0.5254253298372692,
          y: 0.37287941648810946,
        },
      ],
      region: "europe",
    },
    {
      id: "cuba",
      dots: [
        {
          id: "2",
          x: 0.24576476458759597,
          y: 0.5254297851848204,
        },
        {
          id: "1",
          x: 0.2542373928151551,
          y: 0.5254297851848204,
        },
        {
          id: "0",
          x: 0.2627121361434505,
          y: 0.5254297851848204,
        },
      ],
      region: "south_america",
    },
    {
      id: "cyprus",
      dots: [
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.4406819962736919,
        },
      ],
      region: "middle_east",
    },
    {
      id: "czech_republic",
      dots: [
        {
          id: "0",
          x: 0.5169516440593419,
          y: 0.3389845988178084,
        },
      ],
      region: "europe",
    },
    {
      id: "democratic_republic_of_congo",
      dots: [
        {
          id: "16",
          x: 0.5339011730179475,
          y: 0.6779692822398323,
        },
        {
          id: "2",
          x: 0.5508506596745385,
          y: 0.6271270557343807,
        },
        {
          id: "7",
          x: 0.5508506596745385,
          y: 0.7118684147251269,
        },
        {
          id: "13",
          x: 0.5339011730179475,
          y: 0.6271270557343807,
        },
        {
          id: "6",
          x: 0.5508506596745385,
          y: 0.6949144913653784,
        },
        {
          id: "9",
          x: 0.5423748587958749,
          y: 0.6440722648599267,
        },
        {
          id: "8",
          x: 0.5423748587958749,
          y: 0.6271270557343807,
          color: "#A566FF",
        },
        {
          id: "3",
          x: 0.5508506596745385,
          y: 0.6440722648599267,
        },
        {
          id: "18",
          x: 0.5254253298372692,
          y: 0.6779692822398323,
        },
        {
          id: "17",
          x: 0.5254253298372692,
          y: 0.661013243774695,
        },
        {
          id: "14",
          x: 0.5339011730179475,
          y: 0.6440722648599267,
        },
        {
          id: "12",
          x: 0.5423748587958749,
          y: 0.6949144913653784,
        },
        {
          id: "11",
          x: 0.5423748587958749,
          y: 0.6779692822398323,
        },
        {
          id: "5",
          x: 0.5508506596745385,
          y: 0.6779692822398323,
        },
        {
          id: "1",
          x: 0.5593233302041123,
          y: 0.6949144913653784,
        },
        {
          id: "0",
          x: 0.5593233302041123,
          y: 0.6271270557343807,
        },
        {
          id: "15",
          x: 0.5339011730179475,
          y: 0.661013243774695,
        },
        {
          id: "4",
          x: 0.5508506596745385,
          y: 0.661013243774695,
        },
        {
          id: "10",
          x: 0.5423748587958749,
          y: 0.661013243774695,
        },
        {
          id: "19",
          x: 0.5169516440593419,
          y: 0.6779692822398323,
        },
      ],
      region: "africa",
    },
    {
      id: "denmark",
      dots: [
        {
          id: "1",
          x: 0.5000021151007363,
          y: 0.30508550863462164,
        },
        {
          id: "0",
          x: 0.5000021151007363,
          y: 0.28813378498447767,
        },
      ],
      region: "europe",
    },
    {
      id: "djibouti",
      dots: [
        {
          id: "0",
          x: 0.6016949740468679,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "dominican_republic",
      dots: [
        {
          id: "0",
          x: 0.27118687947174597,
          y: 0.5423706371932654,
        },
      ],
      region: "south_america",
    },
    {
      id: "ecuador",
      dots: [
        {
          id: "3",
          x: 0.24576476458759597,
          y: 0.6779692822398323,
        },
        {
          id: "2",
          x: 0.24576476458759597,
          y: 0.661013243774695,
        },
        {
          id: "1",
          x: 0.24576476458759597,
          y: 0.6440722648599267,
        },
        {
          id: "0",
          x: 0.2542373928151551,
          y: 0.661013243774695,
        },
      ],
      region: "south_america",
    },
    {
      id: "egypt",
      dots: [
        {
          id: "3",
          x: 0.5593233302041123,
          y: 0.4915284529899215,
        },
        {
          id: "4",
          x: 0.5593233302041123,
          y: 0.5084715047079709,
        },
        {
          id: "7",
          x: 0.5508506596745385,
          y: 0.5084715047079709,
        },
        {
          id: "5",
          x: 0.5508506596745385,
          y: 0.4745745719322808,
        },
        {
          id: "6",
          x: 0.5508506596745385,
          y: 0.4915284529899215,
        },
        {
          id: "2",
          x: 0.5593233302041123,
          y: 0.4745745719322808,
        },
        {
          id: "1",
          x: 0.5677948162772738,
          y: 0.5084715047079709,
        },
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.4915284529899215,
        },
      ],
      region: "africa",
    },
    {
      id: "el_salvador",
      dots: [
        {
          id: "0",
          x: 0.2203404923006949,
          y: 0.5762740844935532,
        },
      ],
      region: "south_america",
    },
    {
      id: "equatorial_guinea",
      dots: [
        {
          id: "0",
          x: 0.5000021151007363,
          y: 0.6440722648599267,
        },
      ],
      region: "africa",
    },
    {
      id: "eritrea",
      dots: [
        {
          id: "1",
          x: 0.5847454027862475,
          y: 0.5593288753680071,
        },
        {
          id: "0",
          x: 0.5932223881213236,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "estonia",
      dots: [
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.2711863761493271,
        },
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.2711863761493271,
        },
      ],
      region: "europe",
    },
    {
      id: "ethiopia",
      dots: [
        {
          id: "5",
          x: 0.5847454027862475,
          y: 0.6101688175596388,
        },
        {
          id: "4",
          x: 0.5847454027862475,
          y: 0.5932258081436972,
        },
        {
          id: "2",
          x: 0.5932223881213236,
          y: 0.6101688175596388,
        },
        {
          id: "3",
          x: 0.5847454027862475,
          y: 0.5762740844935532,
        },
        {
          id: "8",
          x: 0.5762728168607032,
          y: 0.6101688175596388,
        },
        {
          id: "6",
          x: 0.5762728168607032,
          y: 0.5762740844935532,
        },
        {
          id: "1",
          x: 0.5932223881213236,
          y: 0.5932258081436972,
        },
        {
          id: "0",
          x: 0.6016949740468679,
          y: 0.6101688175596388,
          color: "#DB4437",
        },
        {
          id: "7",
          x: 0.5762728168607032,
          y: 0.5932258081436972,
        },
      ],
      region: "africa",
    },
    {
      id: "faroe_islands",
      dots: [
        {
          id: "0",
          x: 0.4491557279296852,
          y: 0.2372851074075898,
          radius: 2.2423909120551295,
        },
      ],
      region: "europe",
    },
    {
      id: "fiji",
      dots: [
        {
          id: "0",
          x: 0.9830536436924988,
          y: 0.7627126717317518,
        },
      ],
      region: "australia",
    },
    {
      id: "finland",
      dots: [
        {
          id: "8",
          x: 0.5339011730179475,
          y: 0.20338599607334912,
        },
        {
          id: "5",
          x: 0.5423748587958749,
          y: 0.20338599607334912,
        },
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.25423465249918314,
        },
        {
          id: "6",
          x: 0.5423748587958749,
          y: 0.22033556231599638,
        },
        {
          id: "3",
          x: 0.5508506596745385,
          y: 0.2372851074075898,
        },
        {
          id: "4",
          x: 0.5423748587958749,
          y: 0.1864364509817558,
        },
        {
          id: "9",
          x: 0.5339011730179475,
          y: 0.22033556231599638,
        },
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.25423465249918314,
        },
        {
          id: "7",
          x: 0.5423748587958749,
          y: 0.2372851074075898,
        },
        {
          id: "10",
          x: 0.5339011730179475,
          y: 0.2372851074075898,
        },
        {
          id: "2",
          x: 0.5508506596745385,
          y: 0.22033556231599638,
        },
      ],
      region: "europe",
    },
    {
      id: "france",
      dots: [
        {
          id: "7",
          x: 0.47457458555870136,
          y: 0.37287941648810946,
        },
        {
          id: "2",
          x: 0.4830526284441455,
          y: 0.38983109783614567,
        },
        {
          id: "6",
          x: 0.4576294560096273,
          y: 0.35592980794335444,
        },
        {
          id: "8",
          x: 0.4661052991903056,
          y: 0.37287941648810946,
        },
        {
          id: "1",
          x: 0.4830526284441455,
          y: 0.37287941648810946,
        },
        {
          id: "3",
          x: 0.47457458555870136,
          y: 0.3389845988178084,
        },
        {
          id: "0",
          x: 0.4830526284441455,
          y: 0.35592980794335444,
        },
        {
          id: "4",
          x: 0.47457458555870136,
          y: 0.35592980794335444,
        },
        {
          id: "9",
          x: 0.47457458555870136,
          y: 0.38983109783614567,
        },
        {
          id: "5",
          x: 0.46610534149232036,
          y: 0.35592980794335444,
        },
      ],
      region: "europe",
    },
    {
      id: "french_guiana",
      dots: [
        {
          id: "0",
          x: 0.32203432419316524,
          y: 0.6271270557343807,
        },
      ],
      region: "south_america",
    },
    {
      id: "gabon",
      dots: [
        {
          id: "2",
          x: 0.5084747433282955,
          y: 0.661013243774695,
        },
        {
          id: "1",
          x: 0.5084747433282955,
          y: 0.6440722648599267,
        },
        {
          id: "0",
          x: 0.5169516440593419,
          y: 0.6440722648599267,
        },
        {
          id: "3",
          x: 0.5000021151007363,
          y: 0.661013243774695,
        },
      ],
      region: "africa",
    },
    {
      id: "gambia",
      dots: [
        {
          id: "0",
          x: 0.4237293405420479,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "georgia",
      dots: [
        {
          id: "1",
          x: 0.5932223881213236,
          y: 0.38983109783614567,
        },
        {
          id: "0",
          x: 0.6016949740468679,
          y: 0.38983109783614567,
        },
      ],
      region: "europe",
    },
    {
      id: "germany",
      dots: [
        {
          id: "4",
          x: 0.5000021151007363,
          y: 0.3389845988178084,
        },
        {
          id: "2",
          x: 0.5084747433282955,
          y: 0.3389845988178084,
        },
        {
          id: "3",
          x: 0.5000021151007363,
          y: 0.32203291746977214,
        },
        {
          id: "1",
          x: 0.5084747433282955,
          y: 0.32203291746977214,
        },
        {
          id: "0",
          x: 0.5084747433282955,
          y: 0.30508550863462164,
        },
        {
          id: "5",
          x: 0.491524114517307,
          y: 0.32203291746977214,
        },
      ],
      region: "europe",
    },
    {
      id: "ghana",
      dots: [
        {
          id: "1",
          x: 0.4661030994855398,
          y: 0.5932258081436972,
        },
        {
          id: "2",
          x: 0.4661030994855398,
          y: 0.6101688175596388,
        },
        {
          id: "0",
          x: 0.47457458555870136,
          y: 0.5932258081436972,
        },
      ],
      region: "africa",
    },
    {
      id: "greece",
      dots: [
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.42372811521605125,
        },
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.42372811521605125,
        },
      ],
      region: "europe",
    },
    {
      id: "greenland",
      dots: [
        {
          id: "55",
          x: 0.3813544394441583,
          y: 0.1864364509817558,
        },
        {
          id: "70",
          x: 0.36440711019031846,
          y: 0.016947377108569712,
        },
        {
          id: "83",
          x: 0.355932366862023,
          y: 0.03389693277569003,
        },
        {
          id: "146",
          x: 0.32203432419316524,
          y: 0.13559213052196908,
        },
        {
          id: "69",
          x: 0.36440711019031846,
          y: 0,
        },
        {
          id: "38",
          x: 0.38983134017520477,
          y: 0.10169299803667456,
        },
        {
          id: "58",
          x: 0.3728818535186139,
          y: 0.03389693277569003,
        },
        {
          id: "40",
          x: 0.38983134017520477,
          y: 0.13559213052196908,
        },
        {
          id: "42",
          x: 0.38983134017520477,
          y: 0.1694912418562097,
        },
        {
          id: "30",
          x: 0.3983050259531321,
          y: 0.15254167561356247,
        },
        {
          id: "68",
          x: 0.3728818535186139,
          y: 0.20338599607334912,
        },
        {
          id: "66",
          x: 0.3728818535186139,
          y: 0.1694912418562097,
        },
        {
          id: "63",
          x: 0.3728818535186139,
          y: 0.11864256427932182,
          radius: 2.2171903107915156,
        },
        {
          id: "88",
          x: 0.355932366862023,
          y: 0.11864256427932182,
        },
        {
          id: "71",
          x: 0.36440711019031846,
          y: 0.03389693277569003,
        },
        {
          id: "29",
          x: 0.3983050259531321,
          y: 0.13559213052196908,
        },
        {
          id: "0",
          x: 0.44067882719863877,
          y: 0.03389693277569003,
        },
        {
          id: "1",
          x: 0.4322040838703433,
          y: 0.03389693277569003,
        },
        {
          id: "33",
          x: 0.38983134017520477,
          y: 0.016947377108569712,
        },
        {
          id: "15",
          x: 0.4067819689861933,
          y: 0.0847456315036318,
        },
        {
          id: "86",
          x: 0.355932366862023,
          y: 0.0847456315036318,
        },
        {
          id: "74",
          x: 0.36440711019031846,
          y: 0.0847456315036318,
        },
        {
          id: "52",
          x: 0.3813544394441583,
          y: 0.13559213052196908,
        },
        {
          id: "44",
          x: 0.3813544394441583,
          y: 0,
        },
        {
          id: "41",
          x: 0.38983134017520477,
          y: 0.15254167561356247,
        },
        {
          id: "8",
          x: 0.41525459721375235,
          y: 0.0847456315036318,
        },
        {
          id: "14",
          x: 0.4067819689861933,
          y: 0.06779388670243394,
        },
        {
          id: "64",
          x: 0.3728818535186139,
          y: 0.13559213052196908,
        },
        {
          id: "72",
          x: 0.36440711019031846,
          y: 0.05084649901833728,
        },
        {
          id: "4",
          x: 0.41525459721375235,
          y: 0.016947387684096656,
        },
        {
          id: "48",
          x: 0.3813544394441583,
          y: 0.06779388670243394,
        },
        {
          id: "60",
          x: 0.3728818535186139,
          y: 0.06779388670243394,
        },
        {
          id: "27",
          x: 0.3983050259531321,
          y: 0.10169299803667456,
        },
        {
          id: "82",
          x: 0.355932366862023,
          y: 0.016947377108569712,
        },
        {
          id: "17",
          x: 0.4067819689861933,
          y: 0.11864256427932182,
        },
        {
          id: "73",
          x: 0.36440711019031846,
          y: 0.06779388670243394,
        },
        {
          id: "61",
          x: 0.3728818535186139,
          y: 0.0847456315036318,
        },
        {
          id: "7",
          x: 0.41525459721375235,
          y: 0.06779388670243394,
        },
        {
          id: "24",
          x: 0.3983050259531321,
          y: 0.05084649901833728,
        },
        {
          id: "34",
          x: 0.38983134017520477,
          y: 0.03389693277569003,
        },
        {
          id: "13",
          x: 0.4067819689861933,
          y: 0.05084649901833728,
        },
        {
          id: "43",
          x: 0.38983134017520477,
          y: 0.1864364509817558,
        },
        {
          id: "62",
          x: 0.3728818535186139,
          y: 0.10169299803667456,
        },
        {
          id: "85",
          x: 0.355932366862023,
          y: 0.06779388670243394,
        },
        {
          id: "22",
          x: 0.3983050259531321,
          y: 0.016947377108569712,
        },
        {
          id: "49",
          x: 0.3813544394441583,
          y: 0.0847456315036318,
        },
        {
          id: "21",
          x: 0.3983050259531321,
          y: 0,
        },
        {
          id: "35",
          x: 0.38983134017520477,
          y: 0.05084649901833728,
        },
        {
          id: "123",
          x: 0.33898389545378554,
          y: 0.22033556231599638,
        },
        {
          id: "37",
          x: 0.38983134017520477,
          y: 0.0847456315036318,
        },
        {
          id: "93",
          x: 0.355932366862023,
          y: 0.20338599607334912,
        },
        {
          id: "128",
          x: 0.33050910982347537,
          y: 0.05084649901833728,
        },
        {
          id: "119",
          x: 0.33898389545378554,
          y: 0.15254167561356247,
          radius: 2.806834733298233,
        },
        {
          id: "122",
          x: 0.33898389545378554,
          y: 0.20338599607334912,
        },
        {
          id: "121",
          x: 0.33898389545378554,
          y: 0.1864364509817558,
        },
        {
          id: "92",
          x: 0.355932366862023,
          y: 0.1864364509817558,
        },
        {
          id: "132",
          x: 0.33050910982347537,
          y: 0.11864256427932182,
        },
        {
          id: "116",
          x: 0.33898389545378554,
          y: 0.10169299803667456,
        },
        {
          id: "118",
          x: 0.33898389545378554,
          y: 0.13559213052196908,
        },
        {
          id: "95",
          x: 0.355932366862023,
          y: 0.2372851074075898,
        },
        {
          id: "129",
          x: 0.33050910982347537,
          y: 0.06779388670243394,
        },
        {
          id: "109",
          x: 0.34745758123171283,
          y: 0.2372851074075898,
          color: "#DB4437",
        },
        {
          id: "99",
          x: 0.34745758123171283,
          y: 0.06779388670243394,
        },
        {
          id: "101",
          x: 0.34745758123171283,
          y: 0.10169299803667456,
        },
        {
          id: "124",
          x: 0.33898389545378554,
          y: 0.2372851074075898,
        },
        {
          id: "127",
          x: 0.33050910982347537,
          y: 0.03389693277569003,
        },
        {
          id: "138",
          x: 0.33050910982347537,
          y: 0.22033556231599638,
        },
        {
          id: "107",
          x: 0.34745758123171283,
          y: 0.20338599607334912,
        },
        {
          id: "125",
          x: 0.33898389545378554,
          y: 0.25423465249918314,
        },
        {
          id: "115",
          x: 0.33898389545378554,
          y: 0.0847456315036318,
        },
        {
          id: "112",
          x: 0.33898389545378554,
          y: 0.03389693277569003,
        },
        {
          id: "159",
          x: 0.30508483753657434,
          y: 0.06779388670243394,
        },
        {
          id: "168",
          x: 0.2881364507323663,
          y: 0.05084649901833728,
        },
        {
          id: "134",
          x: 0.33050910982347537,
          y: 0.15254167561356247,
        },
        {
          id: "176",
          x: 0.27118687947174597,
          y: 0.0847456315036318,
        },
        {
          id: "120",
          x: 0.33898389545378554,
          y: 0.1694912418562097,
        },
        {
          id: "111",
          x: 0.33898389545378554,
          y: 0.016947387684096656,
        },
        {
          id: "140",
          x: 0.32203432419316524,
          y: 0.03389693277569003,
        },
        {
          id: "164",
          x: 0.296611151758647,
          y: 0.06779388670243394,
        },
        {
          id: "106",
          x: 0.34745758123171283,
          y: 0.1864364509817558,
        },
        {
          id: "148",
          x: 0.32203432419316524,
          y: 0.1694912418562097,
        },
        {
          id: "143",
          x: 0.32203432419316524,
          y: 0.0847456315036318,
        },
        {
          id: "152",
          x: 0.3135607230192674,
          y: 0.05084649901833728,
        },
        {
          id: "137",
          x: 0.33050910982347537,
          y: 0.20338599607334912,
        },
        {
          id: "113",
          x: 0.33898389545378554,
          y: 0.05084649901833728,
        },
        {
          id: "160",
          x: 0.30508483753657434,
          y: 0.0847456315036318,
        },
        {
          id: "136",
          x: 0.33050910982347537,
          y: 0.1864364509817558,
        },
        {
          id: "133",
          x: 0.33050910982347537,
          y: 0.13559213052196908,
        },
        {
          id: "167",
          x: 0.2881364507323663,
          y: 0.03389693277569003,
        },
        {
          id: "130",
          x: 0.33050910982347537,
          y: 0.0847456315036318,
        },
        {
          id: "98",
          x: 0.34745758123171283,
          y: 0.05084649901833728,
        },
        {
          id: "170",
          x: 0.2881364507323663,
          y: 0.0847456315036318,
        },
        {
          id: "102",
          x: 0.34745758123171283,
          y: 0.11864256427932182,
        },
        {
          id: "147",
          x: 0.32203432419316524,
          y: 0.15254167561356247,
        },
        {
          id: "166",
          x: 0.296611151758647,
          y: 0.10169299803667456,
        },
        {
          id: "114",
          x: 0.33898389545378554,
          y: 0.06779388670243394,
        },
        {
          id: "174",
          x: 0.27966166510205615,
          y: 0.10169299803667456,
        },
        {
          id: "175",
          x: 0.27118687947174597,
          y: 0.06779388670243394,
        },
        {
          id: "91",
          x: 0.355932366862023,
          y: 0.1694912418562097,
        },
        {
          id: "97",
          x: 0.34745758123171283,
          y: 0.03389693277569003,
        },
        {
          id: "141",
          x: 0.32203432419316524,
          y: 0.05084649901833728,
        },
        {
          id: "165",
          x: 0.296611151758647,
          y: 0.0847456315036318,
        },
        {
          id: "157",
          x: 0.30508483753657434,
          y: 0.03389693277569003,
        },
        {
          id: "151",
          x: 0.3135607230192674,
          y: 0.03389693277569003,
        },
        {
          id: "149",
          x: 0.32203432419316524,
          y: 0.1864364509817558,
        },
        {
          id: "131",
          x: 0.33050910982347537,
          y: 0.10169299803667456,
        },
        {
          id: "108",
          x: 0.34745758123171283,
          y: 0.22033556231599638,
        },
        {
          id: "161",
          x: 0.30508483753657434,
          y: 0.10169299803667456,
        },
        {
          id: "81",
          x: 0.36440711019031846,
          y: 0.20338599607334912,
        },
        {
          id: "54",
          x: 0.3813544394441583,
          y: 0.1694912418562097,
        },
        {
          id: "87",
          x: 0.355932366862023,
          y: 0.10169299803667456,
        },
        {
          id: "65",
          x: 0.3728818535186139,
          y: 0.15254167561356247,
        },
        {
          id: "10",
          x: 0.41525459721375235,
          y: 0.11864256427932182,
          color: "#F4B400",
        },
        {
          id: "76",
          x: 0.36440711019031846,
          y: 0.11864256427932182,
        },
        {
          id: "77",
          x: 0.36440711019031846,
          y: 0.13559213052196908,
        },
        {
          id: "59",
          x: 0.3728818535186139,
          y: 0.05084649901833728,
        },
        {
          id: "46",
          x: 0.3813544394441583,
          y: 0.03389693277569003,
        },
        {
          id: "57",
          x: 0.3728818535186139,
          y: 0.016947377108569712,
        },
        {
          id: "142",
          x: 0.32203432419316524,
          y: 0.06779388670243394,
          radius: 2.0366382940268712,
        },
        {
          id: "56",
          x: 0.3728818535186139,
          y: 0,
        },
        {
          id: "100",
          x: 0.34745758123171283,
          y: 0.0847456315036318,
        },
        {
          id: "139",
          x: 0.33050910982347537,
          y: 0.2372851074075898,
        },
        {
          id: "135",
          x: 0.33050910982347537,
          y: 0.1694912418562097,
        },
        {
          id: "78",
          x: 0.36440711019031846,
          y: 0.15254167561356247,
        },
        {
          id: "11",
          x: 0.4067819689861933,
          y: 0.016947377108569712,
        },
        {
          id: "19",
          x: 0.4067819689861933,
          y: 0.15254167561356247,
        },
        {
          id: "28",
          x: 0.3983050259531321,
          y: 0.11864256427932182,
        },
        {
          id: "25",
          x: 0.3983050259531321,
          y: 0.06779388670243394,
        },
        {
          id: "155",
          x: 0.3135607230192674,
          y: 0.10169299803667456,
        },
        {
          id: "96",
          x: 0.34745758123171283,
          y: 0.016947377108569712,
        },
        {
          id: "2",
          x: 0.4237293405420479,
          y: 0.03389693277569003,
        },
        {
          id: "94",
          x: 0.355932366862023,
          y: 0.22033556231599638,
        },
        {
          id: "23",
          x: 0.3983050259531321,
          y: 0.03389693277569003,
        },
        {
          id: "144",
          x: 0.32203432419316524,
          y: 0.10169299803667456,
        },
        {
          id: "163",
          x: 0.296611151758647,
          y: 0.05084649901833728,
        },
        {
          id: "39",
          x: 0.38983134017520477,
          y: 0.11864256427932182,
        },
        {
          id: "18",
          x: 0.4067819689861933,
          y: 0.13559213052196908,
        },
        {
          id: "36",
          x: 0.38983134017520477,
          y: 0.06779388670243394,
        },
        {
          id: "104",
          x: 0.34745758123171283,
          y: 0.15254167561356247,
        },
        {
          id: "117",
          x: 0.33898389545378554,
          y: 0.11864256427932182,
        },
        {
          id: "3",
          x: 0.4237293405420479,
          y: 0.05084649901833728,
        },
        {
          id: "105",
          x: 0.34745758123171283,
          y: 0.1694912418562097,
        },
        {
          id: "158",
          x: 0.30508483753657434,
          y: 0.05084649901833728,
        },
        {
          id: "90",
          x: 0.355932366862023,
          y: 0.15254167561356247,
        },
        {
          id: "12",
          x: 0.4067819689861933,
          y: 0.03389693277569003,
        },
        {
          id: "31",
          x: 0.3983050259531321,
          y: 0.1694912418562097,
        },
        {
          id: "5",
          x: 0.41525459721375235,
          y: 0.03389693277569003,
        },
        {
          id: "9",
          x: 0.41525459721375235,
          y: 0.10169299803667456,
        },
        {
          id: "26",
          x: 0.3983050259531321,
          y: 0.0847456315036318,
        },
        {
          id: "20",
          x: 0.4067819689861933,
          y: 0.1694912418562097,
        },
        {
          id: "110",
          x: 0.34745758123171283,
          y: 0.25423465249918314,
          radius: 2.8382964244060584,
        },
        {
          id: "32",
          x: 0.38983134017520477,
          y: 0,
        },
        {
          id: "6",
          x: 0.41525459721375235,
          y: 0.05084649901833728,
        },
        {
          id: "145",
          x: 0.32203432419316524,
          y: 0.11864256427932182,
          radius: 2.5392988822533322,
        },
        {
          id: "103",
          x: 0.34745758123171283,
          y: 0.13559213052196908,
        },
        {
          id: "153",
          x: 0.3135607230192674,
          y: 0.06779388670243394,
        },
        {
          id: "16",
          x: 0.4067819689861933,
          y: 0.10169299803667456,
        },
        {
          id: "80",
          x: 0.36440711019031846,
          y: 0.1864364509817558,
        },
        {
          id: "156",
          x: 0.3135607230192674,
          y: 0.11864256427932182,
        },
        {
          id: "45",
          x: 0.3813544394441583,
          y: 0.016947377108569712,
        },
        {
          id: "53",
          x: 0.3813544394441583,
          y: 0.15254167561356247,
        },
        {
          id: "150",
          x: 0.32203432419316524,
          y: 0.20338599607334912,
        },
        {
          id: "126",
          x: 0.33050910982347537,
          y: 0.016947377108569712,
          radius: 2.368556908714096,
        },
        {
          id: "84",
          x: 0.355932366862023,
          y: 0.05084649901833728,
        },
        {
          id: "47",
          x: 0.3813544394441583,
          y: 0.05084649901833728,
        },
        {
          id: "89",
          x: 0.355932366862023,
          y: 0.13559213052196908,
        },
        {
          id: "169",
          x: 0.2881364507323663,
          y: 0.06779388670243394,
        },
        {
          id: "173",
          x: 0.27966166510205615,
          y: 0.0847456315036318,
        },
        {
          id: "50",
          x: 0.3813544394441583,
          y: 0.10169299803667456,
        },
        {
          id: "67",
          x: 0.3728818535186139,
          y: 0.1864364509817558,
        },
        {
          id: "172",
          x: 0.27966166510205615,
          y: 0.06779388670243394,
        },
        {
          id: "75",
          x: 0.36440711019031846,
          y: 0.10169299803667456,
        },
        {
          id: "154",
          x: 0.3135607230192674,
          y: 0.0847456315036318,
        },
        {
          id: "79",
          x: 0.36440711019031846,
          y: 0.1694912418562097,
        },
        {
          id: "171",
          x: 0.2881364507323663,
          y: 0.10169299803667456,
        },
        {
          id: "51",
          x: 0.3813544394441583,
          y: 0.11864256427932182,
        },
        {
          id: "162",
          x: 0.296611151758647,
          y: 0.03389693277569003,
        },
      ],
      region: "north_america",
    },
    {
      id: "guatemala",
      dots: [
        {
          id: "0",
          x: 0.2203404923006949,
          y: 0.5593288753680071,
        },
      ],
      region: "south_america",
    },
    {
      id: "guinea_bissau",
      dots: [
        {
          id: "0",
          x: 0.4322040838703433,
          y: 0.5932258081436972,
        },
      ],
      region: "africa",
    },
    {
      id: "guyana",
      dots: [
        {
          id: "0",
          x: 0.30508483753657434,
          y: 0.6101688175596388,
        },
        {
          id: "1",
          x: 0.30508483753657434,
          y: 0.6271270557343807,
        },
      ],
      region: "south_america",
    },
    {
      id: "haiti",
      dots: [
        {
          id: "0",
          x: 0.2627121361434505,
          y: 0.5423706371932654,
        },
      ],
      region: "south_america",
    },
    {
      id: "honduras",
      dots: [
        {
          id: "1",
          x: 0.22881523562899034,
          y: 0.5593288753680071,
        },
        {
          id: "0",
          x: 0.23728892140691765,
          y: 0.5593288753680071,
        },
      ],
      region: "south_america",
    },
    {
      id: "hungary",
      dots: [
        {
          id: "0",
          x: 0.5339011730179475,
          y: 0.35592980794335444,
          color: "#A566FF",
        },
        {
          id: "1",
          x: 0.5254253298372692,
          y: 0.35592980794335444,
        },
      ],
      region: "europe",
    },
    {
      id: "iceland",
      dots: [
        {
          id: "2",
          x: 0.4152545549117377,
          y: 0.22033556231599638,
        },
        {
          id: "3",
          x: 0.4067819689861933,
          y: 0.20338599607334912,
        },
        {
          id: "1",
          x: 0.4152545549117377,
          y: 0.20338599607334912,
        },
        {
          id: "0",
          x: 0.423731497944799,
          y: 0.20338599607334912,
        },
        {
          id: "4",
          x: 0.4067819689861933,
          y: 0.22033556231599638,
        },
      ],
      region: "europe",
    },
    {
      id: "india",
      dots: [
        {
          id: "34",
          x: 0.6779655912028054,
          y: 0.5084715047079709,
        },
        {
          id: "19",
          x: 0.6949151624634257,
          y: 0.5254297851848204,
        },
        {
          id: "26",
          x: 0.6864424919338519,
          y: 0.4745745719322808,
        },
        {
          id: "15",
          x: 0.6949151624634257,
          y: 0.4576315202142314,
        },
        {
          id: "29",
          x: 0.6864424919338519,
          y: 0.5254297851848204,
        },
        {
          id: "0",
          x: 0.7457648068896107,
          y: 0.4915284529899215,
        },
        {
          id: "33",
          x: 0.6779655912028054,
          y: 0.4915284529899215,
        },
        {
          id: "20",
          x: 0.6949151624634257,
          y: 0.5423706371932654,
        },
        {
          id: "8",
          x: 0.7033920631944722,
          y: 0.4915284529899215,
        },
        {
          id: "1",
          x: 0.7372878215545348,
          y: 0.4915284529899215,
        },
        {
          id: "16",
          x: 0.6949151624634257,
          y: 0.4745745719322808,
        },
        {
          id: "37",
          x: 0.6694941051296439,
          y: 0.5084715047079709,
        },
        {
          id: "25",
          x: 0.6864424919338519,
          y: 0.4576315202142314,
        },
        {
          id: "2",
          x: 0.7372878215545348,
          y: 0.5084715047079709,
        },
        {
          id: "30",
          x: 0.6864424919338519,
          y: 0.5423706371932654,
        },
        {
          id: "35",
          x: 0.6779655912028054,
          y: 0.5254297851848204,
        },
        {
          id: "14",
          x: 0.6949151624634257,
          y: 0.4406819962736919,
        },
        {
          id: "17",
          x: 0.6949151624634257,
          y: 0.4915284529899215,
        },
        {
          id: "7",
          x: 0.7118646491200166,
          y: 0.5423706371932654,
        },
        {
          id: "10",
          x: 0.7033920631944722,
          y: 0.5254297851848204,
        },
        {
          id: "28",
          x: 0.6864424919338519,
          y: 0.5084715047079709,
        },
        {
          id: "32",
          x: 0.6864424919338519,
          y: 0.5762740844935532,
        },
        {
          id: "13",
          x: 0.7033920631944722,
          y: 0.5762740844935532,
        },
        {
          id: "6",
          x: 0.7118646491200166,
          y: 0.5254297851848204,
          radius: 2.447607419349948,
        },
        {
          id: "12",
          x: 0.7033920631944722,
          y: 0.5593288753680071,
        },
        {
          id: "21",
          x: 0.6949151624634257,
          y: 0.5593288753680071,
        },
        {
          id: "11",
          x: 0.7033920631944722,
          y: 0.5423706371932654,
        },
        {
          id: "18",
          x: 0.6949151624634257,
          y: 0.5084715047079709,
        },
        {
          id: "3",
          x: 0.720341549851063,
          y: 0.5084715047079709,
          color: "#F4B400",
        },
        {
          id: "9",
          x: 0.7033920631944722,
          y: 0.5084715047079709,
        },
        {
          id: "22",
          x: 0.6949151624634257,
          y: 0.5762740844935532,
        },
        {
          id: "31",
          x: 0.6864424919338519,
          y: 0.5593288753680071,
          color: "#A566FF",
        },
        {
          id: "23",
          x: 0.6949151624634257,
          y: 0.5932258081436972,
        },
        {
          id: "24",
          x: 0.6864424919338519,
          y: 0.4406819962736919,
        },
        {
          id: "4",
          x: 0.720341549851063,
          y: 0.5254297851848204,
        },
        {
          id: "36",
          x: 0.6694941051296439,
          y: 0.5254297851848204,
        },
        {
          id: "5",
          x: 0.7118646491200166,
          y: 0.5084715047079709,
        },
        {
          id: "27",
          x: 0.6864424919338519,
          y: 0.4915284529899215,
        },
      ],
      region: "asia",
    },
    {
      id: "indonesia",
      dots: [
        {
          id: "37",
          x: 0.7796638648068219,
          y: 0.6949144913653784,
        },
        {
          id: "7",
          x: 0.8559344819627593,
          y: 0.6779692822398323,
        },
        {
          id: "32",
          x: 0.7966122516110299,
          y: 0.6949144913653784,
        },
        {
          id: "2",
          x: 0.8728839686193501,
          y: 0.6949144913653784,
        },
        {
          id: "38",
          x: 0.7711868794717459,
          y: 0.661013243774695,
        },
        {
          id: "14",
          x: 0.830508094575122,
          y: 0.661013243774695,
        },
        {
          id: "16",
          x: 0.830508094575122,
          y: 0.6949144913653784,
        },
        {
          id: "18",
          x: 0.8220344087971947,
          y: 0.661013243774695,
        },
        {
          id: "17",
          x: 0.8220344087971947,
          y: 0.6440722648599267,
        },
        {
          id: "11",
          x: 0.8389838954537855,
          y: 0.6440722648599267,
        },
        {
          id: "23",
          x: 0.8135585233145016,
          y: 0.6779692822398323,
        },
        {
          id: "9",
          x: 0.8474575812317129,
          y: 0.661013243774695,
        },
        {
          id: "26",
          x: 0.8050848375365743,
          y: 0.6271270557343807,
        },
        {
          id: "0",
          x: 0.8728839686193501,
          y: 0.661013243774695,
        },
        {
          id: "5",
          x: 0.8644071524923332,
          y: 0.6949144913653784,
        },
        {
          id: "25",
          x: 0.8135585233145016,
          y: 0.7118684147251269,
        },
        {
          id: "27",
          x: 0.8050848375365743,
          y: 0.6440722648599267,
        },
        {
          id: "29",
          x: 0.8050848375365743,
          y: 0.6949144913653784,
        },
        {
          id: "31",
          x: 0.7966122516110299,
          y: 0.661013243774695,
        },
        {
          id: "44",
          x: 0.7457648068896107,
          y: 0.6271270557343807,
        },
        {
          id: "41",
          x: 0.7627142935462016,
          y: 0.661013243774695,
        },
        {
          id: "20",
          x: 0.8220344087971947,
          y: 0.6949144913653784,
        },
        {
          id: "43",
          x: 0.7542373082111256,
          y: 0.6440722648599267,
        },
        {
          id: "13",
          x: 0.830508094575122,
          y: 0.6440722648599267,
        },
        {
          id: "40",
          x: 0.7627142935462016,
          y: 0.6440722648599267,
        },
        {
          id: "4",
          x: 0.8644071524923332,
          y: 0.6779692822398323,
        },
        {
          id: "39",
          x: 0.7711868794717459,
          y: 0.6779692822398323,
        },
        {
          id: "21",
          x: 0.8135585233145016,
          y: 0.6440722648599267,
        },
        {
          id: "24",
          x: 0.8135585233145016,
          y: 0.6949144913653784,
        },
        {
          id: "1",
          x: 0.8728839686193501,
          y: 0.6779692822398323,
        },
        {
          id: "3",
          x: 0.8644071524923332,
          y: 0.661013243774695,
        },
        {
          id: "30",
          x: 0.7966122516110299,
          y: 0.6440722648599267,
        },
        {
          id: "35",
          x: 0.7881353508799834,
          y: 0.6949144913653784,
        },
        {
          id: "34",
          x: 0.7881353508799834,
          y: 0.661013243774695,
          color: "#A566FF",
        },
        {
          id: "19",
          x: 0.8220344087971947,
          y: 0.6779692822398323,
        },
        {
          id: "15",
          x: 0.830508094575122,
          y: 0.6779692822398323,
        },
        {
          id: "6",
          x: 0.8559344819627593,
          y: 0.661013243774695,
        },
        {
          id: "42",
          x: 0.7542373082111256,
          y: 0.6271270557343807,
        },
        {
          id: "12",
          x: 0.8389838954537855,
          y: 0.661013243774695,
          radius: 2.0941007888428853,
        },
        {
          id: "33",
          x: 0.7881353508799834,
          y: 0.6440722648599267,
        },
        {
          id: "10",
          x: 0.8474575812317129,
          y: 0.6949144913653784,
        },
        {
          id: "36",
          x: 0.7796638648068219,
          y: 0.6779692822398323,
        },
        {
          id: "28",
          x: 0.8050848375365743,
          y: 0.661013243774695,
        },
        {
          id: "8",
          x: 0.8559344819627593,
          y: 0.6949144913653784,
        },
        {
          id: "22",
          x: 0.8135585233145016,
          y: 0.661013243774695,
        },
      ],
      region: "asia",
    },
    {
      id: "iran",
      dots: [
        {
          id: "18",
          x: 0.6186444607034589,
          y: 0.4576315202142314,
        },
        {
          id: "9",
          x: 0.6355951318164621,
          y: 0.4406819962736919,
        },
        {
          id: "16",
          x: 0.6271213614345054,
          y: 0.4915284529899215,
        },
        {
          id: "21",
          x: 0.610171790173885,
          y: 0.4576315202142314,
        },
        {
          id: "20",
          x: 0.610171790173885,
          y: 0.4406819962736919,
        },
        {
          id: "8",
          x: 0.6016949740468679,
          y: 0.42372811521605125,
        },
        {
          id: "14",
          x: 0.6271213614345054,
          y: 0.4576315202142314,
        },
        {
          id: "7",
          x: 0.610171790173885,
          y: 0.42372811521605125,
        },
        {
          id: "17",
          x: 0.6186444607034589,
          y: 0.4406819962736919,
        },
        {
          id: "6",
          x: 0.6186444607034589,
          y: 0.42372811521605125,
        },
        {
          id: "13",
          x: 0.6271213614345054,
          y: 0.4406819962736919,
        },
        {
          id: "11",
          x: 0.6355951318164621,
          y: 0.4745745719322808,
        },
        {
          id: "12",
          x: 0.6355951318164621,
          y: 0.4915284529899215,
        },
        {
          id: "5",
          x: 0.6271213614345054,
          y: 0.42372811521605125,
        },
        {
          id: "4",
          x: 0.6355951318164621,
          y: 0.42372811521605125,
        },
        {
          id: "15",
          x: 0.6271213614345054,
          y: 0.4745745719322808,
        },
        {
          id: "3",
          x: 0.6440677177420064,
          y: 0.4915284529899215,
        },
        {
          id: "10",
          x: 0.6355951318164621,
          y: 0.4576315202142314,
        },
        {
          id: "2",
          x: 0.6440677177420064,
          y: 0.4745745719322808,
        },
        {
          id: "1",
          x: 0.6440677177420064,
          y: 0.4576315202142314,
        },
        {
          id: "19",
          x: 0.6186444607034589,
          y: 0.4745745719322808,
        },
        {
          id: "0",
          x: 0.6440677177420064,
          y: 0.4406819962736919,
        },
      ],
      region: "middle_east",
    },
    {
      id: "iraq",
      dots: [
        {
          id: "1",
          x: 0.6016949740468679,
          y: 0.4576315202142314,
        },
        {
          id: "0",
          x: 0.6016949740468679,
          y: 0.4406819962736919,
        },
        {
          id: "3",
          x: 0.5932223881213236,
          y: 0.4406819962736919,
        },
        {
          id: "2",
          x: 0.6016949740468679,
          y: 0.4745745719322808,
        },
        {
          id: "4",
          x: 0.5932223881213236,
          y: 0.4576315202142314,
        },
      ],
      region: "middle_east",
    },
    {
      id: "ireland",
      dots: [
        {
          id: "0",
          x: 0.4491557279296852,
          y: 0.30508550863462164,
        },
        {
          id: "1",
          x: 0.4406809846013898,
          y: 0.30508550863462164,
          color: "#DB4437",
        },
      ],
      region: "europe",
    },
    {
      id: "israel",
      dots: [
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.4745745719322808,
        },
      ],
      region: "middle_east",
    },
    {
      id: "italy",
      dots: [
        {
          id: "3",
          x: 0.5169516440593419,
          y: 0.42372811521605125,
          color: "#DB4437",
        },
        {
          id: "2",
          x: 0.5169516440593419,
          y: 0.3886243456075437,
          color: "#F4B400",
        },
        {
          id: "1",
          x: 0.5169516440593419,
          y: 0.4067785066712962,
        },
        {
          id: "0",
          x: 0.491524114517307,
          y: 0.37287941648810946,
        },
        {
          id: "6",
          x: 0.5084747433282955,
          y: 0.37287941648810946,
        },
        {
          id: "4",
          x: 0.5084747433282955,
          y: 0.38983109783614567,
        },
        {
          id: "5",
          x: 0.5084747433282955,
          y: 0.42372811521605125,
        },
        {
          id: "7",
          x: 0.5000021151007363,
          y: 0.37287941648810946,
        },
      ],
      region: "europe",
    },
    {
      id: "jamaica",
      dots: [
        {
          id: "0",
          x: 0.2542373928151551,
          y: 0.5423706371932654,
        },
      ],
      region: "south_america",
    },
    {
      id: "japan",
      dots: [
        {
          id: "5",
          x: 0.8728839686193501,
          y: 0.4406819962736919,
        },
        {
          id: "6",
          x: 0.8644071524923332,
          y: 0.42372811521605125,
          color: "#2EB67D",
        },
        {
          id: "4",
          x: 0.8728839686193501,
          y: 0.42372811521605125,
          radius: 2.0263290863699597,
          color: "#A566FF",
        },
        {
          id: "10",
          x: 0.8474575812317129,
          y: 0.4576315202142314,
        },
        {
          id: "9",
          x: 0.8474575812317129,
          y: 0.4406819962736919,
        },
        {
          id: "3",
          x: 0.8728839686193501,
          y: 0.4067785066712962,
          color: "#A566FF",
        },
        {
          id: "12",
          x: 0.8389838954537855,
          y: 0.4915284529899215,
        },
        {
          id: "11",
          x: 0.8474575812317129,
          y: 0.4745745719322808,
        },
        {
          id: "2",
          x: 0.8728839686193501,
          y: 0.38983109783614567,
          color: "#DB4437",
        },
        {
          id: "7",
          x: 0.8644071524923332,
          y: 0.4406819962736919,
        },
        {
          id: "1",
          x: 0.8728839686193501,
          y: 0.37287941648810946,
        },
        {
          id: "8",
          x: 0.8559344819627593,
          y: 0.4406819962736919,
          radius: 2.702721099269053,
        },
        {
          id: "0",
          x: 0.881356639148924,
          y: 0.38983109783614567,
        },
      ],
      region: "asia",
    },
    {
      id: "jordan",
      dots: [
        {
          id: "1",
          x: 0.5762728168607032,
          y: 0.4745745719322808,
        },
        {
          id: "0",
          x: 0.5847454027862475,
          y: 0.4576315202142314,
          radius: 2.8561970356665274,
        },
      ],
      region: "middle_east",
    },
    {
      id: "kazakhstan",
      dots: [
        {
          id: "25",
          x: 0.6610171197945679,
          y: 0.38983109783614567,
        },
        {
          id: "12",
          x: 0.6779655912028054,
          y: 0.37287941648810946,
        },
        {
          id: "23",
          x: 0.6610171197945679,
          y: 0.35592980794335444,
        },
        {
          id: "48",
          x: 0.6016949740468679,
          y: 0.3389845988178084,
        },
        {
          id: "11",
          x: 0.6779655912028054,
          y: 0.35592980794335444,
        },
        {
          id: "47",
          x: 0.610171790173885,
          y: 0.35592980794335444,
        },
        {
          id: "43",
          x: 0.6186444607034589,
          y: 0.37287941648810946,
        },
        {
          id: "20",
          x: 0.6694941051296439,
          y: 0.37287941648810946,
        },
        {
          id: "3",
          x: 0.7033920631944722,
          y: 0.3389845988178084,
        },
        {
          id: "59",
          x: 0.6440677177420064,
          y: 0.30508550863462164,
        },
        {
          id: "33",
          x: 0.6355951318164621,
          y: 0.32203291746977214,
        },
        {
          id: "31",
          x: 0.6440677177420064,
          y: 0.3389845988178084,
        },
        {
          id: "14",
          x: 0.6864424919338519,
          y: 0.3389845988178084,
        },
        {
          id: "22",
          x: 0.6610171197945679,
          y: 0.3389845988178084,
        },
        {
          id: "24",
          x: 0.6610171197945679,
          y: 0.37287941648810946,
        },
        {
          id: "6",
          x: 0.7033920631944722,
          y: 0.35592980794335444,
        },
        {
          id: "53",
          x: 0.6694941051296439,
          y: 0.30508550863462164,
        },
        {
          id: "28",
          x: 0.6525445338690236,
          y: 0.35592980794335444,
        },
        {
          id: "57",
          x: 0.6525445338690236,
          y: 0.30508550863462164,
        },
        {
          id: "44",
          x: 0.6186444607034589,
          y: 0.38983109783614567,
        },
        {
          id: "15",
          x: 0.6779655912028054,
          y: 0.32203291746977214,
        },
        {
          id: "38",
          x: 0.6271213614345054,
          y: 0.35592980794335444,
        },
        {
          id: "7",
          x: 0.6949151624634257,
          y: 0.35592980794335444,
        },
        {
          id: "4",
          x: 0.6949151624634257,
          y: 0.32203291746977214,
        },
        {
          id: "50",
          x: 0.6864424919338519,
          y: 0.30508550863462164,
        },
        {
          id: "32",
          x: 0.6440677177420064,
          y: 0.35592980794335444,
        },
        {
          id: "26",
          x: 0.6525445338690236,
          y: 0.32203291746977214,
        },
        {
          id: "41",
          x: 0.6186444607034589,
          y: 0.3389845988178084,
        },
        {
          id: "18",
          x: 0.6694941051296439,
          y: 0.3389845988178084,
          radius: 2.3522106067341424,
        },
        {
          id: "13",
          x: 0.6864424919338519,
          y: 0.32203291746977214,
        },
        {
          id: "58",
          x: 0.6440677177420064,
          y: 0.28813378498447767,
        },
        {
          id: "51",
          x: 0.6779655912028054,
          y: 0.30508550863462164,
        },
        {
          id: "29",
          x: 0.6525445338690236,
          y: 0.37287941648810946,
        },
        {
          id: "49",
          x: 0.6864424919338519,
          y: 0.28813378498447767,
        },
        {
          id: "40",
          x: 0.6186444607034589,
          y: 0.32203291746977214,
        },
        {
          id: "8",
          x: 0.6949151624634257,
          y: 0.37287941648810946,
        },
        {
          id: "30",
          x: 0.6440677177420064,
          y: 0.32203291746977214,
        },
        {
          id: "34",
          x: 0.6355951318164621,
          y: 0.3389845988178084,
        },
        {
          id: "39",
          x: 0.6271213614345054,
          y: 0.37287941648810946,
        },
        {
          id: "10",
          x: 0.6864424919338519,
          y: 0.37287941648810946,
        },
        {
          id: "46",
          x: 0.610171790173885,
          y: 0.3389845988178084,
        },
        {
          id: "54",
          x: 0.6610171197945679,
          y: 0.28813378498447767,
        },
        {
          id: "42",
          x: 0.6186444607034589,
          y: 0.35592980794335444,
          radius: 2.1355528170384064,
        },
        {
          id: "0",
          x: 0.7118646491200166,
          y: 0.32203291746977214,
        },
        {
          id: "55",
          x: 0.6610171197945679,
          y: 0.30508550863462164,
        },
        {
          id: "52",
          x: 0.6694941051296439,
          y: 0.28813378498447767,
        },
        {
          id: "45",
          x: 0.610171790173885,
          y: 0.32203291746977214,
        },
        {
          id: "27",
          x: 0.6525445338690236,
          y: 0.3389845988178084,
        },
        {
          id: "16",
          x: 0.6779655912028054,
          y: 0.3389845988178084,
        },
        {
          id: "2",
          x: 0.7033920631944722,
          y: 0.32203291746977214,
        },
        {
          id: "56",
          x: 0.6525445338690236,
          y: 0.28813378498447767,
          color: "#2EB67D",
        },
        {
          id: "1",
          x: 0.7118646491200166,
          y: 0.3389845988178084,
        },
        {
          id: "9",
          x: 0.6864424919338519,
          y: 0.35592980794335444,
        },
        {
          id: "19",
          x: 0.6694941051296439,
          y: 0.35592980794335444,
        },
        {
          id: "37",
          x: 0.6271213614345054,
          y: 0.3389845988178084,
        },
        {
          id: "5",
          x: 0.6949151624634257,
          y: 0.3389845988178084,
        },
        {
          id: "21",
          x: 0.6610171197945679,
          y: 0.32203291746977214,
        },
        {
          id: "17",
          x: 0.6694941051296439,
          y: 0.32203291746977214,
        },
        {
          id: "36",
          x: 0.6271213614345054,
          y: 0.32203291746977214,
          color: "#F4B400",
        },
        {
          id: "35",
          x: 0.6355951318164621,
          y: 0.35592980794335444,
        },
      ],
      region: "middle_east",
    },
    {
      id: "kenya",
      dots: [
        {
          id: "2",
          x: 0.5847454027862475,
          y: 0.661013243774695,
        },
        {
          id: "3",
          x: 0.5932223881213236,
          y: 0.6271270557343807,
        },
        {
          id: "0",
          x: 0.5932223881213236,
          y: 0.6440722648599267,
        },
        {
          id: "5",
          x: 0.5762728168607032,
          y: 0.6271270557343807,
        },
        {
          id: "1",
          x: 0.5847454027862475,
          y: 0.6440722648599267,
        },
        {
          id: "4",
          x: 0.5847454027862475,
          y: 0.6271270557343807,
        },
        {
          id: "6",
          x: 0.5762728168607032,
          y: 0.6440722648599267,
        },
      ],
      region: "africa",
    },
    {
      id: "kosovo",
      dots: [
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.38983109783614567,
        },
      ],
      region: "europe",
    },
    {
      id: "kuwait",
      dots: [
        {
          id: "0",
          x: 0.610171790173885,
          y: 0.4745745719322808,
        },
      ],
      region: "middle_east",
    },
    {
      id: "kyrgyzstan",
      dots: [
        {
          id: "0",
          x: 0.6949151624634257,
          y: 0.38983109783614567,
        },
        {
          id: "1",
          x: 0.6864424919338519,
          y: 0.38983109783614567,
        },
        {
          id: "2",
          x: 0.6779655912028054,
          y: 0.38983109783614567,
        },
      ],
      region: "middle_east",
    },
    {
      id: "laos",
      dots: [
        {
          id: "2",
          x: 0.7627142935462016,
          y: 0.5423706371932654,
        },
        {
          id: "1",
          x: 0.7627142935462016,
          y: 0.5254297851848204,
        },
        {
          id: "0",
          x: 0.7711868794717459,
          y: 0.5593288753680071,
        },
      ],
      region: "asia",
    },
    {
      id: "latvia",
      dots: [
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.28813378498447767,
        },
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.28813378498447767,
        },
      ],
      region: "europe",
    },
    {
      id: "lebanon",
      dots: [
        {
          id: "0",
          x: 0.5762728168607032,
          y: 0.4576315202142314,
        },
      ],
      region: "middle_east",
    },
    {
      id: "lesotho",
      dots: [
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.8305110213065564,
        },
      ],
      region: "africa",
    },
    {
      id: "liberia",
      dots: [
        {
          id: "0",
          x: 0.44915251297656605,
          y: 0.6271270557343807,
          color: "#DB4437",
        },
      ],
      region: "africa",
    },
    {
      id: "libya",
      dots: [
        {
          id: "4",
          x: 0.5423748587958749,
          y: 0.5254297851848204,
        },
        {
          id: "2",
          x: 0.5423748587958749,
          y: 0.4915284529899215,
        },
        {
          id: "3",
          x: 0.5423748587958749,
          y: 0.5084715047079709,
        },
        {
          id: "14",
          x: 0.5169516440593419,
          y: 0.5084715047079709,
        },
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.4745745719322808,
        },
        {
          id: "16",
          x: 0.5084747433282955,
          y: 0.4915284529899215,
        },
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.4576315202142314,
        },
        {
          id: "13",
          x: 0.5169516440593419,
          y: 0.4915284529899215,
        },
        {
          id: "9",
          x: 0.5254253298372692,
          y: 0.4745745719322808,
        },
        {
          id: "10",
          x: 0.5254253298372692,
          y: 0.4915284529899215,
        },
        {
          id: "12",
          x: 0.5169516440593419,
          y: 0.4745745719322808,
        },
        {
          id: "11",
          x: 0.5254253298372692,
          y: 0.5084715047079709,
        },
        {
          id: "5",
          x: 0.5339011730179475,
          y: 0.4576315202142314,
        },
        {
          id: "15",
          x: 0.5084747433282955,
          y: 0.4745745719322808,
        },
        {
          id: "6",
          x: 0.5339011730179475,
          y: 0.4745745719322808,
        },
        {
          id: "17",
          x: 0.5084747433282955,
          y: 0.5084715047079709,
        },
        {
          id: "8",
          x: 0.5339011730179475,
          y: 0.5084715047079709,
        },
        {
          id: "7",
          x: 0.5339011730179475,
          y: 0.4915284529899215,
        },
      ],
      region: "africa",
    },
    {
      id: "lithuania",
      dots: [
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.28813378498447767,
        },
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.30508550863462164,
        },
      ],
      region: "europe",
    },
    {
      id: "luxembourg",
      dots: [
        {
          id: "0",
          x: 0.491524114517307,
          y: 0.3389845988178084,
        },
      ],
      region: "europe",
    },
    {
      id: "macau",
      dots: [
        {
          id: "0",
          x: 0.7881353508799834,
          y: 0.5423706371932654,
        },
      ],
      region: "asia",
    },
    {
      id: "macedonia",
      dots: [
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.4067785066712962,
        },
      ],
    },
    {
      id: "madagascar",
      dots: [
        {
          id: "2",
          x: 0.610171790173885,
          y: 0.7457674626062059,
        },
        {
          id: "1",
          x: 0.610171790173885,
          y: 0.7288136238506728,
        },
        {
          id: "5",
          x: 0.6016949740468679,
          y: 0.7457674626062059,
        },
        {
          id: "3",
          x: 0.610171790173885,
          y: 0.7627126717317518,
          color: "#F4B400",
        },
        {
          id: "4",
          x: 0.610171790173885,
          y: 0.7796665950915004,
        },
        {
          id: "0",
          x: 0.6186444607034589,
          y: 0.7288136238506728,
        },
        {
          id: "6",
          x: 0.6016949740468679,
          y: 0.7627126717317518,
        },
        {
          id: "7",
          x: 0.6016949740468679,
          y: 0.7796665950915004,
        },
        {
          id: "8",
          x: 0.6016949740468679,
          y: 0.7966118042170462,
          radius: 2.5172636116153426,
        },
      ],
      region: "africa",
    },
    {
      id: "malawi",
      dots: [
        {
          id: "0",
          x: 0.5762728168607032,
          y: 0.7118684147251269,
        },
        {
          id: "1",
          x: 0.5762728168607032,
          y: 0.7288136238506728,
        },
      ],
      region: "africa",
    },
    {
      id: "malaysia",
      dots: [
        {
          id: "0",
          x: 0.7881353508799834,
          y: 0.6271270557343807,
          radius: 2.092693489250191,
        },
        {
          id: "3",
          x: 0.7627142935462016,
          y: 0.6271270557343807,
        },
        {
          id: "1",
          x: 0.8050848375365743,
          y: 0.6101688175596388,
        },
        {
          id: "4",
          x: 0.7542373082111256,
          y: 0.6101688175596388,
        },
        {
          id: "2",
          x: 0.7711868794717459,
          y: 0.6271270557343807,
        },
      ],
      region: "asia",
    },
    {
      id: "mali",
      dots: [
        {
          id: "3",
          x: 0.47457458555870136,
          y: 0.5593288753680071,
        },
        {
          id: "9",
          x: 0.45762505660009567,
          y: 0.5762740844935532,
        },
        {
          id: "1",
          x: 0.47457458555870136,
          y: 0.5254297851848204,
        },
        {
          id: "5",
          x: 0.4661030994855398,
          y: 0.5254297851848204,
        },
        {
          id: "7",
          x: 0.4661030994855398,
          y: 0.5593288753680071,
        },
        {
          id: "0",
          x: 0.4830526284441455,
          y: 0.5423706371932654,
        },
        {
          id: "6",
          x: 0.4661030994855398,
          y: 0.5423706371932654,
        },
        {
          id: "4",
          x: 0.4661030994855398,
          y: 0.5084715047079709,
        },
        {
          id: "8",
          x: 0.45762505660009567,
          y: 0.5593288753680071,
        },
        {
          id: "2",
          x: 0.47457458555870136,
          y: 0.5423706371932654,
        },
        {
          id: "11",
          x: 0.44067882719863877,
          y: 0.5593288753680071,
        },
        {
          id: "10",
          x: 0.44915251297656605,
          y: 0.5593288753680071,
        },
        {
          id: "12",
          x: 0.44067882719863877,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "mauritania",
      dots: [
        {
          id: "1",
          x: 0.45762505660009567,
          y: 0.5084715047079709,
        },
        {
          id: "0",
          x: 0.45762505660009567,
          y: 0.4915284529899215,
        },
        {
          id: "9",
          x: 0.4322040838703433,
          y: 0.5254297851848204,
        },
        {
          id: "3",
          x: 0.45762505660009567,
          y: 0.5423706371932654,
        },
        {
          id: "10",
          x: 0.4322040838703433,
          y: 0.5423706371932654,
        },
        {
          id: "5",
          x: 0.44915251297656605,
          y: 0.5254297851848204,
        },
        {
          id: "8",
          x: 0.44067882719863877,
          y: 0.5423706371932654,
        },
        {
          id: "7",
          x: 0.44067882719863877,
          y: 0.5254297851848204,
        },
        {
          id: "2",
          x: 0.45762505660009567,
          y: 0.5254297851848204,
        },
        {
          id: "6",
          x: 0.44915251297656605,
          y: 0.5423706371932654,
        },
        {
          id: "4",
          x: 0.44915251297656605,
          y: 0.5084715047079709,
        },
      ],
      region: "africa",
    },
    {
      id: "mauritius",
      dots: [
        {
          id: "0",
          x: 0.6271213614345054,
          y: 0.7621277181853885,
          radius: 2.1026674540489925,
        },
      ],
      region: "africa",
    },
    {
      id: "mexico",
      dots: [
        {
          id: "16",
          x: 0.1779667122061956,
          y: 0.4745745719322808,
        },
        {
          id: "6",
          x: 0.19491622001379386,
          y: 0.5254297851848204,
        },
        {
          id: "20",
          x: 0.16949194772689277,
          y: 0.4915284529899215,
        },
        {
          id: "4",
          x: 0.2033909633420893,
          y: 0.5423706371932654,
        },
        {
          id: "14",
          x: 0.1864414766854984,
          y: 0.4915284529899215,
          color: "#A566FF",
        },
        {
          id: "21",
          x: 0.16949194772689277,
          y: 0.5084715047079709,
        },
        {
          id: "12",
          x: 0.1779667122061956,
          y: 0.5423706371932654,
          radius: 2.17457605773912,
          color: "#F4B400",
        },
        {
          id: "8",
          x: 0.19491622001379386,
          y: 0.5593288753680071,
          radius: 2.453719098595823,
          color: "#F4B400",
        },
        {
          id: "3",
          x: 0.2118657489723995,
          y: 0.5593288753680071,
        },
        {
          id: "7",
          x: 0.19491622001379386,
          y: 0.5423706371932654,
        },
        {
          id: "2",
          x: 0.2118657489723995,
          y: 0.5423706371932654,
        },
        {
          id: "19",
          x: 0.16949194772689277,
          y: 0.4745745719322808,
        },
        {
          id: "18",
          x: 0.1779667122061956,
          y: 0.5084715047079709,
        },
        {
          id: "27",
          x: 0.14406875414136724,
          y: 0.4576315202142314,
        },
        {
          id: "26",
          x: 0.1525445761710382,
          y: 0.4915284529899215,
        },
        {
          id: "25",
          x: 0.1525445761710382,
          y: 0.4745745719322808,
        },
        {
          id: "1",
          x: 0.2203404923006949,
          y: 0.5254297851848204,
        },
        {
          id: "22",
          x: 0.1610182619489655,
          y: 0.4745745719322808,
        },
        {
          id: "17",
          x: 0.1779667122061956,
          y: 0.4915284529899215,
        },
        {
          id: "0",
          x: 0.22881523562899034,
          y: 0.5254297851848204,
          color: "#F4B400",
        },
        {
          id: "23",
          x: 0.1610182619489655,
          y: 0.4915284529899215,
        },
        {
          id: "10",
          x: 0.1864414766854984,
          y: 0.5423706371932654,
        },
        {
          id: "15",
          x: 0.1864414766854984,
          y: 0.5084715047079709,
          color: "#A566FF",
        },
        {
          id: "9",
          x: 0.1864414766854984,
          y: 0.5254297851848204,
        },
        {
          id: "24",
          x: 0.1610182619489655,
          y: 0.5084715047079709,
          radius: 2.9158366633408717,
        },
        {
          id: "13",
          x: 0.19491622001379386,
          y: 0.5084715047079709,
        },
        {
          id: "5",
          x: 0.2033909633420893,
          y: 0.5593288753680071,
        },
        {
          id: "11",
          x: 0.1779667122061956,
          y: 0.5254297851848204,
        },
      ],
      region: "south_america",
    },
    {
      id: "moldova",
      dots: [
        {
          id: "0",
          x: 0.5593233302041123,
          y: 0.35592980794335444,
        },
      ],
      region: "europe",
    },
    {
      id: "monaco",
      dots: [
        {
          id: "0",
          x: 0.491524114517307,
          y: 0.38983109783614567,
        },
      ],
      region: "europe",
    },
    {
      id: "mongolia",
      dots: [
        {
          id: "22",
          x: 0.7627142935462016,
          y: 0.35592980794335444,
          color: "#A566FF",
        },
        {
          id: "24",
          x: 0.7542373082111256,
          y: 0.35592980794335444,
        },
        {
          id: "4",
          x: 0.7711868794717459,
          y: 0.3389845988178084,
        },
        {
          id: "23",
          x: 0.7627142935462016,
          y: 0.37287941648810946,
        },
        {
          id: "14",
          x: 0.7288152356289904,
          y: 0.3389845988178084,
        },
        {
          id: "18",
          x: 0.7796638648068219,
          y: 0.35592980794335444,
        },
        {
          id: "26",
          x: 0.7457648068896107,
          y: 0.35592980794335444,
        },
        {
          id: "5",
          x: 0.7627142935462016,
          y: 0.32203291746977214,
        },
        {
          id: "11",
          x: 0.7372878215545348,
          y: 0.32203291746977214,
        },
        {
          id: "25",
          x: 0.7542373082111256,
          y: 0.37287941648810946,
          color: "#A566FF",
        },
        {
          id: "1",
          x: 0.7881353508799834,
          y: 0.3389845988178084,
        },
        {
          id: "12",
          x: 0.7372878215545348,
          y: 0.3389845988178084,
        },
        {
          id: "10",
          x: 0.7457648068896107,
          y: 0.3389845988178084,
        },
        {
          id: "3",
          x: 0.7711868794717459,
          y: 0.32203291746977214,
        },
        {
          id: "13",
          x: 0.7288152356289904,
          y: 0.32203291746977214,
        },
        {
          id: "16",
          x: 0.7881353508799834,
          y: 0.35592980794335444,
        },
        {
          id: "7",
          x: 0.7542373082111256,
          y: 0.30508550863462164,
        },
        {
          id: "28",
          x: 0.7372878215545348,
          y: 0.35592980794335444,
        },
        {
          id: "0",
          x: 0.7966122516110299,
          y: 0.3389845988178084,
        },
        {
          id: "2",
          x: 0.7796638648068219,
          y: 0.3389845988178084,
        },
        {
          id: "27",
          x: 0.7457648068896107,
          y: 0.37287941648810946,
        },
        {
          id: "6",
          x: 0.7627142935462016,
          y: 0.3389845988178084,
        },
        {
          id: "19",
          x: 0.7796638648068219,
          y: 0.37287941648810946,
        },
        {
          id: "8",
          x: 0.7542373082111256,
          y: 0.32203291746977214,
        },
        {
          id: "17",
          x: 0.7881353508799834,
          y: 0.37287941648810946,
        },
        {
          id: "21",
          x: 0.7711868794717459,
          y: 0.37287941648810946,
        },
        {
          id: "9",
          x: 0.7542373082111256,
          y: 0.3389845988178084,
        },
        {
          id: "20",
          x: 0.7711868794717459,
          y: 0.35592980794335444,
        },
        {
          id: "15",
          x: 0.7966122516110299,
          y: 0.35592980794335444,
        },
      ],
      region: "asia",
    },
    {
      id: "morocco",
      dots: [
        {
          id: "0",
          x: 0.45762505660009567,
          y: 0.4406819962736919,
        },
        {
          id: "5",
          x: 0.4661030994855398,
          y: 0.4576315202142314,
        },
        {
          id: "1",
          x: 0.44915251297656605,
          y: 0.4576315202142314,
        },
        {
          id: "4",
          x: 0.4661030994855398,
          y: 0.4406819962736919,
        },
        {
          id: "7",
          x: 0.44915251297656605,
          y: 0.4745745719322808,
        },
        {
          id: "2",
          x: 0.47457458555870136,
          y: 0.4406819962736919,
        },
        {
          id: "3",
          x: 0.47457458555870136,
          y: 0.4576315202142314,
        },
        {
          id: "6",
          x: 0.45762505660009567,
          y: 0.4576315202142314,
        },
      ],
      region: "africa",
    },
    {
      id: "mozambique",
      dots: [
        {
          id: "0",
          x: 0.5847454027862475,
          y: 0.7288136238506728,
        },
        {
          id: "2",
          x: 0.5762728168607032,
          y: 0.7457674626062059,
        },
        {
          id: "1",
          x: 0.5847454027862475,
          y: 0.7457674626062059,
        },
        {
          id: "6",
          x: 0.5677948162772738,
          y: 0.7288136238506728,
        },
        {
          id: "5",
          x: 0.5762728168607032,
          y: 0.7966118042170462,
        },
        {
          id: "3",
          x: 0.5762728168607032,
          y: 0.7627126717317518,
        },
        {
          id: "7",
          x: 0.5677948162772738,
          y: 0.7966118042170462,
        },
        {
          id: "4",
          x: 0.5762728168607032,
          y: 0.7796665950915004,
        },
      ],
      region: "africa",
    },
    {
      id: "namibia",
      dots: [
        {
          id: "4",
          x: 0.5169516440593419,
          y: 0.7627126717317518,
        },
        {
          id: "3",
          x: 0.5254253298372692,
          y: 0.8135592130521969,
        },
        {
          id: "2",
          x: 0.5254253298372692,
          y: 0.7966118042170462,
        },
        {
          id: "1",
          x: 0.5254253298372692,
          y: 0.7796665950915004,
        },
        {
          id: "0",
          x: 0.5254253298372692,
          y: 0.7627126717317518,
        },
        {
          id: "6",
          x: 0.5169516440593419,
          y: 0.7966118042170462,
        },
        {
          id: "5",
          x: 0.5169516440593419,
          y: 0.7796665950915004,
        },
      ],
      region: "africa",
    },
    {
      id: "nepal",
      dots: [
        {
          id: "2",
          x: 0.7118646491200166,
          y: 0.4915284529899215,
        },
        {
          id: "1",
          x: 0.7033920631944722,
          y: 0.4745745719322808,
        },
        {
          id: "0",
          x: 0.720341549851063,
          y: 0.4915284529899215,
        },
      ],
      region: "asia",
    },
    {
      id: "netherlands",
      dots: [
        {
          id: "0",
          x: 0.4830526284441455,
          y: 0.32203291746977214,
        },
      ],
      region: "europe",
    },
    {
      id: "new_caledonia",
      dots: [
        {
          id: "0",
          x: 0.9406777696482707,
          y: 0.7796665950915004,
        },
      ],
      region: "australia",
    },
    {
      id: "new_zealand",
      dots: [
        {
          id: "11",
          x: 0.9491545857752877,
          y: 0.9152543261942604,
        },
        {
          id: "0",
          x: 0.9830504287393796,
          y: 0.8813573934185704,
        },
        {
          id: "7",
          x: 0.9661042416399375,
          y: 0.8983113167783189,
          radius: 2.7877540372733014,
        },
        {
          id: "1",
          x: 0.9745767429614524,
          y: 0.8644099845834199,
        },
        {
          id: "2",
          x: 0.9745767429614524,
          y: 0.8813573934185704,
        },
        {
          id: "9",
          x: 0.9576272563048615,
          y: 0.9152543261942604,
        },
        {
          id: "12",
          x: 0.9491545857752877,
          y: 0.9322082495540088,
        },
        {
          id: "3",
          x: 0.9745767429614524,
          y: 0.8983113167783189,
        },
        {
          id: "6",
          x: 0.9661042416399375,
          y: 0.8813573934185704,
        },
        {
          id: "8",
          x: 0.9661042416399375,
          y: 0.9152543261942604,
        },
        {
          id: "10",
          x: 0.9576272563048615,
          y: 0.9322082495540088,
        },
        {
          id: "4",
          x: 0.9661042416399375,
          y: 0.847460545247096,
        },
        {
          id: "5",
          x: 0.9661042416399375,
          y: 0.8644099845834199,
        },
      ],
      region: "australia",
    },
    {
      id: "nicaragua",
      dots: [
        {
          id: "0",
          x: 0.23728892140691765,
          y: 0.5762740844935532,
        },
        {
          id: "1",
          x: 0.22881523562899034,
          y: 0.5762740844935532,
          color: "#A566FF",
        },
      ],
      region: "south_america",
    },
    {
      id: "niger",
      dots: [
        {
          id: "6",
          x: 0.5000021151007363,
          y: 0.5423706371932654,
        },
        {
          id: "0",
          x: 0.5169516440593419,
          y: 0.5254297851848204,
        },
        {
          id: "7",
          x: 0.5000021151007363,
          y: 0.5593288753680071,
        },
        {
          id: "9",
          x: 0.491524114517307,
          y: 0.5593288753680071,
        },
        {
          id: "1",
          x: 0.5169516440593419,
          y: 0.5423706371932654,
        },
        {
          id: "10",
          x: 0.4830526284441455,
          y: 0.5593288753680071,
        },
        {
          id: "3",
          x: 0.5084747433282955,
          y: 0.5423706371932654,
        },
        {
          id: "8",
          x: 0.491524114517307,
          y: 0.5423706371932654,
        },
        {
          id: "5",
          x: 0.5000021151007363,
          y: 0.5254297851848204,
        },
        {
          id: "4",
          x: 0.5084747433282955,
          y: 0.5593288753680071,
        },
        {
          id: "2",
          x: 0.5084747433282955,
          y: 0.5254297851848204,
        },
      ],
      region: "africa",
    },
    {
      id: "nigeria",
      dots: [
        {
          id: "0",
          x: 0.5084747433282955,
          y: 0.5762740844935532,
        },
        {
          id: "1",
          x: 0.5084747433282955,
          y: 0.5932258081436972,
        },
        {
          id: "2",
          x: 0.5000021151007363,
          y: 0.5762740844935532,
        },
        {
          id: "3",
          x: 0.5000021151007363,
          y: 0.5932258081436972,
        },
        {
          id: "4",
          x: 0.5000021151007363,
          y: 0.6101688175596388,
          color: "#A566FF",
        },
        {
          id: "5",
          x: 0.491524114517307,
          y: 0.5762740844935532,
        },
        {
          id: "6",
          x: 0.491524114517307,
          y: 0.5932258081436972,
        },
        {
          id: "7",
          x: 0.491524114517307,
          y: 0.6101688175596388,
        },
        {
          id: "8",
          x: 0.4830526284441455,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "north_korea",
      dots: [
        {
          id: "2",
          x: 0.830508094575122,
          y: 0.4067785066712962,
        },
        {
          id: "1",
          x: 0.8389838954537855,
          y: 0.4067785066712962,
        },
        {
          id: "0",
          x: 0.8389838954537855,
          y: 0.38983109783614567,
        },
      ],
      region: "asia",
    },
    {
      id: "norway",
      dots: [
        {
          id: "14",
          x: 0.491524114517307,
          y: 0.2711863761493271,
        },
        {
          id: "4",
          x: 0.5254253298372692,
          y: 0.1864364509817558,
          radius: 2.3043485780612865,
        },
        {
          id: "3",
          x: 0.5254253298372692,
          y: 0.1694912418562097,
        },
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.1694912418562097,
        },
        {
          id: "8",
          x: 0.5000021151007363,
          y: 0.22033556231599638,
        },
        {
          id: "2",
          x: 0.5339011730179475,
          y: 0.1864364509817558,
        },
        {
          id: "10",
          x: 0.5000021151007363,
          y: 0.25423465249918314,
        },
        {
          id: "6",
          x: 0.5084747433282955,
          y: 0.20338599607334912,
        },
        {
          id: "5",
          x: 0.5169516440593419,
          y: 0.1864364509817558,
        },
        {
          id: "12",
          x: 0.491524114517307,
          y: 0.2372851074075898,
        },
        {
          id: "11",
          x: 0.5000021151007363,
          y: 0.2711863761493271,
          color: "#F4B400",
        },
        {
          id: "7",
          x: 0.5084747433282955,
          y: 0.22033556231599638,
        },
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.1694912418562097,
        },
        {
          id: "9",
          x: 0.5000021151007363,
          y: 0.2372851074075898,
        },
        {
          id: "13",
          x: 0.491524114517307,
          y: 0.25423465249918314,
        },
      ],
      region: "europe",
    },
    {
      id: "oman",
      dots: [
        {
          id: "0",
          x: 0.6355951318164621,
          y: 0.5254297851848204,
        },
        {
          id: "1",
          x: 0.6271213614345054,
          y: 0.5423706371932654,
        },
      ],
      region: "middle_east",
    },
    {
      id: "pakistan",
      dots: [
        {
          id: "3",
          x: 0.6694941051296439,
          y: 0.4576315202142314,
        },
        {
          id: "0",
          x: 0.6779655912028054,
          y: 0.4406819962736919,
        },
        {
          id: "2",
          x: 0.6779655912028054,
          y: 0.4745745719322808,
        },
        {
          id: "7",
          x: 0.6610171197945679,
          y: 0.4915284529899215,
        },
        {
          id: "1",
          x: 0.6779655912028054,
          y: 0.4576315202142314,
        },
        {
          id: "4",
          x: 0.6694941051296439,
          y: 0.4745745719322808,
        },
        {
          id: "5",
          x: 0.6694941051296439,
          y: 0.4915284529899215,
        },
        {
          id: "6",
          x: 0.6610171197945679,
          y: 0.4745745719322808,
        },
        {
          id: "8",
          x: 0.6525445338690236,
          y: 0.4745745719322808,
        },
        {
          id: "9",
          x: 0.6525445338690236,
          y: 0.4915284529899215,
        },
      ],
      region: "middle_east",
    },
    {
      id: "panama",
      dots: [
        {
          id: "2",
          x: 0.24576476458759597,
          y: 0.6101688175596388,
        },
        {
          id: "1",
          x: 0.24576476458759597,
          y: 0.5932258081436972,
        },
        {
          id: "0",
          x: 0.2542373928151551,
          y: 0.5932258081436972,
        },
      ],
      region: "south_america",
    },
    {
      id: "papua_new_guinea",
      dots: [
        {
          id: "6",
          x: 0.8898334552759412,
          y: 0.6949144913653784,
        },
        {
          id: "2",
          x: 0.9067787117310594,
          y: 0.6779692822398323,
        },
        {
          id: "7",
          x: 0.881356639148924,
          y: 0.6779692822398323,
        },
        {
          id: "4",
          x: 0.8983061258055149,
          y: 0.7118684147251269,
          color: "#A566FF",
        },
        {
          id: "3",
          x: 0.8983061258055149,
          y: 0.6779692822398323,
        },
        {
          id: "8",
          x: 0.881356639148924,
          y: 0.6949144913653784,
        },
        {
          id: "5",
          x: 0.8898334552759412,
          y: 0.6779692822398323,
        },
        {
          id: "0",
          x: 0.9237282829916796,
          y: 0.6949144913653784,
          color: "#F4B400",
        },
        {
          id: "1",
          x: 0.9152545972137525,
          y: 0.6949144913653784,
        },
      ],
      region: "australia",
    },
    {
      id: "paraguay",
      dots: [
        {
          id: "5",
          x: 0.296611151758647,
          y: 0.7796665950915004,
        },
        {
          id: "2",
          x: 0.30508483753657434,
          y: 0.7627126717317518,
        },
        {
          id: "1",
          x: 0.3135607230192674,
          y: 0.8135592130521969,
        },
        {
          id: "3",
          x: 0.30508483753657434,
          y: 0.7796665950915004,
        },
        {
          id: "4",
          x: 0.30508483753657434,
          y: 0.7966118042170462,
        },
        {
          id: "0",
          x: 0.3135607230192674,
          y: 0.7966118042170462,
        },
      ],
      region: "south_america",
    },
    {
      id: "peru",
      dots: [
        {
          id: "11",
          x: 0.2542373928151551,
          y: 0.7118684147251269,
        },
        {
          id: "10",
          x: 0.2542373928151551,
          y: 0.6949144913653784,
        },
        {
          id: "9",
          x: 0.2542373928151551,
          y: 0.6779692822398323,
        },
        {
          id: "6",
          x: 0.2627121361434505,
          y: 0.6949144913653784,
        },
        {
          id: "2",
          x: 0.27118687947174597,
          y: 0.7288136238506728,
        },
        {
          id: "1",
          x: 0.27118687947174597,
          y: 0.7118684147251269,
        },
        {
          id: "3",
          x: 0.27118687947174597,
          y: 0.7457674626062059,
        },
        {
          id: "4",
          x: 0.2627121361434505,
          y: 0.661013243774695,
        },
        {
          id: "7",
          x: 0.2627121361434505,
          y: 0.7118684147251269,
        },
        {
          id: "5",
          x: 0.2627121361434505,
          y: 0.6779692822398323,
        },
        {
          id: "8",
          x: 0.2627121361434505,
          y: 0.7288136238506728,
        },
        {
          id: "0",
          x: 0.27118687947174597,
          y: 0.661013243774695,
        },
      ],
      region: "south_america",
    },
    {
      id: "philippines",
      dots: [
        {
          id: "6",
          x: 0.8220344087971947,
          y: 0.5932258081436972,
        },
        {
          id: "3",
          x: 0.8220344087971947,
          y: 0.5423706371932654,
        },
        {
          id: "2",
          x: 0.830508094575122,
          y: 0.6101688175596388,
        },
        {
          id: "8",
          x: 0.8135585233145016,
          y: 0.5423706371932654,
        },
        {
          id: "1",
          x: 0.830508094575122,
          y: 0.5932258081436972,
          radius: 2.19996721494543,
        },
        {
          id: "4",
          x: 0.8220344087971947,
          y: 0.5593288753680071,
          radius: 2.5160160917455903,
          color: "#2EB67D",
        },
        {
          id: "10",
          x: 0.8135585233145016,
          y: 0.5762740844935532,
          color: "#F4B400",
        },
        {
          id: "5",
          x: 0.8220344087971947,
          y: 0.5762740844935532,
        },
        {
          id: "9",
          x: 0.8135585233145016,
          y: 0.5593288753680071,
        },
        {
          id: "7",
          x: 0.8220344087971947,
          y: 0.6101688175596388,
        },
        {
          id: "0",
          x: 0.830508094575122,
          y: 0.5762740844935532,
        },
      ],
      region: "asia",
    },
    {
      id: "poland",
      dots: [
        {
          id: "2",
          x: 0.5339011730179475,
          y: 0.3389845988178084,
        },
        {
          id: "5",
          x: 0.5169516440593419,
          y: 0.30508550863462164,
        },
        {
          id: "4",
          x: 0.5254253298372692,
          y: 0.32203291746977214,
        },
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.32203291746977214,
        },
        {
          id: "0",
          x: 0.5339011730179475,
          y: 0.30508550863462164,
        },
        {
          id: "3",
          x: 0.5254253298372692,
          y: 0.30508550863462164,
        },
        {
          id: "6",
          x: 0.5169516440593419,
          y: 0.32203291746977214,
        },
      ],
      region: "europe",
    },
    {
      id: "portugal",
      dots: [
        {
          id: "1",
          x: 0.44915251297656605,
          y: 0.42372811521605125,
        },
        {
          id: "0",
          x: 0.44915251297656605,
          y: 0.4067785066712962,
        },
      ],
      region: "europe",
    },
    {
      id: "puerto_rico",
      dots: [
        {
          id: "0",
          x: 0.27966166510205615,
          y: 0.5423706371932654,
        },
      ],
      region: "south_america",
    },
    {
      id: "qatar",
      dots: [
        {
          id: "0",
          x: 0.6186444607034589,
          y: 0.5084715047079709,
        },
      ],
      region: "middle_east",
    },
    {
      id: "republic_of_guinea",
      dots: [
        {
          id: "2",
          x: 0.44067882719863877,
          y: 0.5932258081436972,
        },
        {
          id: "1",
          x: 0.44915251297656605,
          y: 0.5932258081436972,
        },
        {
          id: "0",
          x: 0.44915251297656605,
          y: 0.5762740844935532,
          radius: 2.466022363234738,
        },
      ],
      region: "africa",
    },
    {
      id: "romania",
      dots: [
        {
          id: "0",
          x: 0.5508506596745385,
          y: 0.37287941648810946,
        },
        {
          id: "1",
          x: 0.5423748587958749,
          y: 0.35592980794335444,
        },
        {
          id: "2",
          x: 0.5508506596745385,
          y: 0.35592980794335444,
        },
      ],
      region: "europe",
    },
    {
      id: "russia",
      dots: [
        {
          id: "170",
          x: 0.830508094575122,
          y: 0.2711863761493271,
        },
        {
          id: "491",
          x: 0.6186444607034589,
          y: 0.25423465249918314,
        },
        {
          id: "518",
          x: 0.5932223881213236,
          y: 0.28813378498447767,
        },
        {
          id: "432",
          x: 0.5932223881213236,
          y: 0.03389693277569003,
        },
        {
          id: "363",
          x: 0.7033920631944722,
          y: 0.22033556231599638,
        },
        {
          id: "291",
          x: 0.7457648068896107,
          y: 0.03389693277569003,
        },
        {
          id: "330",
          x: 0.7288152356289904,
          y: 0.25423465249918314,
          color: "#A566FF",
        },
        {
          id: "441",
          x: 0.6610171197945679,
          y: 0.1694912418562097,
        },
        {
          id: "444",
          x: 0.6610171197945679,
          y: 0.22033556231599638,
        },
        {
          id: "447",
          x: 0.6610171197945679,
          y: 0.2711863761493271,
        },
        {
          id: "483",
          x: 0.6271213614345054,
          y: 0.2711863761493271,
        },
        {
          id: "470",
          x: 0.6355951318164621,
          y: 0.22033556231599638,
        },
        {
          id: "453",
          x: 0.6525445338690236,
          y: 0.2372851074075898,
        },
        {
          id: "454",
          x: 0.6525445338690236,
          y: 0.25423465249918314,
          radius: 2.3327782602457034,
        },
        {
          id: "370",
          x: 0.6949151624634257,
          y: 0.15254167561356247,
        },
        {
          id: "289",
          x: 0.7542373082111256,
          y: 0.2711863761493271,
        },
        {
          id: "329",
          x: 0.7288152356289904,
          y: 0.2372851074075898,
        },
        {
          id: "299",
          x: 0.7457648068896107,
          y: 0.1864364509817558,
        },
        {
          id: "503",
          x: 0.610171790173885,
          y: 0.30508550863462164,
        },
        {
          id: "449",
          x: 0.6525445338690236,
          y: 0.1694912418562097,
        },
        {
          id: "290",
          x: 0.7542373082111256,
          y: 0.28813378498447767,
        },
        {
          id: "459",
          x: 0.6440677177420064,
          y: 0.1864364509817558,
        },
        {
          id: "480",
          x: 0.6271213614345054,
          y: 0.22033556231599638,
        },
        {
          id: "496",
          x: 0.610171790173885,
          y: 0.1864364509817558,
        },
        {
          id: "487",
          x: 0.6186444607034589,
          y: 0.1864364509817558,
        },
        {
          id: "462",
          x: 0.6440677177420064,
          y: 0.2372851074075898,
        },
        {
          id: "368",
          x: 0.7033920631944722,
          y: 0.30508550863462164,
        },
        {
          id: "372",
          x: 0.6949151624634257,
          y: 0.1864364509817558,
        },
        {
          id: "401",
          x: 0.6864424919338519,
          y: 0.1694912418562097,
        },
        {
          id: "323",
          x: 0.7288152356289904,
          y: 0.13559213052196908,
        },
        {
          id: "362",
          x: 0.7033920631944722,
          y: 0.20338599607334912,
        },
        {
          id: "311",
          x: 0.7372878215545348,
          y: 0.13559213052196908,
        },
        {
          id: "457",
          x: 0.6440677177420064,
          y: 0.11864256427932182,
        },
        {
          id: "343",
          x: 0.720341549851063,
          y: 0.2711863761493271,
        },
        {
          id: "482",
          x: 0.6271213614345054,
          y: 0.25423465249918314,
        },
        {
          id: "358",
          x: 0.7033920631944722,
          y: 0.13559213052196908,
        },
        {
          id: "498",
          x: 0.610171790173885,
          y: 0.22033556231599638,
        },
        {
          id: "445",
          x: 0.6610171197945679,
          y: 0.2372851074075898,
        },
        {
          id: "317",
          x: 0.7372878215545348,
          y: 0.2372851074075898,
        },
        {
          id: "481",
          x: 0.6271213614345054,
          y: 0.2372851074075898,
        },
        {
          id: "384",
          x: 0.8644071524923332,
          y: 0.37287941648810946,
        },
        {
          id: "479",
          x: 0.6271213614345054,
          y: 0.20338599607334912,
        },
        {
          id: "361",
          x: 0.7033920631944722,
          y: 0.1864364509817558,
        },
        {
          id: "436",
          x: 0.6694941051296439,
          y: 0.2372851074075898,
          radius: 2.849614686625442,
          color: "#2EB67D",
        },
        {
          id: "435",
          x: 0.6694941051296439,
          y: 0.22033556231599638,
        },
        {
          id: "296",
          x: 0.7457648068896107,
          y: 0.13559213052196908,
        },
        {
          id: "359",
          x: 0.7033920631944722,
          y: 0.15254167561356247,
        },
        {
          id: "439",
          x: 0.6610171197945679,
          y: 0.10169299803667456,
        },
        {
          id: "381",
          x: 0.881356639148924,
          y: 0.37287941648810946,
        },
        {
          id: "440",
          x: 0.6610171197945679,
          y: 0.15254167561356247,
        },
        {
          id: "36",
          x: 0.9406777696482707,
          y: 0.22033556231599638,
        },
        {
          id: "241",
          x: 0.7796638648068219,
          y: 0.2372851074075898,
        },
        {
          id: "497",
          x: 0.610171790173885,
          y: 0.20338599607334912,
        },
        {
          id: "183",
          x: 0.8135585233145016,
          y: 0.13559213052196908,
        },
        {
          id: "182",
          x: 0.8220344087971947,
          y: 0.28813378498447767,
        },
        {
          id: "397",
          x: 0.5847454027862475,
          y: 0.32203291746977214,
        },
        {
          id: "75",
          x: 0.8983061258055149,
          y: 0.20338599607334912,
        },
        {
          id: "151",
          x: 0.8389838954537855,
          y: 0.15254167561356247,
        },
        {
          id: "488",
          x: 0.6186444607034589,
          y: 0.20338599607334912,
        },
        {
          id: "206",
          x: 0.7966122516110299,
          y: 0.11864256427932182,
        },
        {
          id: "468",
          x: 0.6355951318164621,
          y: 0.1864364509817558,
        },
        {
          id: "281",
          x: 0.7542373082111256,
          y: 0.13559213052196908,
        },
        {
          id: "12",
          x: 0.9745767429614524,
          y: 0.1864364509817558,
        },
        {
          id: "474",
          x: 0.6355951318164621,
          y: 0.28813378498447767,
        },
        {
          id: "477",
          x: 0.6271213614345054,
          y: 0.15254167561356247,
          color: "#DB4437",
        },
        {
          id: "284",
          x: 0.7542373082111256,
          y: 0.1864364509817558,
        },
        {
          id: "437",
          x: 0.6694941051296439,
          y: 0.25423465249918314,
        },
        {
          id: "192",
          x: 0.8135585233145016,
          y: 0.28813378498447767,
        },
        {
          id: "455",
          x: 0.6525445338690236,
          y: 0.2711863761493271,
        },
        {
          id: "130",
          x: 0.8559344819627593,
          y: 0.20338599607334912,
        },
        {
          id: "492",
          x: 0.6186444607034589,
          y: 0.2711863761493271,
        },
        {
          id: "367",
          x: 0.7033920631944722,
          y: 0.28813378498447767,
        },
        {
          id: "320",
          x: 0.7372878215545348,
          y: 0.28813378498447767,
        },
        {
          id: "433",
          x: 0.6694941051296439,
          y: 0.1864364509817558,
        },
        {
          id: "252",
          x: 0.7711868794717459,
          y: 0.15254167561356247,
        },
        {
          id: "22",
          x: 0.9576272563048615,
          y: 0.1864364509817558,
        },
        {
          id: "6",
          x: 0.9830504287393796,
          y: 0.15254167561356247,
        },
        {
          id: "560",
          x: 0.5254253298372692,
          y: 0.0847456315036318,
        },
        {
          id: "494",
          x: 0.6186444607034589,
          y: 0.30508550863462164,
        },
        {
          id: "287",
          x: 0.7542373082111256,
          y: 0.2372851074075898,
        },
        {
          id: "519",
          x: 0.5932223881213236,
          y: 0.30508550863462164,
        },
        {
          id: "31",
          x: 0.9491545857752877,
          y: 0.2372851074075898,
        },
        {
          id: "386",
          x: 0.8559344819627593,
          y: 0.37287941648810946,
        },
        {
          id: "212",
          x: 0.7966122516110299,
          y: 0.22033556231599638,
        },
        {
          id: "295",
          x: 0.7457648068896107,
          y: 0.11864256427932182,
        },
        {
          id: "74",
          x: 0.8983061258055149,
          y: 0.1864364509817558,
        },
        {
          id: "382",
          x: 0.8728839686193501,
          y: 0.35592980794335444,
        },
        {
          id: "242",
          x: 0.7796638648068219,
          y: 0.25423465249918314,
        },
        {
          id: "164",
          x: 0.830508094575122,
          y: 0.1694912418562097,
        },
        {
          id: "302",
          x: 0.7457648068896107,
          y: 0.2372851074075898,
        },
        {
          id: "108",
          x: 0.8728839686193501,
          y: 0.25423465249918314,
        },
        {
          id: "0",
          x: 1.0084758854826932,
          y: 0.20338599607334912,
          radius: 2.1859206449248685,
        },
        {
          id: "95",
          x: 0.881356639148924,
          y: 0.2372851074075898,
        },
        {
          id: "517",
          x: 0.5932223881213236,
          y: 0.2711863761493271,
        },
        {
          id: "220",
          x: 0.7881353508799834,
          y: 0.11864256427932182,
        },
        {
          id: "125",
          x: 0.8644071524923332,
          y: 0.32203291746977214,
        },
        {
          id: "525",
          x: 0.5847454027862475,
          y: 0.2711863761493271,
        },
        {
          id: "195",
          x: 0.8050848375365743,
          y: 0.1694912418562097,
        },
        {
          id: "233",
          x: 0.7796638648068219,
          y: 0.10169299803667456,
        },
        {
          id: "200",
          x: 0.8050848375365743,
          y: 0.25423465249918314,
        },
        {
          id: "106",
          x: 0.8728839686193501,
          y: 0.22033556231599638,
        },
        {
          id: "301",
          x: 0.7457648068896107,
          y: 0.22033556231599638,
          color: "#A566FF",
        },
        {
          id: "538",
          x: 0.5677948162772738,
          y: 0.22033556231599638,
          radius: 2.6961218930536006,
        },
        {
          id: "116",
          x: 0.8644071524923332,
          y: 0.1694912418562097,
        },
        {
          id: "253",
          x: 0.7711868794717459,
          y: 0.1694912418562097,
        },
        {
          id: "144",
          x: 0.8474575812317129,
          y: 0.2372851074075898,
        },
        {
          id: "292",
          x: 0.7457648068896107,
          y: 0.05084649901833728,
          color: "#DB4437",
        },
        {
          id: "33",
          x: 0.9406777696482707,
          y: 0.1694912418562097,
        },
        {
          id: "29",
          x: 0.9491545857752877,
          y: 0.20338599607334912,
        },
        {
          id: "321",
          x: 0.7372878215545348,
          y: 0.30508550863462164,
        },
        {
          id: "196",
          x: 0.8050848375365743,
          y: 0.1864364509817558,
        },
        {
          id: "534",
          x: 0.5762728168607032,
          y: 0.28813378498447767,
        },
        {
          id: "504",
          x: 0.6016949740468679,
          y: 0.1864364509817558,
        },
        {
          id: "117",
          x: 0.8644071524923332,
          y: 0.1864364509817558,
        },
        {
          id: "98",
          x: 0.881356639148924,
          y: 0.3389845988178084,
        },
        {
          id: "16",
          x: 0.9661042416399375,
          y: 0.1694912418562097,
        },
        {
          id: "150",
          x: 0.8389838954537855,
          y: 0.13559213052196908,
        },
        {
          id: "172",
          x: 0.830508094575122,
          y: 0.30508550863462164,
        },
        {
          id: "398",
          x: 0.5762728168607032,
          y: 0.32203291746977214,
        },
        {
          id: "149",
          x: 0.8474575812317129,
          y: 0.32203291746977214,
        },
        {
          id: "540",
          x: 0.5677948162772738,
          y: 0.25423465249918314,
        },
        {
          id: "96",
          x: 0.881356639148924,
          y: 0.25423465249918314,
        },
        {
          id: "553",
          x: 0.5508506596745385,
          y: 0.05084649901833728,
          color: "#F4B400",
        },
        {
          id: "145",
          x: 0.8474575812317129,
          y: 0.25423465249918314,
          color: "#2EB67D",
        },
        {
          id: "484",
          x: 0.6271213614345054,
          y: 0.28813378498447767,
        },
        {
          id: "92",
          x: 0.881356639148924,
          y: 0.1864364509817558,
        },
        {
          id: "360",
          x: 0.7033920631944722,
          y: 0.1694912418562097,
        },
        {
          id: "478",
          x: 0.6271213614345054,
          y: 0.1864364509817558,
        },
        {
          id: "24",
          x: 0.9576272563048615,
          y: 0.22033556231599638,
        },
        {
          id: "9",
          x: 0.9830504287393796,
          y: 0.22033556231599638,
        },
        {
          id: "511",
          x: 0.6016949740468679,
          y: 0.30508550863462164,
        },
        {
          id: "339",
          x: 0.720341549851063,
          y: 0.20338599607334912,
        },
        {
          id: "79",
          x: 0.8898334552759412,
          y: 0.11864256427932182,
        },
        {
          id: "375",
          x: 0.6949151624634257,
          y: 0.2372851074075898,
        },
        {
          id: "430",
          x: 0.6016949740468679,
          y: 0.03389693277569003,
        },
        {
          id: "45",
          x: 0.9322040838703434,
          y: 0.2711863761493271,
          radius: 2.4544643833995687,
          color: "#A566FF",
        },
        {
          id: "537",
          x: 0.5677948162772738,
          y: 0.20338599607334912,
        },
        {
          id: "139",
          x: 0.8474575812317129,
          y: 0.15254167561356247,
        },
        {
          id: "471",
          x: 0.6355951318164621,
          y: 0.2372851074075898,
        },
        {
          id: "285",
          x: 0.7542373082111256,
          y: 0.20338599607334912,
        },
        {
          id: "429",
          x: 0.610171790173885,
          y: 0.05084649901833728,
        },
        {
          id: "515",
          x: 0.5932223881213236,
          y: 0.2372851074075898,
        },
        {
          id: "472",
          x: 0.6355951318164621,
          y: 0.25423465249918314,
        },
        {
          id: "14",
          x: 0.9745767429614524,
          y: 0.22033556231599638,
        },
        {
          id: "505",
          x: 0.6016949740468679,
          y: 0.20338599607334912,
        },
        {
          id: "112",
          x: 0.8728839686193501,
          y: 0.3389845988178084,
        },
        {
          id: "394",
          x: 0.5932223881213236,
          y: 0.3389845988178084,
        },
        {
          id: "316",
          x: 0.7372878215545348,
          y: 0.22033556231599638,
        },
        {
          id: "294",
          x: 0.7457648068896107,
          y: 0.10169299803667456,
        },
        {
          id: "114",
          x: 0.8644071524923332,
          y: 0.11864256427932182,
        },
        {
          id: "230",
          x: 0.7881353508799834,
          y: 0.28813378498447767,
        },
        {
          id: "148",
          x: 0.8474575812317129,
          y: 0.30508550863462164,
        },
        {
          id: "60",
          x: 0.9152545972137525,
          y: 0.22033556231599638,
        },
        {
          id: "392",
          x: 0.6016949740468679,
          y: 0.37287941648810946,
        },
        {
          id: "87",
          x: 0.881356639148924,
          y: 0.10169299803667456,
        },
        {
          id: "541",
          x: 0.5677948162772738,
          y: 0.2711863761493271,
          radius: 2.128945380193276,
        },
        {
          id: "532",
          x: 0.5762728168607032,
          y: 0.25423465249918314,
        },
        {
          id: "240",
          x: 0.7796638648068219,
          y: 0.22033556231599638,
        },
        {
          id: "190",
          x: 0.8135585233145016,
          y: 0.25423465249918314,
        },
        {
          id: "412",
          x: 0.6779655912028054,
          y: 0.20338599607334912,
        },
        {
          id: "405",
          x: 0.6864424919338519,
          y: 0.2372851074075898,
        },
        {
          id: "104",
          x: 0.8728839686193501,
          y: 0.1864364509817558,
        },
        {
          id: "52",
          x: 0.9237282829916796,
          y: 0.2372851074075898,
        },
        {
          id: "105",
          x: 0.8728839686193501,
          y: 0.20338599607334912,
        },
        {
          id: "499",
          x: 0.610171790173885,
          y: 0.2372851074075898,
        },
        {
          id: "463",
          x: 0.6440677177420064,
          y: 0.25423465249918314,
        },
        {
          id: "93",
          x: 0.881356639148924,
          y: 0.20338599607334912,
        },
        {
          id: "354",
          x: 0.7118646491200166,
          y: 0.25423465249918314,
        },
        {
          id: "297",
          x: 0.7457648068896107,
          y: 0.15254167561356247,
        },
        {
          id: "236",
          x: 0.7796638648068219,
          y: 0.15254167561356247,
        },
        {
          id: "53",
          x: 0.9237282829916796,
          y: 0.2711863761493271,
        },
        {
          id: "1",
          x: 1,
          y: 0.20338599607334912,
          radius: 2.1513219313682885,
        },
        {
          id: "101",
          x: 0.8728839686193501,
          y: 0.13559213052196908,
          radius: 2.993251078977719,
        },
        {
          id: "250",
          x: 0.7711868794717459,
          y: 0.11864256427932182,
        },
        {
          id: "76",
          x: 0.8983061258055149,
          y: 0.22033556231599638,
        },
        {
          id: "50",
          x: 0.9237282829916796,
          y: 0.20338599607334912,
          color: "#2EB67D",
        },
        {
          id: "300",
          x: 0.7457648068896107,
          y: 0.20338599607334912,
        },
        {
          id: "261",
          x: 0.7711868794717459,
          y: 0.30508550863462164,
        },
        {
          id: "385",
          x: 0.8559344819627593,
          y: 0.35592980794335444,
        },
        {
          id: "391",
          x: 0.6016949740468679,
          y: 0.35592980794335444,
        },
        {
          id: "77",
          x: 0.8983061258055149,
          y: 0.2372851074075898,
        },
        {
          id: "174",
          x: 0.8220344087971947,
          y: 0.15254167561356247,
        },
        {
          id: "271",
          x: 0.7627142935462016,
          y: 0.22033556231599638,
        },
        {
          id: "211",
          x: 0.7966122516110299,
          y: 0.20338599607334912,
        },
        {
          id: "473",
          x: 0.6355951318164621,
          y: 0.2711863761493271,
        },
        {
          id: "506",
          x: 0.6016949740468679,
          y: 0.22033556231599638,
        },
        {
          id: "73",
          x: 0.8983061258055149,
          y: 0.1694912418562097,
        },
        {
          id: "464",
          x: 0.6440677177420064,
          y: 0.2711863761493271,
        },
        {
          id: "350",
          x: 0.7118646491200166,
          y: 0.1864364509817558,
        },
        {
          id: "41",
          x: 0.9322040838703434,
          y: 0.20338599607334912,
        },
        {
          id: "336",
          x: 0.720341549851063,
          y: 0.15254167561356247,
        },
        {
          id: "523",
          x: 0.5847454027862475,
          y: 0.2372851074075898,
        },
        {
          id: "521",
          x: 0.5847454027862475,
          y: 0.20338599607334912,
          radius: 2.5321727057383363,
        },
        {
          id: "20",
          x: 0.9661042416399375,
          y: 0.2372851074075898,
        },
        {
          id: "413",
          x: 0.6779655912028054,
          y: 0.22033556231599638,
        },
        {
          id: "254",
          x: 0.7711868794717459,
          y: 0.1864364509817558,
        },
        {
          id: "154",
          x: 0.8389838954537855,
          y: 0.20338599607334912,
        },
        {
          id: "165",
          x: 0.830508094575122,
          y: 0.1864364509817558,
        },
        {
          id: "389",
          x: 0.8474575812317129,
          y: 0.38983109783614567,
          radius: 2.491638220629892,
        },
        {
          id: "163",
          x: 0.830508094575122,
          y: 0.15254167561356247,
        },
        {
          id: "409",
          x: 0.6779655912028054,
          y: 0.15254167561356247,
        },
        {
          id: "277",
          x: 0.7542373082111256,
          y: 0.05084649901833728,
        },
        {
          id: "510",
          x: 0.6016949740468679,
          y: 0.28813378498447767,
          radius: 2.7000856107425286,
        },
        {
          id: "63",
          x: 0.9152545972137525,
          y: 0.30508550863462164,
        },
        {
          id: "486",
          x: 0.6186444607034589,
          y: 0.15254167561356247,
        },
        {
          id: "366",
          x: 0.7033920631944722,
          y: 0.2711863761493271,
        },
        {
          id: "564",
          x: 0.5508506596745385,
          y: 0.15254167561356247,
        },
        {
          id: "2",
          x: 1,
          y: 0.22033556231599638,
        },
        {
          id: "216",
          x: 0.7966122516110299,
          y: 0.28813378498447767,
        },
        {
          id: "249",
          x: 0.7711868794717459,
          y: 0.10169299803667456,
        },
        {
          id: "90",
          x: 0.881356639148924,
          y: 0.15254167561356247,
        },
        {
          id: "328",
          x: 0.7288152356289904,
          y: 0.22033556231599638,
        },
        {
          id: "89",
          x: 0.881356639148924,
          y: 0.13559213052196908,
        },
        {
          id: "456",
          x: 0.6440677177420064,
          y: 0.10169299803667456,
        },
        {
          id: "199",
          x: 0.8050848375365743,
          y: 0.2372851074075898,
        },
        {
          id: "500",
          x: 0.610171790173885,
          y: 0.25423465249918314,
        },
        {
          id: "335",
          x: 0.720341549851063,
          y: 0.13559213052196908,
        },
        {
          id: "42",
          x: 0.9322040838703434,
          y: 0.22033556231599638,
        },
        {
          id: "18",
          x: 0.9661042416399375,
          y: 0.20338599607334912,
        },
        {
          id: "319",
          x: 0.7372878215545348,
          y: 0.2711863761493271,
        },
        {
          id: "19",
          x: 0.9661042416399375,
          y: 0.22033556231599638,
        },
        {
          id: "228",
          x: 0.7881353508799834,
          y: 0.25423465249918314,
        },
        {
          id: "275",
          x: 0.7627142935462016,
          y: 0.28813378498447767,
        },
        {
          id: "313",
          x: 0.7372878215545348,
          y: 0.1694912418562097,
        },
        {
          id: "461",
          x: 0.6440677177420064,
          y: 0.22033556231599638,
        },
        {
          id: "215",
          x: 0.7966122516110299,
          y: 0.2711863761493271,
        },
        {
          id: "266",
          x: 0.7627142935462016,
          y: 0.13559213052196908,
        },
        {
          id: "427",
          x: 0.6355951318164621,
          y: 0.05084649901833728,
          color: "#F4B400",
        },
        {
          id: "26",
          x: 0.9576272563048615,
          y: 0.25423465249918314,
        },
        {
          id: "388",
          x: 0.8474575812317129,
          y: 0.37287941648810946,
        },
        {
          id: "550",
          x: 0.5593233302041123,
          y: 0.25423465249918314,
        },
        {
          id: "268",
          x: 0.7627142935462016,
          y: 0.1694912418562097,
        },
        {
          id: "255",
          x: 0.7711868794717459,
          y: 0.20338599607334912,
        },
        {
          id: "152",
          x: 0.8389838954537855,
          y: 0.1694912418562097,
        },
        {
          id: "531",
          x: 0.5762728168607032,
          y: 0.2372851074075898,
        },
        {
          id: "72",
          x: 0.8983061258055149,
          y: 0.15254167561356247,
        },
        {
          id: "516",
          x: 0.5932223881213236,
          y: 0.25423465249918314,
        },
        {
          id: "422",
          x: 0.6525445338690236,
          y: 0.05084649901833728,
        },
        {
          id: "83",
          x: 0.8898334552759412,
          y: 0.20338599607334912,
        },
        {
          id: "179",
          x: 0.8220344087971947,
          y: 0.2372851074075898,
        },
        {
          id: "227",
          x: 0.7881353508799834,
          y: 0.2372851074075898,
        },
        {
          id: "310",
          x: 0.7372878215545348,
          y: 0.11864256427932182,
        },
        {
          id: "565",
          x: 0.5508506596745385,
          y: 0.1694912418562097,
        },
        {
          id: "349",
          x: 0.7118646491200166,
          y: 0.1694912418562097,
        },
        {
          id: "158",
          x: 0.8389838954537855,
          y: 0.2711863761493271,
        },
        {
          id: "188",
          x: 0.8135585233145016,
          y: 0.22033556231599638,
        },
        {
          id: "476",
          x: 0.6271213614345054,
          y: 0.13559213052196908,
        },
        {
          id: "490",
          x: 0.6186444607034589,
          y: 0.2372851074075898,
        },
        {
          id: "80",
          x: 0.8898334552759412,
          y: 0.15254167561356247,
          color: "#F4B400",
        },
        {
          id: "167",
          x: 0.830508094575122,
          y: 0.22033556231599638,
        },
        {
          id: "399",
          x: 0.6864424919338519,
          y: 0.13559213052196908,
        },
        {
          id: "166",
          x: 0.830508094575122,
          y: 0.20338599607334912,
        },
        {
          id: "485",
          x: 0.6271213614345054,
          y: 0.30508550863462164,
        },
        {
          id: "97",
          x: 0.881356639148924,
          y: 0.32203291746977214,
        },
        {
          id: "561",
          x: 0.5169516440593419,
          y: 0.06779388670243394,
        },
        {
          id: "13",
          x: 0.9745767429614524,
          y: 0.20338599607334912,
        },
        {
          id: "567",
          x: 0.5508506596745385,
          y: 0.20338599607334912,
        },
        {
          id: "274",
          x: 0.7627142935462016,
          y: 0.2711863761493271,
        },
        {
          id: "194",
          x: 0.8050848375365743,
          y: 0.15254167561356247,
        },
        {
          id: "507",
          x: 0.6016949740468679,
          y: 0.2372851074075898,
        },
        {
          id: "376",
          x: 0.6949151624634257,
          y: 0.25423465249918314,
        },
        {
          id: "201",
          x: 0.8050848375365743,
          y: 0.2711863761493271,
        },
        {
          id: "373",
          x: 0.6949151624634257,
          y: 0.20338599607334912,
        },
        {
          id: "17",
          x: 0.9661042416399375,
          y: 0.1864364509817558,
        },
        {
          id: "69",
          x: 0.9067787117310594,
          y: 0.2372851074075898,
        },
        {
          id: "107",
          x: 0.8728839686193501,
          y: 0.2372851074075898,
        },
        {
          id: "11",
          x: 0.9745767429614524,
          y: 0.1694912418562097,
        },
        {
          id: "522",
          x: 0.5847454027862475,
          y: 0.22033556231599638,
        },
        {
          id: "508",
          x: 0.6016949740468679,
          y: 0.25423465249918314,
        },
        {
          id: "501",
          x: 0.610171790173885,
          y: 0.2711863761493271,
        },
        {
          id: "169",
          x: 0.830508094575122,
          y: 0.25423465249918314,
        },
        {
          id: "333",
          x: 0.7288152356289904,
          y: 0.30508550863462164,
        },
        {
          id: "348",
          x: 0.7118646491200166,
          y: 0.15254167561356247,
        },
        {
          id: "273",
          x: 0.7627142935462016,
          y: 0.25423465249918314,
        },
        {
          id: "364",
          x: 0.7033920631944722,
          y: 0.2372851074075898,
        },
        {
          id: "448",
          x: 0.6525445338690236,
          y: 0.10169299803667456,
        },
        {
          id: "84",
          x: 0.8898334552759412,
          y: 0.22033556231599638,
        },
        {
          id: "27",
          x: 0.9491545857752877,
          y: 0.1694912418562097,
        },
        {
          id: "40",
          x: 0.9322040838703434,
          y: 0.1864364509817558,
        },
        {
          id: "223",
          x: 0.7881353508799834,
          y: 0.1694912418562097,
        },
        {
          id: "159",
          x: 0.8389838954537855,
          y: 0.28813378498447767,
        },
        {
          id: "238",
          x: 0.7796638648068219,
          y: 0.1864364509817558,
        },
        {
          id: "308",
          x: 0.7372878215545348,
          y: 0.05084649901833728,
        },
        {
          id: "203",
          x: 0.8050848375365743,
          y: 0.30508550863462164,
        },
        {
          id: "39",
          x: 0.9322040838703434,
          y: 0.1694912418562097,
        },
        {
          id: "535",
          x: 0.5762728168607032,
          y: 0.30508550863462164,
        },
        {
          id: "452",
          x: 0.6525445338690236,
          y: 0.22033556231599638,
        },
        {
          id: "176",
          x: 0.8220344087971947,
          y: 0.1864364509817558,
        },
        {
          id: "231",
          x: 0.7881353508799834,
          y: 0.30508550863462164,
        },
        {
          id: "237",
          x: 0.7796638648068219,
          y: 0.1694912418562097,
        },
        {
          id: "99",
          x: 0.8728839686193501,
          y: 0.10169299803667456,
          color: "#2EB67D",
        },
        {
          id: "189",
          x: 0.8135585233145016,
          y: 0.2372851074075898,
        },
        {
          id: "419",
          x: 0.6694941051296439,
          y: 0.13559213052196908,
          radius: 2.7948888784886856,
          color: "#2EB67D",
        },
        {
          id: "263",
          x: 0.7627142935462016,
          y: 0.0847456315036318,
        },
        {
          id: "466",
          x: 0.6355951318164621,
          y: 0.13559213052196908,
        },
        {
          id: "94",
          x: 0.881356639148924,
          y: 0.22033556231599638,
        },
        {
          id: "340",
          x: 0.720341549851063,
          y: 0.22033556231599638,
        },
        {
          id: "365",
          x: 0.7033920631944722,
          y: 0.25423465249918314,
        },
        {
          id: "102",
          x: 0.8728839686193501,
          y: 0.15254167561356247,
        },
        {
          id: "298",
          x: 0.7457648068896107,
          y: 0.1694912418562097,
        },
        {
          id: "371",
          x: 0.6949151624634257,
          y: 0.1694912418562097,
        },
        {
          id: "10",
          x: 0.9830504287393796,
          y: 0.2372851074075898,
        },
        {
          id: "155",
          x: 0.8389838954537855,
          y: 0.22033556231599638,
        },
        {
          id: "146",
          x: 0.8474575812317129,
          y: 0.2711863761493271,
        },
        {
          id: "293",
          x: 0.7457648068896107,
          y: 0.06779388670243394,
        },
        {
          id: "217",
          x: 0.7966122516110299,
          y: 0.30508550863462164,
        },
        {
          id: "342",
          x: 0.720341549851063,
          y: 0.25423465249918314,
        },
        {
          id: "305",
          x: 0.7457648068896107,
          y: 0.28813378498447767,
        },
        {
          id: "21",
          x: 0.9576272563048615,
          y: 0.1694912418562097,
        },
        {
          id: "309",
          x: 0.7372878215545348,
          y: 0.10169299803667456,
        },
        {
          id: "415",
          x: 0.6779655912028054,
          y: 0.25423465249918314,
        },
        {
          id: "67",
          x: 0.9067787117310594,
          y: 0.20338599607334912,
          radius: 2.405696003292035,
        },
        {
          id: "225",
          x: 0.7881353508799834,
          y: 0.20338599607334912,
        },
        {
          id: "408",
          x: 0.6779655912028054,
          y: 0.13559213052196908,
        },
        {
          id: "147",
          x: 0.8474575812317129,
          y: 0.28813378498447767,
        },
        {
          id: "353",
          x: 0.7118646491200166,
          y: 0.2372851074075898,
        },
        {
          id: "345",
          x: 0.720341549851063,
          y: 0.30508550863462164,
        },
        {
          id: "177",
          x: 0.8220344087971947,
          y: 0.20338599607334912,
        },
        {
          id: "256",
          x: 0.7711868794717459,
          y: 0.22033556231599638,
        },
        {
          id: "5",
          x: 0.9915263142220727,
          y: 0.20338599607334912,
        },
        {
          id: "469",
          x: 0.6355951318164621,
          y: 0.20338599607334912,
        },
        {
          id: "221",
          x: 0.7881353508799834,
          y: 0.13559213052196908,
        },
        {
          id: "475",
          x: 0.6355951318164621,
          y: 0.30508550863462164,
        },
        {
          id: "100",
          x: 0.8728839686193501,
          y: 0.11864256427932182,
        },
        {
          id: "502",
          x: 0.610171790173885,
          y: 0.28813378498447767,
        },
        {
          id: "306",
          x: 0.7457648068896107,
          y: 0.30508550863462164,
        },
        {
          id: "257",
          x: 0.7711868794717459,
          y: 0.2372851074075898,
        },
        {
          id: "417",
          x: 0.6779655912028054,
          y: 0.28813378498447767,
        },
        {
          id: "136",
          x: 0.8559344819627593,
          y: 0.30508550863462164,
          radius: 2.3458096892726106,
        },
        {
          id: "312",
          x: 0.7372878215545348,
          y: 0.15254167561356247,
        },
        {
          id: "314",
          x: 0.7372878215545348,
          y: 0.1864364509817558,
        },
        {
          id: "493",
          x: 0.6186444607034589,
          y: 0.28813378498447767,
        },
        {
          id: "127",
          x: 0.8559344819627593,
          y: 0.15254167561356247,
        },
        {
          id: "556",
          x: 0.5339011730179475,
          y: 0.05084649901833728,
          radius: 2.5060769766047337,
        },
        {
          id: "383",
          x: 0.8644071524923332,
          y: 0.35592980794335444,
        },
        {
          id: "542",
          x: 0.5677948162772738,
          y: 0.28813378498447767,
        },
        {
          id: "68",
          x: 0.9067787117310594,
          y: 0.22033556231599638,
        },
        {
          id: "443",
          x: 0.6610171197945679,
          y: 0.20338599607334912,
        },
        {
          id: "48",
          x: 0.9237282829916796,
          y: 0.1694912418562097,
        },
        {
          id: "489",
          x: 0.6186444607034589,
          y: 0.22033556231599638,
        },
        {
          id: "32",
          x: 0.9491545857752877,
          y: 0.25423465249918314,
          color: "#A566FF",
        },
        {
          id: "380",
          x: 0.881356639148924,
          y: 0.35592980794335444,
        },
        {
          id: "175",
          x: 0.8220344087971947,
          y: 0.1694912418562097,
        },
        {
          id: "103",
          x: 0.8728839686193501,
          y: 0.1694912418562097,
        },
        {
          id: "260",
          x: 0.7711868794717459,
          y: 0.28813378498447767,
        },
        {
          id: "218",
          x: 0.7966122516110299,
          y: 0.32203291746977214,
        },
        {
          id: "135",
          x: 0.8559344819627593,
          y: 0.28813378498447767,
        },
        {
          id: "222",
          x: 0.7881353508799834,
          y: 0.15254167561356247,
        },
        {
          id: "3",
          x: 0.9915263142220727,
          y: 0.15254167561356247,
        },
        {
          id: "442",
          x: 0.6610171197945679,
          y: 0.1864364509817558,
        },
        {
          id: "193",
          x: 0.8050848375365743,
          y: 0.13559213052196908,
        },
        {
          id: "406",
          x: 0.6864424919338519,
          y: 0.25423465249918314,
        },
        {
          id: "539",
          x: 0.5677948162772738,
          y: 0.2372851074075898,
        },
        {
          id: "62",
          x: 0.9152545972137525,
          y: 0.25423465249918314,
        },
        {
          id: "78",
          x: 0.8983061258055149,
          y: 0.25423465249918314,
        },
        {
          id: "82",
          x: 0.8898334552759412,
          y: 0.1864364509817558,
        },
        {
          id: "161",
          x: 0.8389838954537855,
          y: 0.32203291746977214,
        },
        {
          id: "346",
          x: 0.720341549851063,
          y: 0.32203291746977214,
        },
        {
          id: "131",
          x: 0.8559344819627593,
          y: 0.22033556231599638,
        },
        {
          id: "35",
          x: 0.9406777696482707,
          y: 0.20338599607334912,
        },
        {
          id: "288",
          x: 0.7542373082111256,
          y: 0.25423465249918314,
        },
        {
          id: "495",
          x: 0.610171790173885,
          y: 0.1694912418562097,
        },
        {
          id: "369",
          x: 0.6949151624634257,
          y: 0.13559213052196908,
        },
        {
          id: "178",
          x: 0.8220344087971947,
          y: 0.22033556231599638,
        },
        {
          id: "109",
          x: 0.8728839686193501,
          y: 0.2711863761493271,
        },
        {
          id: "327",
          x: 0.7288152356289904,
          y: 0.20338599607334912,
        },
        {
          id: "219",
          x: 0.7881353508799834,
          y: 0.10169299803667456,
        },
        {
          id: "57",
          x: 0.9152545972137525,
          y: 0.1694912418562097,
        },
        {
          id: "355",
          x: 0.7118646491200166,
          y: 0.2711863761493271,
        },
        {
          id: "142",
          x: 0.8474575812317129,
          y: 0.20338599607334912,
        },
        {
          id: "416",
          x: 0.6779655912028054,
          y: 0.2711863761493271,
        },
        {
          id: "204",
          x: 0.8050848375365743,
          y: 0.32203291746977214,
        },
        {
          id: "247",
          x: 0.7711868794717459,
          y: 0.06779388670243394,
        },
        {
          id: "235",
          x: 0.7796638648068219,
          y: 0.13559213052196908,
        },
        {
          id: "566",
          x: 0.5508506596745385,
          y: 0.1864364509817558,
        },
        {
          id: "520",
          x: 0.5847454027862475,
          y: 0.1864364509817558,
        },
        {
          id: "181",
          x: 0.8220344087971947,
          y: 0.2711863761493271,
        },
        {
          id: "70",
          x: 0.9067787117310594,
          y: 0.25423465249918314,
        },
        {
          id: "160",
          x: 0.8389838954537855,
          y: 0.30508550863462164,
        },
        {
          id: "205",
          x: 0.7966122516110299,
          y: 0.10169299803667456,
        },
        {
          id: "245",
          x: 0.7796638648068219,
          y: 0.30508550863462164,
        },
        {
          id: "337",
          x: 0.720341549851063,
          y: 0.1694912418562097,
        },
        {
          id: "467",
          x: 0.6355951318164621,
          y: 0.15254167561356247,
        },
        {
          id: "554",
          x: 0.5423748587958749,
          y: 0.05084649901833728,
          color: "#DB4437",
        },
        {
          id: "251",
          x: 0.7711868794717459,
          y: 0.13559213052196908,
        },
        {
          id: "357",
          x: 0.7118646491200166,
          y: 0.30508550863462164,
        },
        {
          id: "229",
          x: 0.7881353508799834,
          y: 0.2711863761493271,
        },
        {
          id: "121",
          x: 0.8644071524923332,
          y: 0.25423465249918314,
        },
        {
          id: "396",
          x: 0.5932223881213236,
          y: 0.37287941648810946,
        },
        {
          id: "140",
          x: 0.8474575812317129,
          y: 0.1694912418562097,
        },
        {
          id: "15",
          x: 0.9745767429614524,
          y: 0.2372851074075898,
        },
        {
          id: "393",
          x: 0.5932223881213236,
          y: 0.32203291746977214,
        },
        {
          id: "133",
          x: 0.8559344819627593,
          y: 0.25423465249918314,
        },
        {
          id: "186",
          x: 0.8135585233145016,
          y: 0.1864364509817558,
        },
        {
          id: "326",
          x: 0.7288152356289904,
          y: 0.1864364509817558,
        },
        {
          id: "226",
          x: 0.7881353508799834,
          y: 0.22033556231599638,
        },
        {
          id: "246",
          x: 0.7796638648068219,
          y: 0.32203291746977214,
        },
        {
          id: "208",
          x: 0.7966122516110299,
          y: 0.15254167561356247,
        },
        {
          id: "548",
          x: 0.5593233302041123,
          y: 0.22033556231599638,
        },
        {
          id: "55",
          x: 0.9237282829916796,
          y: 0.30508550863462164,
          radius: 2.262710144458981,
        },
        {
          id: "410",
          x: 0.6779655912028054,
          y: 0.1694912418562097,
        },
        {
          id: "43",
          x: 0.9322040838703434,
          y: 0.2372851074075898,
        },
        {
          id: "559",
          x: 0.5254253298372692,
          y: 0.06779388670243394,
        },
        {
          id: "37",
          x: 0.9406777696482707,
          y: 0.2372851074075898,
        },
        {
          id: "334",
          x: 0.720341549851063,
          y: 0.11864256427932182,
        },
        {
          id: "434",
          x: 0.6694941051296439,
          y: 0.20338599607334912,
        },
        {
          id: "304",
          x: 0.7457648068896107,
          y: 0.2711863761493271,
        },
        {
          id: "378",
          x: 0.6949151624634257,
          y: 0.28813378498447767,
        },
        {
          id: "377",
          x: 0.6949151624634257,
          y: 0.2711863761493271,
        },
        {
          id: "458",
          x: 0.6440677177420064,
          y: 0.1694912418562097,
        },
        {
          id: "428",
          x: 0.6271213614345054,
          y: 0.05084649901833728,
        },
        {
          id: "85",
          x: 0.8898334552759412,
          y: 0.2372851074075898,
        },
        {
          id: "61",
          x: 0.9152545972137525,
          y: 0.2372851074075898,
        },
        {
          id: "66",
          x: 0.9067787117310594,
          y: 0.1864364509817558,
        },
        {
          id: "171",
          x: 0.830508094575122,
          y: 0.28813378498447767,
        },
        {
          id: "30",
          x: 0.9491545857752877,
          y: 0.22033556231599638,
        },
        {
          id: "547",
          x: 0.5593233302041123,
          y: 0.20338599607334912,
        },
        {
          id: "197",
          x: 0.8050848375365743,
          y: 0.20338599607334912,
        },
        {
          id: "303",
          x: 0.7457648068896107,
          y: 0.25423465249918314,
        },
        {
          id: "278",
          x: 0.7542373082111256,
          y: 0.06779388670243394,
        },
        {
          id: "356",
          x: 0.7118646491200166,
          y: 0.28813378498447767,
        },
        {
          id: "173",
          x: 0.8220344087971947,
          y: 0.13559213052196908,
          color: "#DB4437",
        },
        {
          id: "81",
          x: 0.8898334552759412,
          y: 0.1694912418562097,
        },
        {
          id: "465",
          x: 0.6355951318164621,
          y: 0.11864256427932182,
          color: "#A566FF",
        },
        {
          id: "563",
          x: 0.5084747433282955,
          y: 0.06779388670243394,
        },
        {
          id: "91",
          x: 0.881356639148924,
          y: 0.1694912418562097,
        },
        {
          id: "438",
          x: 0.6694941051296439,
          y: 0.2711863761493271,
        },
        {
          id: "318",
          x: 0.7372878215545348,
          y: 0.25423465249918314,
        },
        {
          id: "8",
          x: 0.9830504287393796,
          y: 0.20338599607334912,
        },
        {
          id: "224",
          x: 0.7881353508799834,
          y: 0.1864364509817558,
        },
        {
          id: "162",
          x: 0.830508094575122,
          y: 0.13559213052196908,
        },
        {
          id: "86",
          x: 0.8898334552759412,
          y: 0.25423465249918314,
        },
        {
          id: "282",
          x: 0.7542373082111256,
          y: 0.15254167561356247,
        },
        {
          id: "110",
          x: 0.8728839686193501,
          y: 0.30508550863462164,
        },
        {
          id: "514",
          x: 0.5932223881213236,
          y: 0.22033556231599638,
        },
        {
          id: "451",
          x: 0.6525445338690236,
          y: 0.20338599607334912,
        },
        {
          id: "286",
          x: 0.7542373082111256,
          y: 0.22033556231599638,
        },
        {
          id: "207",
          x: 0.7966122516110299,
          y: 0.13559213052196908,
        },
        {
          id: "379",
          x: 0.6949151624634257,
          y: 0.30508550863462164,
        },
        {
          id: "552",
          x: 0.5593233302041123,
          y: 0.28813378498447767,
        },
        {
          id: "551",
          x: 0.5593233302041123,
          y: 0.2711863761493271,
        },
        {
          id: "234",
          x: 0.7796638648068219,
          y: 0.11864256427932182,
        },
        {
          id: "446",
          x: 0.6610171197945679,
          y: 0.25423465249918314,
        },
        {
          id: "347",
          x: 0.7118646491200166,
          y: 0.13559213052196908,
        },
        {
          id: "132",
          x: 0.8559344819627593,
          y: 0.2372851074075898,
        },
        {
          id: "118",
          x: 0.8644071524923332,
          y: 0.20338599607334912,
        },
        {
          id: "232",
          x: 0.7881353508799834,
          y: 0.32203291746977214,
        },
        {
          id: "168",
          x: 0.830508094575122,
          y: 0.2372851074075898,
        },
        {
          id: "49",
          x: 0.9237282829916796,
          y: 0.1864364509817558,
        },
        {
          id: "25",
          x: 0.9576272563048615,
          y: 0.2372851074075898,
          radius: 2.983713146074229,
        },
        {
          id: "279",
          x: 0.7542373082111256,
          y: 0.10169299803667456,
        },
        {
          id: "210",
          x: 0.7966122516110299,
          y: 0.1864364509817558,
        },
        {
          id: "322",
          x: 0.7288152356289904,
          y: 0.11864256427932182,
        },
        {
          id: "536",
          x: 0.5677948162772738,
          y: 0.1864364509817558,
        },
        {
          id: "198",
          x: 0.8050848375365743,
          y: 0.22033556231599638,
        },
        {
          id: "307",
          x: 0.7457648068896107,
          y: 0.32203291746977214,
        },
        {
          id: "395",
          x: 0.5932223881213236,
          y: 0.35592980794335444,
        },
        {
          id: "262",
          x: 0.7627142935462016,
          y: 0.06779388670243394,
        },
        {
          id: "38",
          x: 0.9406777696482707,
          y: 0.25423465249918314,
        },
        {
          id: "460",
          x: 0.6440677177420064,
          y: 0.20338599607334912,
        },
        {
          id: "269",
          x: 0.7627142935462016,
          y: 0.1864364509817558,
        },
        {
          id: "390",
          x: 0.6016949740468679,
          y: 0.32203291746977214,
        },
        {
          id: "407",
          x: 0.6864424919338519,
          y: 0.2711863761493271,
        },
        {
          id: "450",
          x: 0.6525445338690236,
          y: 0.1864364509817558,
        },
        {
          id: "187",
          x: 0.8135585233145016,
          y: 0.20338599607334912,
        },
        {
          id: "387",
          x: 0.8559344819627593,
          y: 0.38983109783614567,
        },
        {
          id: "509",
          x: 0.6016949740468679,
          y: 0.2711863761493271,
        },
        {
          id: "524",
          x: 0.5847454027862475,
          y: 0.25423465249918314,
          color: "#DB4437",
        },
        {
          id: "51",
          x: 0.9237282829916796,
          y: 0.22033556231599638,
        },
        {
          id: "325",
          x: 0.7288152356289904,
          y: 0.1694912418562097,
        },
        {
          id: "129",
          x: 0.8559344819627593,
          y: 0.1864364509817558,
        },
        {
          id: "543",
          x: 0.5677948162772738,
          y: 0.30508550863462164,
        },
        {
          id: "185",
          x: 0.8135585233145016,
          y: 0.1694912418562097,
        },
        {
          id: "545",
          x: 0.5593233302041123,
          y: 0.1694912418562097,
        },
        {
          id: "191",
          x: 0.8135585233145016,
          y: 0.2711863761493271,
        },
        {
          id: "258",
          x: 0.7711868794717459,
          y: 0.25423465249918314,
        },
        {
          id: "352",
          x: 0.7118646491200166,
          y: 0.22033556231599638,
        },
        {
          id: "54",
          x: 0.9237282829916796,
          y: 0.28813378498447767,
        },
        {
          id: "331",
          x: 0.7288152356289904,
          y: 0.2711863761493271,
        },
        {
          id: "374",
          x: 0.6949151624634257,
          y: 0.22033556231599638,
        },
        {
          id: "28",
          x: 0.9491545857752877,
          y: 0.1864364509817558,
        },
        {
          id: "123",
          x: 0.8644071524923332,
          y: 0.28813378498447767,
        },
        {
          id: "113",
          x: 0.8644071524923332,
          y: 0.10169299803667456,
          radius: 2.6652552798235414,
        },
        {
          id: "332",
          x: 0.7288152356289904,
          y: 0.28813378498447767,
        },
        {
          id: "338",
          x: 0.720341549851063,
          y: 0.1864364509817558,
        },
        {
          id: "213",
          x: 0.7966122516110299,
          y: 0.2372851074075898,
        },
        {
          id: "128",
          x: 0.8559344819627593,
          y: 0.1694912418562097,
        },
        {
          id: "431",
          x: 0.6016949740468679,
          y: 0.05084649901833728,
          radius: 2.1990302369370816,
          color: "#DB4437",
        },
        {
          id: "527",
          x: 0.5847454027862475,
          y: 0.30508550863462164,
        },
        {
          id: "528",
          x: 0.5762728168607032,
          y: 0.1864364509817558,
        },
        {
          id: "280",
          x: 0.7542373082111256,
          y: 0.11864256427932182,
        },
        {
          id: "351",
          x: 0.7118646491200166,
          y: 0.20338599607334912,
        },
        {
          id: "324",
          x: 0.7288152356289904,
          y: 0.15254167561356247,
        },
        {
          id: "544",
          x: 0.5593233302041123,
          y: 0.15254167561356247,
          color: "#F4B400",
        },
        {
          id: "180",
          x: 0.8220344087971947,
          y: 0.25423465249918314,
        },
        {
          id: "141",
          x: 0.8474575812317129,
          y: 0.1864364509817558,
        },
        {
          id: "248",
          x: 0.7711868794717459,
          y: 0.0847456315036318,
        },
        {
          id: "411",
          x: 0.6779655912028054,
          y: 0.1864364509817558,
        },
        {
          id: "44",
          x: 0.9322040838703434,
          y: 0.25423465249918314,
        },
        {
          id: "46",
          x: 0.9322040838703434,
          y: 0.28813378498447767,
        },
        {
          id: "115",
          x: 0.8644071524923332,
          y: 0.15254167561356247,
        },
        {
          id: "143",
          x: 0.8474575812317129,
          y: 0.22033556231599638,
        },
        {
          id: "341",
          x: 0.720341549851063,
          y: 0.2372851074075898,
        },
        {
          id: "272",
          x: 0.7627142935462016,
          y: 0.2372851074075898,
        },
        {
          id: "344",
          x: 0.720341549851063,
          y: 0.28813378498447767,
        },
        {
          id: "239",
          x: 0.7796638648068219,
          y: 0.20338599607334912,
        },
        {
          id: "157",
          x: 0.8389838954537855,
          y: 0.25423465249918314,
        },
        {
          id: "283",
          x: 0.7542373082111256,
          y: 0.1694912418562097,
          radius: 2.664624308135118,
        },
        {
          id: "138",
          x: 0.8559344819627593,
          y: 0.3389845988178084,
        },
        {
          id: "264",
          x: 0.7627142935462016,
          y: 0.10169299803667456,
        },
        {
          id: "414",
          x: 0.6779655912028054,
          y: 0.2372851074075898,
        },
        {
          id: "47",
          x: 0.9322040838703434,
          y: 0.30508550863462164,
          color: "#F4B400",
        },
        {
          id: "120",
          x: 0.8644071524923332,
          y: 0.2372851074075898,
        },
        {
          id: "512",
          x: 0.5932223881213236,
          y: 0.1864364509817558,
        },
        {
          id: "202",
          x: 0.8050848375365743,
          y: 0.28813378498447767,
        },
        {
          id: "426",
          x: 0.6355951318164621,
          y: 0.03389693277569003,
        },
        {
          id: "184",
          x: 0.8135585233145016,
          y: 0.15254167561356247,
        },
        {
          id: "59",
          x: 0.9152545972137525,
          y: 0.20338599607334912,
        },
        {
          id: "529",
          x: 0.5762728168607032,
          y: 0.20338599607334912,
        },
        {
          id: "425",
          x: 0.6440709326951256,
          y: 0.05084649901833728,
        },
        {
          id: "124",
          x: 0.8644071524923332,
          y: 0.30508550863462164,
        },
        {
          id: "558",
          x: 0.5254253298372692,
          y: 0.05084649901833728,
          color: "#DB4437",
        },
        {
          id: "267",
          x: 0.7627142935462016,
          y: 0.15254167561356247,
        },
        {
          id: "549",
          x: 0.5593233302041123,
          y: 0.2372851074075898,
        },
        {
          id: "421",
          x: 0.6694941051296439,
          y: 0.1694912418562097,
        },
        {
          id: "265",
          x: 0.7627142935462016,
          y: 0.11864256427932182,
        },
        {
          id: "404",
          x: 0.6864424919338519,
          y: 0.22033556231599638,
        },
        {
          id: "546",
          x: 0.5593233302041123,
          y: 0.1864364509817558,
        },
        {
          id: "403",
          x: 0.6864424919338519,
          y: 0.20338599607334912,
        },
        {
          id: "34",
          x: 0.9406777696482707,
          y: 0.1864364509817558,
        },
        {
          id: "111",
          x: 0.8728839686193501,
          y: 0.32203291746977214,
          color: "#DB4437",
        },
        {
          id: "244",
          x: 0.7796638648068219,
          y: 0.28813378498447767,
        },
        {
          id: "418",
          x: 0.6694941051296439,
          y: 0.10169299803667456,
        },
        {
          id: "557",
          x: 0.5339011730179475,
          y: 0.06779388670243394,
        },
        {
          id: "214",
          x: 0.7966122516110299,
          y: 0.25423465249918314,
        },
        {
          id: "562",
          x: 0.5169516440593419,
          y: 0.0847456315036318,
        },
        {
          id: "420",
          x: 0.6694941051296439,
          y: 0.15254167561356247,
        },
        {
          id: "513",
          x: 0.5932223881213236,
          y: 0.20338599607334912,
        },
        {
          id: "153",
          x: 0.8389838954537855,
          y: 0.1864364509817558,
        },
        {
          id: "423",
          x: 0.6610204193517165,
          y: 0.05084649901833728,
        },
        {
          id: "270",
          x: 0.7627142935462016,
          y: 0.20338599607334912,
        },
        {
          id: "122",
          x: 0.8644071524923332,
          y: 0.2711863761493271,
        },
        {
          id: "533",
          x: 0.5762728168607032,
          y: 0.2711863761493271,
        },
        {
          id: "400",
          x: 0.6864424919338519,
          y: 0.15254167561356247,
        },
        {
          id: "156",
          x: 0.8389838954537855,
          y: 0.2372851074075898,
          radius: 2.6708946418875508,
        },
        {
          id: "276",
          x: 0.7627142935462016,
          y: 0.30508550863462164,
        },
        {
          id: "209",
          x: 0.7966122516110299,
          y: 0.1694912418562097,
        },
        {
          id: "259",
          x: 0.7711868794717459,
          y: 0.2711863761493271,
        },
        {
          id: "402",
          x: 0.6864424919338519,
          y: 0.1864364509817558,
        },
        {
          id: "555",
          x: 0.5423748587958749,
          y: 0.0847456315036318,
          radius: 2.7716020443812273,
        },
        {
          id: "526",
          x: 0.5847454027862475,
          y: 0.28813378498447767,
        },
        {
          id: "243",
          x: 0.7796638648068219,
          y: 0.2711863761493271,
        },
        {
          id: "424",
          x: 0.6440709326951256,
          y: 0.03389693277569003,
        },
        {
          id: "126",
          x: 0.8644071524923332,
          y: 0.3389845988178084,
        },
        {
          id: "530",
          x: 0.5762728168607032,
          y: 0.22033556231599638,
        },
        {
          id: "119",
          x: 0.8644071524923332,
          y: 0.22033556231599638,
        },
        {
          id: "134",
          x: 0.8559344819627593,
          y: 0.2711863761493271,
        },
        {
          id: "137",
          x: 0.8559344819627593,
          y: 0.32203291746977214,
        },
        {
          id: "23",
          x: 0.9576272563048615,
          y: 0.20338599607334912,
          radius: 2.0965713035151143,
        },
        {
          id: "65",
          x: 0.9067787117310594,
          y: 0.1694912418562097,
        },
        {
          id: "58",
          x: 0.9152545972137525,
          y: 0.1864364509817558,
        },
        {
          id: "4",
          x: 0.9915263142220727,
          y: 0.1864364509817558,
        },
        {
          id: "7",
          x: 0.9830504287393796,
          y: 0.1864364509817558,
        },
        {
          id: "64",
          x: 0.9067787117310594,
          y: 0.15254167561356247,
        },
        {
          id: "315",
          x: 0.7372878215545348,
          y: 0.20338599607334912,
        },
        {
          id: "71",
          x: 0.8983061258055149,
          y: 0.11864256427932182,
          radius: 2.1756256515292973,
        },
        {
          id: "56",
          x: 0.9237282829916796,
          y: 0.32203291746977214,
        },
        {
          id: "88",
          x: 0.881356639148924,
          y: 0.11864256427932182,
        },
      ],
      region: "asia",
    },
    {
      id: "rwanda",
      dots: [
        {
          id: "0",
          x: 0.5593233302041123,
          y: 0.661013243774695,
        },
      ],
      region: "africa",
    },
    {
      id: "samoa",
      dots: [
        {
          id: "0",
          x: 0.9999999153959706,
          y: 0.7627126717317518,
          radius: 2.8497000560873627,
        },
      ],
      region: "australia",
    },
    {
      id: "sao_tome_and_principe",
      dots: [
        {
          id: "0",
          x: 0.49152847162482377,
          y: 0.661013243774695,
        },
      ],
      region: "africa",
    },
    {
      id: "saudi_arabia",
      dots: [
        {
          id: "1",
          x: 0.610171790173885,
          y: 0.5084715047079709,
        },
        {
          id: "0",
          x: 0.6186444607034589,
          y: 0.5254297851848204,
        },
        {
          id: "11",
          x: 0.5932223881213236,
          y: 0.5423706371932654,
        },
        {
          id: "7",
          x: 0.5932223881213236,
          y: 0.4745745719322808,
        },
        {
          id: "6",
          x: 0.6016949740468679,
          y: 0.5423706371932654,
        },
        {
          id: "14",
          x: 0.5847454027862475,
          y: 0.5084715047079709,
        },
        {
          id: "2",
          x: 0.610171790173885,
          y: 0.5254297851848204,
        },
        {
          id: "10",
          x: 0.5932223881213236,
          y: 0.5254297851848204,
        },
        {
          id: "5",
          x: 0.6016949740468679,
          y: 0.5254297851848204,
        },
        {
          id: "13",
          x: 0.5847454027862475,
          y: 0.4915284529899215,
        },
        {
          id: "16",
          x: 0.5762728168607032,
          y: 0.4915284529899215,
        },
        {
          id: "8",
          x: 0.5932223881213236,
          y: 0.4915284529899215,
        },
        {
          id: "12",
          x: 0.5847454027862475,
          y: 0.4745745719322808,
          color: "#DB4437",
        },
        {
          id: "9",
          x: 0.5932223881213236,
          y: 0.5084715047079709,
        },
        {
          id: "3",
          x: 0.6016949740468679,
          y: 0.4915284529899215,
        },
        {
          id: "15",
          x: 0.5847454027862475,
          y: 0.5254297851848204,
        },
        {
          id: "4",
          x: 0.6016949740468679,
          y: 0.5084715047079709,
        },
      ],
      region: "middle_east",
    },
    {
      id: "senegal",
      dots: [
        {
          id: "2",
          x: 0.4322040838703433,
          y: 0.5762740844935532,
        },
        {
          id: "1",
          x: 0.4237293405420479,
          y: 0.5593288753680071,
          color: "#F4B400",
        },
        {
          id: "0",
          x: 0.4322040838703433,
          y: 0.5593288753680071,
        },
      ],
      region: "africa",
    },
    {
      id: "serbia",
      dots: [
        {
          id: "0",
          x: 0.5423748587958749,
          y: 0.37287941648810946,
        },
      ],
      region: "europe",
    },
    {
      id: "sierra_leone",
      dots: [
        {
          id: "0",
          x: 0.44067882719863877,
          y: 0.6101688175596388,
        },
      ],
      region: "africa",
    },
    {
      id: "singapore",
      dots: [
        {
          id: "0",
          x: 0.7711868794717459,
          y: 0.6440722648599267,
        },
      ],
      region: "asia",
    },
    {
      id: "slovakia",
      dots: [
        {
          id: "0",
          x: 0.5254253298372692,
          y: 0.3389845988178084,
        },
      ],
      region: "europe",
    },
    {
      id: "slovenia",
      dots: [
        {
          id: "0",
          x: 0.5169516440593419,
          y: 0.37287941648810946,
        },
      ],
      region: "europe",
    },
    {
      id: "solomon_islands",
      dots: [
        {
          id: "0",
          x: 0.9322041684743728,
          y: 0.7118684147251269,
          color: "#F4B400",
        },
      ],
      region: "australia",
    },
    {
      id: "somalia",
      dots: [
        {
          id: "1",
          x: 0.6186444607034589,
          y: 0.6101688175596388,
          color: "#DB4437",
        },
        {
          id: "2",
          x: 0.610171790173885,
          y: 0.5932258081436972,
        },
        {
          id: "3",
          x: 0.610171790173885,
          y: 0.6101688175596388,
        },
        {
          id: "4",
          x: 0.6016949740468679,
          y: 0.5932258081436972,
        },
        {
          id: "0",
          x: 0.6186444607034589,
          y: 0.5932258081436972,
        },
        {
          id: "5",
          x: 0.6016949740468679,
          y: 0.6271270557343807,
        },
      ],
      region: "africa",
    },
    {
      id: "south_africa",
      dots: [
        {
          id: "5",
          x: 0.5423748587958749,
          y: 0.8135592130521969,
        },
        {
          id: "7",
          x: 0.5423748587958749,
          y: 0.847460545247096,
        },
        {
          id: "10",
          x: 0.5339011730179475,
          y: 0.847460545247096,
          radius: 2.2871384479149315,
        },
        {
          id: "0",
          x: 0.5593233302041123,
          y: 0.7966118042170462,
        },
        {
          id: "1",
          x: 0.5593233302041123,
          y: 0.8305110213065564,
        },
        {
          id: "12",
          x: 0.5254253298372692,
          y: 0.847460545247096,
          color: "#2EB67D",
        },
        {
          id: "11",
          x: 0.5254253298372692,
          y: 0.8305110213065564,
        },
        {
          id: "2",
          x: 0.5508506596745385,
          y: 0.7966118042170462,
        },
        {
          id: "3",
          x: 0.5508506596745385,
          y: 0.8135592130521969,
        },
        {
          id: "4",
          x: 0.5508506596745385,
          y: 0.847460545247096,
        },
        {
          id: "8",
          x: 0.5339011730179475,
          y: 0.8135592130521969,
        },
        {
          id: "9",
          x: 0.5339011730179475,
          y: 0.8305110213065564,
        },
        {
          id: "6",
          x: 0.5423748587958749,
          y: 0.8305110213065564,
        },
      ],
      region: "africa",
    },
    {
      id: "south_korea",
      dots: [
        {
          id: "1",
          x: 0.830508094575122,
          y: 0.42372811521605125,
        },
        {
          id: "0",
          x: 0.8389838954537855,
          y: 0.42372811521605125,
        },
      ],
      region: "asia",
    },
    {
      id: "south_sudan",
      dots: [
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.5932258081436972,
        },
        {
          id: "3",
          x: 0.5593233302041123,
          y: 0.6101688175596388,
        },
        {
          id: "1",
          x: 0.5677948162772738,
          y: 0.6101688175596388,
        },
        {
          id: "2",
          x: 0.5593233302041123,
          y: 0.5932258081436972,
        },
        {
          id: "4",
          x: 0.5508506596745385,
          y: 0.5932258081436972,
        },
      ],
      region: "africa",
    },
    {
      id: "spain",
      dots: [
        {
          id: "5",
          x: 0.45762505660009567,
          y: 0.4067785066712962,
        },
        {
          id: "1",
          x: 0.47457458555870136,
          y: 0.4067785066712962,
        },
        {
          id: "0",
          x: 0.4661030994855398,
          y: 0.4067785066712962,
        },
        {
          id: "7",
          x: 0.44915251297656605,
          y: 0.38983109783614567,
        },
        {
          id: "2",
          x: 0.4661030994855398,
          y: 0.38983109783614567,
        },
        {
          id: "3",
          x: 0.4661030994855398,
          y: 0.42372811521605125,
        },
        {
          id: "4",
          x: 0.45762505660009567,
          y: 0.38983109783614567,
        },
        {
          id: "6",
          x: 0.45762505660009567,
          y: 0.42372811521605125,
          scale: 1.5,
        },
      ],
      region: "europe",
    },
    {
      id: "sri_lanka",
      dots: [
        {
          id: "0",
          x: 0.7033920631944722,
          y: 0.6101688175596388,
        },
      ],
      region: "asia",
    },
    {
      id: "st_lucia",
      dots: [
        {
          id: "0",
          x: 0.2881364084303516,
          y: 0.5762740844935532,
          color: "#DB4437",
        },
      ],
      region: "south_america",
    },
    {
      id: "sudan",
      dots: [
        {
          id: "3",
          x: 0.5677948162772738,
          y: 0.5254297851848204,
        },
        {
          id: "14",
          x: 0.5508506596745385,
          y: 0.5762740844935532,
        },
        {
          id: "15",
          x: 0.5423748587958749,
          y: 0.5593288753680071,
        },
        {
          id: "2",
          x: 0.5762728168607032,
          y: 0.5593288753680071,
        },
        {
          id: "13",
          x: 0.5508506596745385,
          y: 0.5593288753680071,
        },
        {
          id: "9",
          x: 0.5593233302041123,
          y: 0.5593288753680071,
        },
        {
          id: "5",
          x: 0.5677948162772738,
          y: 0.5593288753680071,
        },
        {
          id: "1",
          x: 0.5762728168607032,
          y: 0.5423706371932654,
        },
        {
          id: "6",
          x: 0.5677948162772738,
          y: 0.5762740844935532,
        },
        {
          id: "12",
          x: 0.5508506596745385,
          y: 0.5423706371932654,
        },
        {
          id: "8",
          x: 0.5593233302041123,
          y: 0.5423706371932654,
        },
        {
          id: "11",
          x: 0.5508506596745385,
          y: 0.5254297851848204,
        },
        {
          id: "16",
          x: 0.5423748587958749,
          y: 0.5762740844935532,
        },
        {
          id: "4",
          x: 0.5677948162772738,
          y: 0.5423706371932654,
        },
        {
          id: "7",
          x: 0.5593233302041123,
          y: 0.5254297851848204,
        },
        {
          id: "0",
          x: 0.5762728168607032,
          y: 0.5254297851848204,
        },
        {
          id: "10",
          x: 0.5593233302041123,
          y: 0.5762740844935532,
        },
      ],
      region: "africa",
    },
    {
      id: "surinam",
      dots: [
        {
          id: "0",
          x: 0.3135607230192674,
          y: 0.6271270557343807,
        },
      ],
      region: "south_america",
    },
    {
      id: "swaziland",
      dots: [
        {
          id: "0",
          x: 0.5593233302041123,
          y: 0.8135592130521969,
        },
      ],
      region: "africa",
    },
    {
      id: "sweden",
      dots: [
        {
          id: "9",
          x: 0.5084747433282955,
          y: 0.2372851074075898,
        },
        {
          id: "7",
          x: 0.5169516440593419,
          y: 0.2711863761493271,
        },
        {
          id: "6",
          x: 0.5169516440593419,
          y: 0.25423465249918314,
        },
        {
          id: "11",
          x: 0.5084747433282955,
          y: 0.2711863761493271,
        },
        {
          id: "5",
          x: 0.5169516440593419,
          y: 0.2372851074075898,
        },
        {
          id: "10",
          x: 0.5084747433282955,
          y: 0.25423465249918314,
        },
        {
          id: "4",
          x: 0.5169516440593419,
          y: 0.22033556231599638,
        },
        {
          id: "3",
          x: 0.5169516440593419,
          y: 0.20338599607334912,
        },
        {
          id: "2",
          x: 0.5254253298372692,
          y: 0.25423465249918314,
        },
        {
          id: "1",
          x: 0.5254253298372692,
          y: 0.22033556231599638,
        },
        {
          id: "0",
          x: 0.5254253298372692,
          y: 0.20338599607334912,
        },
        {
          id: "8",
          x: 0.5169516440593419,
          y: 0.28813378498447767,
        },
      ],
      region: "europe",
    },
    {
      id: "switzerland",
      dots: [
        {
          id: "1",
          x: 0.491524114517307,
          y: 0.35592980794335444,
        },
        {
          id: "0",
          x: 0.5000021151007363,
          y: 0.35592980794335444,
        },
      ],
      region: "europe",
    },
    {
      id: "syria",
      dots: [
        {
          id: "1",
          x: 0.5762728168607032,
          y: 0.4406819962736919,
        },
        {
          id: "0",
          x: 0.5847454027862475,
          y: 0.4406819962736919,
        },
      ],
      region: "middle_east",
    },
    {
      id: "taiwan",
      dots: [
        {
          id: "0",
          x: 0.8135585233145016,
          y: 0.5084715047079709,
        },
      ],
      region: "asia",
    },
    {
      id: "tajikistan",
      dots: [
        {
          id: "0",
          x: 0.6779655912028054,
          y: 0.4067785066712962,
          radius: 2.2070267200019558,
        },
        {
          id: "1",
          x: 0.6779655912028054,
          y: 0.42372811521605125,
        },
        {
          id: "2",
          x: 0.6694941051296439,
          y: 0.4067785066712962,
        },
      ],
      region: "middle_east",
    },
    {
      id: "tanzania",
      dots: [
        {
          id: "8",
          x: 0.5677948162772738,
          y: 0.6949144913653784,
        },
        {
          id: "1",
          x: 0.5847454027862475,
          y: 0.6949144913653784,
        },
        {
          id: "3",
          x: 0.5762728168607032,
          y: 0.661013243774695,
          radius: 2.6038438662596906,
        },
        {
          id: "5",
          x: 0.5762728168607032,
          y: 0.6949144913653784,
        },
        {
          id: "7",
          x: 0.5677948162772738,
          y: 0.6779692822398323,
        },
        {
          id: "6",
          x: 0.5677948162772738,
          y: 0.661013243774695,
        },
        {
          id: "4",
          x: 0.5762728168607032,
          y: 0.6779692822398323,
        },
        {
          id: "2",
          x: 0.5847454027862475,
          y: 0.7118684147251269,
        },
        {
          id: "0",
          x: 0.5847454027862475,
          y: 0.6779692822398323,
        },
      ],
      region: "africa",
    },
    {
      id: "thailand",
      dots: [
        {
          id: "3",
          x: 0.7542373082111256,
          y: 0.5593288753680071,
        },
        {
          id: "2",
          x: 0.7542373082111256,
          y: 0.5423706371932654,
        },
        {
          id: "4",
          x: 0.7542373082111256,
          y: 0.5762740844935532,
        },
        {
          id: "1",
          x: 0.7627142935462016,
          y: 0.6101688175596388,
        },
        {
          id: "5",
          x: 0.7542373082111256,
          y: 0.5932258081436972,
        },
        {
          id: "0",
          x: 0.7627142935462016,
          y: 0.5593288753680071,
        },
      ],
      region: "asia",
    },
    {
      id: "timor_leste",
      dots: [
        {
          id: "0",
          x: 0.8220344087971947,
          y: 0.7118684147251269,
        },
      ],
      region: "asia",
    },
    {
      id: "togo",
      dots: [
        {
          id: "0",
          x: 0.47457458555870136,
          y: 0.6101688175596388,
        },
      ],
      region: "africa",
    },
    {
      id: "tonga",
      dots: [
        {
          id: "0",
          x: 0.9915262296180432,
          y: 0.7796665950915004,
        },
      ],
      region: "australia",
    },
    {
      id: "tunisia",
      dots: [
        {
          id: "0",
          x: 0.5000021151007363,
          y: 0.4406819962736919,
        },
        {
          id: "1",
          x: 0.5000021151007363,
          y: 0.4576315202142314,
        },
        {
          id: "2",
          x: 0.5084747433282955,
          y: 0.4576315202142314,
        },
      ],
      region: "africa",
    },
    {
      id: "turkey",
      dots: [
        {
          id: "6",
          x: 0.5677948162772738,
          y: 0.4067785066712962,
        },
        {
          id: "2",
          x: 0.5847454027862475,
          y: 0.4067785066712962,
        },
        {
          id: "7",
          x: 0.5677948162772738,
          y: 0.42372811521605125,
        },
        {
          id: "1",
          x: 0.5932223881213236,
          y: 0.42372811521605125,
        },
        {
          id: "10",
          x: 0.5508506596745385,
          y: 0.4067785066712962,
        },
        {
          id: "11",
          x: 0.5508506596745385,
          y: 0.42372811521605125,
        },
        {
          id: "9",
          x: 0.5593233302041123,
          y: 0.42372811521605125,
        },
        {
          id: "0",
          x: 0.5932223881213236,
          y: 0.4067785066712962,
        },
        {
          id: "3",
          x: 0.5847454027862475,
          y: 0.42372811521605125,
        },
        {
          id: "8",
          x: 0.5593233302041123,
          y: 0.4067785066712962,
        },
        {
          id: "5",
          x: 0.5762728168607032,
          y: 0.42372811521605125,
        },
        {
          id: "4",
          x: 0.5762728168607032,
          y: 0.4067785066712962,
        },
      ],
      region: "europe",
    },
    {
      id: "turkmenistan",
      dots: [
        {
          id: "0",
          x: 0.6525445338690236,
          y: 0.42372811521605125,
        },
        {
          id: "1",
          x: 0.6440677177420064,
          y: 0.4067785066712962,
        },
        {
          id: "6",
          x: 0.6271213614345054,
          y: 0.4067785066712962,
        },
        {
          id: "2",
          x: 0.6440677177420064,
          y: 0.42372811521605125,
          radius: 2.3392419617357856,
        },
        {
          id: "5",
          x: 0.6271213614345054,
          y: 0.38983109783614567,
        },
        {
          id: "3",
          x: 0.6355951318164621,
          y: 0.38983109783614567,
        },
        {
          id: "4",
          x: 0.6355951318164621,
          y: 0.4067785066712962,
          color: "#F4B400",
        },
      ],
      region: "middle_east",
    },
    {
      id: "turks_and_caicos",
      dots: [
        {
          id: "0",
          x: 0.27118687947174597,
          y: 0.5254297851848204,
          radius: 2.346920093768891,
        },
      ],
      region: "south_america",
    },
    {
      id: "uganda",
      dots: [
        {
          id: "2",
          x: 0.5593233302041123,
          y: 0.6440722648599267,
        },
        {
          id: "1",
          x: 0.5677948162772738,
          y: 0.6440722648599267,
        },
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.6271270557343807,
        },
      ],
      region: "africa",
    },
    {
      id: "ukraine",
      dots: [
        {
          id: "5",
          x: 0.5677948162772738,
          y: 0.35592980794335444,
        },
        {
          id: "2",
          x: 0.5762728168607032,
          y: 0.35592980794335444,
        },
        {
          id: "13",
          x: 0.5762728168607032,
          y: 0.37287941648810946,
        },
        {
          id: "3",
          x: 0.5677948162772738,
          y: 0.32203291746977214,
        },
        {
          id: "4",
          x: 0.5677948162772738,
          y: 0.3389845988178084,
        },
        {
          id: "1",
          x: 0.5762728168607032,
          y: 0.3389845988178084,
        },
        {
          id: "0",
          x: 0.5847454027862475,
          y: 0.35592980794335444,
        },
        {
          id: "14",
          x: 0.5847454027862475,
          y: 0.3389845988178084,
        },
        {
          id: "8",
          x: 0.5593233302041123,
          y: 0.37287941648810946,
        },
        {
          id: "9",
          x: 0.5508506596745385,
          y: 0.3389845988178084,
        },
        {
          id: "7",
          x: 0.5593233302041123,
          y: 0.3389845988178084,
        },
        {
          id: "10",
          x: 0.5423748587958749,
          y: 0.3389845988178084,
        },
        {
          id: "6",
          x: 0.5677948162772738,
          y: 0.37287941648810946,
        },
        {
          id: "11",
          x: 0.5593233302041123,
          y: 0.32203291746977214,
        },
        {
          id: "12",
          x: 0.5847454027862475,
          y: 0.37287941648810946,
        },
      ],
      region: "europe",
    },
    {
      id: "united_arab_emirates",
      dots: [
        {
          id: "0",
          x: 0.6271213614345054,
          y: 0.5254297851848204,
        },
      ],
      region: "middle_east",
    },
    {
      id: "united_kingdom",
      dots: [
        {
          id: "1",
          x: 0.46610525688829085,
          y: 0.25423465249918314,
        },
        {
          id: "0",
          x: 0.4745789849682329,
          y: 0.30508550863462164,
        },
        {
          id: "10",
          x: 0.45762941370761256,
          y: 0.32203291746977214,
          color: "#A566FF",
        },
        {
          id: "6",
          x: 0.46610525688829085,
          y: 0.32203291746977214,
        },
        {
          id: "3",
          x: 0.46610525688829085,
          y: 0.2711863761493271,
        },
        {
          id: "4",
          x: 0.46610525688829085,
          y: 0.28813378498447767,
        },
        {
          id: "7",
          x: 0.45762941370761256,
          y: 0.2711863761493271,
        },
        {
          id: "2",
          x: 0.4745821999213521,
          y: 0.25423465249918314,
        },
        {
          id: "11",
          x: 0.4491557279296852,
          y: 0.28813378498447767,
        },
        {
          id: "8",
          x: 0.45762941370761256,
          y: 0.28813378498447767,
          radius: 2.6676411171891132,
          color: "#DB4437",
        },
        {
          id: "5",
          x: 0.46610525688829085,
          y: 0.30508550863462164,
        },
        {
          id: "9",
          x: 0.45762941370761256,
          y: 0.30508550863462164,
        },
      ],
      region: "europe",
    },
    {
      id: "us",
      dots: [
        {
          id: "93",
          x: 0.22881523562899034,
          y: 0.35592980794335444,
        },
        {
          id: "98",
          x: 0.22881523562899034,
          y: 0.4576315202142314,
        },
        {
          id: "187",
          x: 0.13559508951444732,
          y: 0.4067785066712962,
        },
        {
          id: "65",
          x: 0,
          y: 0.22033556231599638,
        },
        {
          id: "179",
          x: 0.14406875414136724,
          y: 0.38983109783614567,
        },
        {
          id: "147",
          x: 0.1779667122061956,
          y: 0.37287941648810946,
        },
        {
          id: "148",
          x: 0.1779667122061956,
          y: 0.38983109783614567,
        },
        {
          id: "122",
          x: 0.2033909633420893,
          y: 0.42372811521605125,
        },
        {
          id: "143",
          x: 0.1864414766854984,
          y: 0.4576315202142314,
        },
        {
          id: "99",
          x: 0.22881523562899034,
          y: 0.4745745719322808,
        },
        {
          id: "113",
          x: 0.2118657489723995,
          y: 0.42372811521605125,
        },
        {
          id: "131",
          x: 0.19491622001379386,
          y: 0.42372811521605125,
        },
        {
          id: "20",
          x: 0.05084856572480949,
          y: 0.22033556231599638,
        },
        {
          id: "30",
          x: 0.033899057917211234,
          y: 0.15254167561356247,
        },
        {
          id: "40",
          x: 0.025425372139283954,
          y: 0.1694912418562097,
        },
        {
          id: "38",
          x: 0.033899057917211234,
          y: 0.28813378498447767,
        },
        {
          id: "84",
          x: 0.24576476458759597,
          y: 0.4745745719322808,
        },
        {
          id: "66",
          x: 0,
          y: 0.30508550863462164,
        },
        {
          id: "45",
          x: 0.025425372139283954,
          y: 0.25423465249918314,
        },
        {
          id: "22",
          x: 0.05084856572480949,
          y: 0.25423465249918314,
        },
        {
          id: "11",
          x: 0.05932440890548782,
          y: 0.1694912418562097,
        },
        {
          id: "194",
          x: 0.12711924633376898,
          y: 0.4067785066712962,
        },
        {
          id: "79",
          x: 0.24576476458759597,
          y: 0.38983109783614567,
        },
        {
          id: "127",
          x: 0.19491622001379386,
          y: 0.35592980794335444,
        },
        {
          id: "77",
          x: 0.2542373928151551,
          y: 0.42372811521605125,
        },
        {
          id: "138",
          x: 0.1864414766854984,
          y: 0.37287941648810946,
        },
        {
          id: "104",
          x: 0.2203404923006949,
          y: 0.42372811521605125,
        },
        {
          id: "135",
          x: 0.19491622001379386,
          y: 0.4915284529899215,
        },
        {
          id: "91",
          x: 0.23728892140691765,
          y: 0.4576315202142314,
        },
        {
          id: "68",
          x: 0.27966166510205615,
          y: 0.35592980794335444,
        },
        {
          id: "49",
          x: 0.016949528958605617,
          y: 0.1864364509817558,
        },
        {
          id: "76",
          x: 0.2542373928151551,
          y: 0.4067785066712962,
        },
        {
          id: "35",
          x: 0.033899057917211234,
          y: 0.2372851074075898,
        },
        {
          id: "82",
          x: 0.24576476458759597,
          y: 0.4406819962736919,
        },
        {
          id: "28",
          x: 0.04237490109788957,
          y: 0.25423465249918314,
        },
        {
          id: "36",
          x: 0.033899057917211234,
          y: 0.25423465249918314,
        },
        {
          id: "150",
          x: 0.1779667122061956,
          y: 0.42372811521605125,
        },
        {
          id: "3",
          x: 0.10169603159723609,
          y: 0.30508550863462164,
        },
        {
          id: "29",
          x: 0.04237490109788957,
          y: 0.2711863761493271,
        },
        {
          id: "133",
          x: 0.19491622001379386,
          y: 0.4576315202142314,
        },
        {
          id: "137",
          x: 0.1864414766854984,
          y: 0.35592980794335444,
        },
        {
          id: "24",
          x: 0.04237490109788957,
          y: 0.1864364509817558,
        },
        {
          id: "94",
          x: 0.22881523562899034,
          y: 0.37287941648810946,
        },
        {
          id: "169",
          x: 0.1525445761710382,
          y: 0.3389845988178084,
        },
        {
          id: "178",
          x: 0.14406875414136724,
          y: 0.37287941648810946,
        },
        {
          id: "192",
          x: 0.12711924633376898,
          y: 0.37287941648810946,
        },
        {
          id: "153",
          x: 0.16949194772689277,
          y: 0.3389845988178084,
        },
        {
          id: "71",
          x: 0.27118687947174597,
          y: 0.38983109783614567,
        },
        {
          id: "54",
          x: 0.016949528958605617,
          y: 0.2711863761493271,
        },
        {
          id: "181",
          x: 0.14406875414136724,
          y: 0.42372811521605125,
        },
        {
          id: "0",
          x: 0.09322128826894065,
          y: 0.28813378498447767,
        },
        {
          id: "46",
          x: 0.025425372139283954,
          y: 0.2711863761493271,
        },
        {
          id: "165",
          x: 0.1610182619489655,
          y: 0.4067785066712962,
        },
        {
          id: "115",
          x: 0.2118657489723995,
          y: 0.4576315202142314,
        },
        {
          id: "34",
          x: 0.033899057917211234,
          y: 0.22033556231599638,
        },
        {
          id: "177",
          x: 0.14406875414136724,
          y: 0.35592980794335444,
        },
        {
          id: "166",
          x: 0.1610182619489655,
          y: 0.42372811521605125,
        },
        {
          id: "19",
          x: 0.05084856572480949,
          y: 0.20338599607334912,
        },
        {
          id: "101",
          x: 0.2203404923006949,
          y: 0.37287941648810946,
        },
        {
          id: "58",
          x: 0.008474764479302808,
          y: 0.20338599607334912,
        },
        {
          id: "144",
          x: 0.1864414766854984,
          y: 0.4745745719322808,
        },
        {
          id: "64",
          x: 0,
          y: 0.20338599607334912,
        },
        {
          id: "32",
          x: 0.033899057917211234,
          y: 0.1864364509817558,
        },
        {
          id: "193",
          x: 0.12711924633376898,
          y: 0.38983109783614567,
        },
        {
          id: "86",
          x: 0.23728892140691765,
          y: 0.37287941648810946,
        },
        {
          id: "96",
          x: 0.22881523562899034,
          y: 0.4067785066712962,
        },
        {
          id: "156",
          x: 0.16949194772689277,
          y: 0.38983109783614567,
        },
        {
          id: "21",
          x: 0.05084856572480949,
          y: 0.2372851074075898,
        },
        {
          id: "170",
          x: 0.1525445761710382,
          y: 0.35592980794335444,
        },
        {
          id: "128",
          x: 0.19491622001379386,
          y: 0.37287941648810946,
          radius: 2.3631733851748815,
        },
        {
          id: "37",
          x: 0.033899057917211234,
          y: 0.2711863761493271,
        },
        {
          id: "110",
          x: 0.2118657489723995,
          y: 0.37287941648810946,
        },
        {
          id: "121",
          x: 0.2033909633420893,
          y: 0.4067785066712962,
        },
        {
          id: "195",
          x: 0.12711924633376898,
          y: 0.42372811521605125,
          radius: 2.862363173769686,
        },
        {
          id: "87",
          x: 0.23728892140691765,
          y: 0.38983109783614567,
        },
        {
          id: "8",
          x: 0.06779807353240774,
          y: 0.22033556231599638,
        },
        {
          id: "142",
          x: 0.1864414766854984,
          y: 0.4406819962736919,
        },
        {
          id: "183",
          x: 0.13559508951444732,
          y: 0.3389845988178084,
        },
        {
          id: "41",
          x: 0.025425372139283954,
          y: 0.1864364509817558,
        },
        {
          id: "106",
          x: 0.2203404923006949,
          y: 0.4576315202142314,
        },
        {
          id: "2",
          x: 0.07627393786409344,
          y: 0.25423465249918314,
        },
        {
          id: "47",
          x: 0.025425372139283954,
          y: 0.28813378498447767,
        },
        {
          id: "16",
          x: 0.05932440890548782,
          y: 0.25423465249918314,
        },
        {
          id: "145",
          x: 0.1779667122061956,
          y: 0.3389845988178084,
        },
        {
          id: "92",
          x: 0.23728892140691765,
          y: 0.4745745719322808,
          radius: 2.4563372979336346,
        },
        {
          id: "152",
          x: 0.1779667122061956,
          y: 0.4576315202142314,
        },
        {
          id: "25",
          x: 0.04237490109788957,
          y: 0.20338599607334912,
        },
        {
          id: "17",
          x: 0.05084856572480949,
          y: 0.1694912418562097,
        },
        {
          id: "4",
          x: 0.09322128826894065,
          y: 0.30508550863462164,
        },
        {
          id: "151",
          x: 0.1779667122061956,
          y: 0.4406819962736919,
        },
        {
          id: "56",
          x: 0.016949528958605617,
          y: 0.30508550863462164,
        },
        {
          id: "116",
          x: 0.2118657489723995,
          y: 0.4745745719322808,
        },
        {
          id: "117",
          x: 0.2033909633420893,
          y: 0.3389845988178084,
        },
        {
          id: "140",
          x: 0.1864414766854984,
          y: 0.4067785066712962,
        },
        {
          id: "89",
          x: 0.23728892140691765,
          y: 0.42372811521605125,
        },
        {
          id: "190",
          x: 0.12711924633376898,
          y: 0.3389845988178084,
        },
        {
          id: "1",
          x: 0.08474652378963783,
          y: 0.2711863761493271,
        },
        {
          id: "80",
          x: 0.24576476458759597,
          y: 0.4067785066712962,
        },
        {
          id: "88",
          x: 0.23728892140691765,
          y: 0.4067785066712962,
        },
        {
          id: "15",
          x: 0.05932440890548782,
          y: 0.2372851074075898,
        },
        {
          id: "111",
          x: 0.2118657489723995,
          y: 0.38983109783614567,
        },
        {
          id: "97",
          x: 0.22881523562899034,
          y: 0.42372811521605125,
        },
        {
          id: "69",
          x: 0.27966166510205615,
          y: 0.37287941648810946,
        },
        {
          id: "9",
          x: 0.06779807353240774,
          y: 0.2372851074075898,
        },
        {
          id: "139",
          x: 0.1864414766854984,
          y: 0.38983109783614567,
        },
        {
          id: "5",
          x: 0.06779807353240774,
          y: 0.1694912418562097,
        },
        {
          id: "52",
          x: 0.016949528958605617,
          y: 0.2372851074075898,
        },
        {
          id: "39",
          x: 0.025425372139283954,
          y: 0.15254167561356247,
        },
        {
          id: "43",
          x: 0.025425372139283954,
          y: 0.22033556231599638,
        },
        {
          id: "123",
          x: 0.2033909633420893,
          y: 0.4406819962736919,
        },
        {
          id: "78",
          x: 0.2542373928151551,
          y: 0.4406819962736919,
        },
        {
          id: "126",
          x: 0.19491622001379386,
          y: 0.3389845988178084,
        },
        {
          id: "72",
          x: 0.2627121361434505,
          y: 0.37287941648810946,
        },
        {
          id: "100",
          x: 0.2203404923006949,
          y: 0.35592980794335444,
        },
        {
          id: "67",
          x: 0,
          y: 0.32203291746977214,
        },
        {
          id: "118",
          x: 0.2033909633420893,
          y: 0.35592980794335444,
        },
        {
          id: "112",
          x: 0.2118657489723995,
          y: 0.4067785066712962,
        },
        {
          id: "141",
          x: 0.1864414766854984,
          y: 0.42372811521605125,
        },
        {
          id: "18",
          x: 0.05084856572480949,
          y: 0.1864364509817558,
        },
        {
          id: "48",
          x: 0.016949528958605617,
          y: 0.1694912418562097,
          color: "#A566FF",
        },
        {
          id: "149",
          x: 0.1779667122061956,
          y: 0.4067785066712962,
        },
        {
          id: "154",
          x: 0.16949194772689277,
          y: 0.35592980794335444,
        },
        {
          id: "184",
          x: 0.13559508951444732,
          y: 0.35592980794335444,
        },
        {
          id: "23",
          x: 0.04237490109788957,
          y: 0.1694912418562097,
        },
        {
          id: "73",
          x: 0.2627121361434505,
          y: 0.38983109783614567,
        },
        {
          id: "146",
          x: 0.1779667122061956,
          y: 0.35592980794335444,
        },
        {
          id: "57",
          x: 0.008474764479302808,
          y: 0.1864364509817558,
        },
        {
          id: "31",
          x: 0.033899057917211234,
          y: 0.1694912418562097,
        },
        {
          id: "50",
          x: 0.016949528958605617,
          y: 0.20338599607334912,
        },
        {
          id: "189",
          x: 0.13559508951444732,
          y: 0.4406819962736919,
          color: "#DB4437",
        },
        {
          id: "167",
          x: 0.1610182619489655,
          y: 0.4406819962736919,
        },
        {
          id: "6",
          x: 0.06779807353240774,
          y: 0.1864364509817558,
        },
        {
          id: "85",
          x: 0.24576476458759597,
          y: 0.4915284529899215,
        },
        {
          id: "14",
          x: 0.05932440890548782,
          y: 0.22033556231599638,
        },
        {
          id: "160",
          x: 0.16949194772689277,
          y: 0.4576315202142314,
        },
        {
          id: "132",
          x: 0.19491622001379386,
          y: 0.4406819962736919,
        },
        {
          id: "109",
          x: 0.2118657489723995,
          y: 0.35592980794335444,
        },
        {
          id: "42",
          x: 0.025425372139283954,
          y: 0.20338599607334912,
        },
        {
          id: "83",
          x: 0.24576476458759597,
          y: 0.4576315202142314,
        },
        {
          id: "120",
          x: 0.2033909633420893,
          y: 0.38983109783614567,
        },
        {
          id: "105",
          x: 0.2203404923006949,
          y: 0.4406819962736919,
        },
        {
          id: "134",
          x: 0.19491622001379386,
          y: 0.4745745719322808,
        },
        {
          id: "53",
          x: 0.016949528958605617,
          y: 0.25423465249918314,
        },
        {
          id: "26",
          x: 0.04237490109788957,
          y: 0.22033556231599638,
        },
        {
          id: "114",
          x: 0.2118657489723995,
          y: 0.4406819962736919,
        },
        {
          id: "10",
          x: 0.06779807353240774,
          y: 0.25423465249918314,
        },
        {
          id: "60",
          x: 0.008474764479302808,
          y: 0.2372851074075898,
        },
        {
          id: "95",
          x: 0.22881523562899034,
          y: 0.38983109783614567,
        },
        {
          id: "75",
          x: 0.2542373928151551,
          y: 0.38983109783614567,
        },
        {
          id: "176",
          x: 0.14406875414136724,
          y: 0.3389845988178084,
        },
        {
          id: "130",
          x: 0.19491622001379386,
          y: 0.4067785066712962,
        },
        {
          id: "44",
          x: 0.025425372139283954,
          y: 0.2372851074075898,
        },
        {
          id: "162",
          x: 0.1610182619489655,
          y: 0.35592980794335444,
        },
        {
          id: "107",
          x: 0.2203404923006949,
          y: 0.4745745719322808,
        },
        {
          id: "103",
          x: 0.2203404923006949,
          y: 0.4067785066712962,
        },
        {
          id: "172",
          x: 0.1525445761710382,
          y: 0.38983109783614567,
        },
        {
          id: "33",
          x: 0.033899057917211234,
          y: 0.20338599607334912,
        },
        {
          id: "13",
          x: 0.05932440890548782,
          y: 0.20338599607334912,
        },
        {
          id: "182",
          x: 0.14406875414136724,
          y: 0.4406819962736919,
        },
        {
          id: "7",
          x: 0.06779807353240774,
          y: 0.20338599607334912,
        },
        {
          id: "51",
          x: 0.016949528958605617,
          y: 0.22033556231599638,
        },
        {
          id: "61",
          x: 0.008474764479302808,
          y: 0.25423465249918314,
          radius: 2.3470431359462025,
        },
        {
          id: "188",
          x: 0.13559508951444732,
          y: 0.42372811521605125,
        },
        {
          id: "12",
          x: 0.05932440890548782,
          y: 0.1864364509817558,
        },
        {
          id: "59",
          x: 0.008474764479302808,
          y: 0.22033556231599638,
        },
        {
          id: "102",
          x: 0.2203404923006949,
          y: 0.38983109783614567,
        },
        {
          id: "81",
          x: 0.24576476458759597,
          y: 0.42372811521605125,
        },
        {
          id: "55",
          x: 0.016949528958605617,
          y: 0.28813378498447767,
        },
        {
          id: "62",
          x: 0.008474764479302808,
          y: 0.30508550863462164,
        },
        {
          id: "90",
          x: 0.23728892140691765,
          y: 0.4406819962736919,
          radius: 2.3615326025758687,
        },
        {
          id: "125",
          x: 0.2033909633420893,
          y: 0.4745745719322808,
        },
        {
          id: "129",
          x: 0.19491622001379386,
          y: 0.38983109783614567,
        },
        {
          id: "163",
          x: 0.1610182619489655,
          y: 0.37287941648810946,
        },
        {
          id: "119",
          x: 0.2033909633420893,
          y: 0.37287941648810946,
        },
        {
          id: "136",
          x: 0.1864414766854984,
          y: 0.3389845988178084,
        },
        {
          id: "161",
          x: 0.1610182619489655,
          y: 0.3389845988178084,
        },
        {
          id: "108",
          x: 0.2118657489723995,
          y: 0.3389845988178084,
        },
        {
          id: "185",
          x: 0.13559508951444732,
          y: 0.37287941648810946,
        },
        {
          id: "174",
          x: 0.1525445761710382,
          y: 0.42372811521605125,
        },
        {
          id: "168",
          x: 0.1610182619489655,
          y: 0.4576315202142314,
        },
        {
          id: "63",
          x: 0,
          y: 0.1864364509817558,
          radius: 2.0571830971260807,
        },
        {
          id: "70",
          x: 0.27118687947174597,
          y: 0.37287941648810946,
        },
        {
          id: "173",
          x: 0.1525445761710382,
          y: 0.4067785066712962,
        },
        {
          id: "74",
          x: 0.2627121361434505,
          y: 0.4067785066712962,
        },
        {
          id: "180",
          x: 0.14406875414136724,
          y: 0.4067785066712962,
        },
        {
          id: "191",
          x: 0.12711924633376898,
          y: 0.35592980794335444,
        },
        {
          id: "186",
          x: 0.13559508951444732,
          y: 0.38983109783614567,
        },
        {
          id: "164",
          x: 0.1610182619489655,
          y: 0.38983109783614567,
          radius: 2.424981070867031,
        },
        {
          id: "158",
          x: 0.16949194772689277,
          y: 0.42372811521605125,
        },
        {
          id: "157",
          x: 0.16949194772689277,
          y: 0.4067785066712962,
        },
        {
          id: "155",
          x: 0.16949194772689277,
          y: 0.37287941648810946,
        },
        {
          id: "175",
          x: 0.1525445761710382,
          y: 0.4576315202142314,
        },
        {
          id: "159",
          x: 0.16949194772689277,
          y: 0.4406819962736919,
        },
        {
          id: "171",
          x: 0.1525445761710382,
          y: 0.37287941648810946,
        },
        {
          id: "124",
          x: 0.2033909633420893,
          y: 0.4576315202142314,
        },
        {
          id: "27",
          x: 0.04237490109788957,
          y: 0.2372851074075898,
        },
      ],
    },
    {
      id: "uruguay",
      dots: [
        {
          id: "2",
          x: 0.30508483753657434,
          y: 0.847460545247096,
        },
        {
          id: "1",
          x: 0.3135607230192674,
          y: 0.8644099845834199,
        },
        {
          id: "0",
          x: 0.3135607230192674,
          y: 0.847460545247096,
        },
      ],
      region: "south_america",
    },
    {
      id: "uzbekistan",
      dots: [
        {
          id: "3",
          x: 0.6525445338690236,
          y: 0.4067785066712962,
        },
        {
          id: "2",
          x: 0.6525445338690236,
          y: 0.38983109783614567,
        },
        {
          id: "1",
          x: 0.6610171197945679,
          y: 0.4067785066712962,
        },
        {
          id: "0",
          x: 0.6694941051296439,
          y: 0.38983109783614567,
        },
        {
          id: "4",
          x: 0.6440677177420064,
          y: 0.37287941648810946,
        },
        {
          id: "5",
          x: 0.6440677177420064,
          y: 0.38983109783614567,
        },
        {
          id: "6",
          x: 0.6355951318164621,
          y: 0.37287941648810946,
        },
      ],
      region: "middle_east",
    },
    {
      id: "vanuatu",
      dots: [
        {
          id: "0",
          x: 0.9406777696482707,
          y: 0.7622712915391893,
        },
      ],
      region: "australia",
    },
    {
      id: "venezuela",
      dots: [
        {
          id: "0",
          x: 0.296611151758647,
          y: 0.5932258081436972,
        },
        {
          id: "4",
          x: 0.2881364507323663,
          y: 0.6271270557343807,
        },
        {
          id: "3",
          x: 0.2881364507323663,
          y: 0.6101688175596388,
        },
        {
          id: "2",
          x: 0.2881364507323663,
          y: 0.5932258081436972,
        },
        {
          id: "5",
          x: 0.27966166510205615,
          y: 0.5932258081436972,
        },
        {
          id: "6",
          x: 0.27966166510205615,
          y: 0.6101688175596388,
        },
        {
          id: "7",
          x: 0.27118687947174597,
          y: 0.5932258081436972,
        },
        {
          id: "1",
          x: 0.296611151758647,
          y: 0.6101688175596388,
        },
      ],
      region: "south_america",
    },
    {
      id: "vietnam",
      dots: [
        {
          id: "0",
          x: 0.7796638648068219,
          y: 0.5593288753680071,
        },
        {
          id: "4",
          x: 0.7711868794717459,
          y: 0.5932258081436972,
          color: "#DB4437",
        },
        {
          id: "1",
          x: 0.7796638648068219,
          y: 0.5762740844935532,
          radius: 2.4196968046961986,
          color: "#F4B400",
        },
        {
          id: "3",
          x: 0.7711868794717459,
          y: 0.5423706371932654,
        },
        {
          id: "2",
          x: 0.7711868794717459,
          y: 0.5254297851848204,
        },
      ],
      region: "asia",
    },
    {
      id: "virgin_islands",
      dots: [
        {
          id: "0",
          x: 0.2881364507323663,
          y: 0.5423706371932654,
        },
      ],
      region: "south_america",
    },
    {
      id: "western_sahara",
      dots: [
        {
          id: "1",
          x: 0.44067882719863877,
          y: 0.4915284529899215,
        },
        {
          id: "3",
          x: 0.4322040838703433,
          y: 0.5084715047079709,
        },
        {
          id: "2",
          x: 0.44067882719863877,
          y: 0.5084715047079709,
        },
        {
          id: "0",
          x: 0.44915251297656605,
          y: 0.4915284529899215,
        },
      ],
      region: "africa",
    },
    {
      id: "yemen",
      dots: [
        {
          id: "0",
          x: 0.6186444607034589,
          y: 0.5423706371932654,
        },
        {
          id: "1",
          x: 0.6186444607034589,
          y: 0.5593288753680071,
          color: "#F4B400",
        },
        {
          id: "2",
          x: 0.610171790173885,
          y: 0.5423706371932654,
          color: "#DB4437",
        },
        {
          id: "4",
          x: 0.6016949740468679,
          y: 0.5593288753680071,
        },
        {
          id: "3",
          x: 0.610171790173885,
          y: 0.5593288753680071,
        },
      ],
      region: "middle_east",
    },
    {
      id: "yugoslavia",
      dots: [
        {
          id: "0",
          x: 0.5339011730179475,
          y: 0.37287941648810946,
        },
        {
          id: "1",
          x: 0.5339011730179475,
          y: 0.38983109783614567,
        },
      ],
      region: "europe",
    },
    {
      id: "zambia",
      dots: [
        {
          id: "2",
          x: 0.5593233302041123,
          y: 0.7288136238506728,
        },
        {
          id: "6",
          x: 0.5423748587958749,
          y: 0.7457674626062059,
        },
        {
          id: "5",
          x: 0.5423748587958749,
          y: 0.7288136238506728,
          color: "#2EB67D",
        },
        {
          id: "4",
          x: 0.5508506596745385,
          y: 0.7457674626062059,
        },
        {
          id: "1",
          x: 0.5593233302041123,
          y: 0.7118684147251269,
        },
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.7118684147251269,
        },
        {
          id: "3",
          x: 0.5508506596745385,
          y: 0.7288136238506728,
          color: "#A566FF",
        },
      ],
      region: "africa",
    },
    {
      id: "zimbabwe",
      dots: [
        {
          id: "5",
          x: 0.5593233302041123,
          y: 0.7796665950915004,
        },
        {
          id: "0",
          x: 0.5677948162772738,
          y: 0.7457674626062059,
        },
        {
          id: "1",
          x: 0.5677948162772738,
          y: 0.7627126717317518,
        },
        {
          id: "2",
          x: 0.5677948162772738,
          y: 0.7796665950915004,
        },
        {
          id: "3",
          x: 0.5593233302041123,
          y: 0.7457674626062059,
        },
        {
          id: "6",
          x: 0.5508506596745385,
          y: 0.7627126717317518,
        },
        {
          id: "4",
          x: 0.5593233302041123,
          y: 0.7627126717317518,
        },
      ],
      region: "africa",
    },
  ];

export default getMap;
